{
    "admin-lms": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m23.026 21.435-.619-2.477-1.95-7.436a.617.617 0 0 0-.755-.455l-2.395.641a.61.61 0 0 0-.452-.212h-6.19a.63.63 0 0 0-.62.642v10.267a.63.63 0 0 0 .62.642h6.19a.63.63 0 0 0 .619-.642v-5.134l1.361 5.274a.622.622 0 0 0 .62.475.687.687 0 0 0 .16 0l2.99-.828a.623.623 0 0 0 .378-.301.696.696 0 0 0 .043-.456zm-9.904.353h-1.856v-1.283h1.857v1.283zm0-2.567h-1.856v-3.85h1.857v3.85zm0-5.132h-1.856v-1.284h1.857v1.284zm3.095 7.699H14.36v-1.283h1.857zm0-2.567H14.36v-3.85h1.857zm0-5.132H14.36v-1.284h1.857zm1.393-1.117 1.795-.5.322 1.238-1.795.5zm1.603 6.198-.96-3.721 1.796-.5.96 3.72zm.62 2.477-.323-1.239 1.795-.5.322 1.238-1.795.5z"
            },
            {
                "d": "M8.046 1.045c2.416 0 4.375 1.975 4.375 4.412 0 1.26-.543 2.458-1.488 3.282a6.995 6.995 0 0 1 2.403 1.806h-2.72a5.192 5.192 0 0 0-2.57-.676c-2.9 0-5.25 2.37-5.25 5.294 0 .487-.392.882-.875.882s-.875-.395-.875-.882a7.062 7.062 0 0 1 4.112-6.424A4.357 4.357 0 0 1 3.67 5.457c0-2.437 1.959-4.412 4.375-4.412zm0 1.765c-1.45 0-2.625 1.185-2.625 2.647s1.175 2.647 2.625 2.647a2.62 2.62 0 0 0 1.856-.775c.492-.497.769-1.17.769-1.872A2.636 2.636 0 0 0 8.046 2.81z"
            }
        ]
    },
    "admin": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8 1c2.416 0 4.375 1.975 4.375 4.412 0 1.26-.543 2.458-1.488 3.282a6.993 6.993 0 0 1 2.264 1.65l-.826 1.772A5.232 5.232 0 0 0 8 9.824c-2.9 0-5.25 2.37-5.25 5.294a.879.879 0 0 1-.875.882.879.879 0 0 1-.875-.882 7.062 7.062 0 0 1 4.112-6.424 4.357 4.357 0 0 1-1.487-3.282C3.625 2.975 5.584 1 8 1Zm0 1.765a2.636 2.636 0 0 0-2.625 2.647A2.636 2.636 0 0 0 8 8.059a2.62 2.62 0 0 0 1.856-.775c.492-.497.769-1.17.769-1.872A2.636 2.636 0 0 0 8 2.765Z"
            },
            {
                "d": "M16.7 10c1.11 0 2.018.84 2.095 1.906l.005.147v.684h2.1c1.11 0 2.018.84 2.095 1.906l.005.146v6.158c0 1.085-.86 1.973-1.95 2.048L20.9 23h-9.8c-1.11 0-2.018-.84-2.095-1.906L9 20.947V14.79c0-.544.221-1.066.615-1.451a2.12 2.12 0 0 1 1.3-.593l.185-.008h2.1v-.684c0-1.085.86-1.973 1.95-2.048L15.3 10h1.4Zm4.9 7.184a15.29 15.29 0 0 1-1.672.54l-.428.103v.404a.692.692 0 0 1-.7.684.695.695 0 0 1-.694-.591l-.006-.093v-.144a16.39 16.39 0 0 1-2.1.144 16.468 16.468 0 0 1-1.577-.083l-.523-.06v.143a.692.692 0 0 1-.7.684.695.695 0 0 1-.694-.591l-.006-.093v-.404a15.15 15.15 0 0 1-1.688-.49l-.412-.153v3.763a.69.69 0 0 0 .605.678l.095.007h9.8a.695.695 0 0 0 .694-.592l.006-.093v-3.763Zm-.7-3.079h-9.8a.695.695 0 0 0-.694.592l-.006.092v.91c.545.225 1.103.417 1.672.573l.428.112v-.226c0-.378.313-.684.7-.684.354 0 .647.257.694.591l.006.093v.506c1.237.183 2.494.203 3.735.061l.465-.06v-.507c0-.378.313-.684.7-.684.354 0 .647.257.694.591l.006.093v.212a14.53 14.53 0 0 0 1.689-.522l.411-.162v-.897a.692.692 0 0 0-.7-.684Zm-4.2-2.737h-1.4c-.387 0-.7.307-.7.685v.684h2.8v-.684a.692.692 0 0 0-.7-.685Z"
            }
        ]
    },
    "align-center": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm4 2a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2H7Zm14 4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Zm-4 4H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "align-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm0 4h14a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm18 2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Zm-4 4H3a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "align-right": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm18 10H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2Zm0-8H7a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2Zm0 4H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "align": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 15h10a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2Zm0-4h10a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm0-4h18a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm18 10H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Zm-1.36-7.43a1 1 0 1 0-1.28 1.53l1.08.9-1.08.9a1 1 0 0 0 .64 1.77 1 1 0 0 0 .64-.24l2-1.66a1 1 0 0 0 0-1.54l-2-1.66Z"
            }
        ]
    },
    "angle-double-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.716 8.296a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 0 1.42l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.3-2.29 2.3-2.29a1 1 0 0 0 0-1.42Zm3.2 3.71 2.34-2.29a1.004 1.004 0 1 0-1.42-1.42l-3 3a1 1 0 0 0 0 1.42l3 3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.34-2.29Z"
            },
            {
                "d": "m14.764 12.006 2.44-2.29a.975.975 0 0 0 0-1.42 1.078 1.078 0 0 0-1.481 0l-3.128 3a.98.98 0 0 0-.308.71.98.98 0 0 0 .308.71l3.128 3c.196.19.462.296.74.296.278 0 .544-.107.74-.296a.98.98 0 0 0 .309-.71.98.98 0 0 0-.309-.71l-2.44-2.29Z"
            }
        ]
    },
    "angle-double-right": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7.295 15.716a.997.997 0 0 0 1.417 0l2.993-3a1.001 1.001 0 0 0 0-1.42l-2.993-3a.997.997 0 0 0-1.417 0 1.001 1.001 0 0 0 0 1.42l2.295 2.29-2.295 2.29a1.001 1.001 0 0 0 0 1.42Zm6 0a.997.997 0 0 0 1.417 0l2.993-3a1.001 1.001 0 0 0 0-1.42l-2.993-3a.997.997 0 0 0-1.417 0 1.001 1.001 0 0 0 0 1.42l2.295 2.29-2.295 2.29a1.001 1.001 0 0 0 0 1.42Z"
            }
        ]
    },
    "angle-down": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42Z"
            }
        ]
    },
    "angle-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6 0-.1 0-.1 0 0Z"
            }
        ]
    },
    "angle-right": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15.54 11.29 9.88 5.64a1 1 0 1 0-1.42 1.41l4.95 5L8.46 17a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l5.66-5.65a1 1 0 0 0 0-1.47Z"
            }
        ]
    },
    "angle-up": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m17 13.41-4.29-4.24a1 1 0 0 0-1.42 0l-4.24 4.24a1 1 0 1 0 1.41 1.42L12 11.29l3.54 3.54a1 1 0 0 0 1.41 0 1 1 0 0 0 .05-1.42Z"
            }
        ]
    },
    "app": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m13.362 17.148-.182-.144a.927.927 0 0 0-.219-.108l-.218-.096c-.4-.083-.815.04-1.105.324a1.37 1.37 0 0 0-.255.396 1.19 1.19 0 0 0 .26 1.306c.344.343.865.448 1.318.266.146-.07.28-.158.401-.264a1.19 1.19 0 0 0 .255-1.308 1.2 1.2 0 0 0-.255-.372Z"
            },
            {
                "d": "M17.357 0C19.37 0 21 1.612 21 3.6v16.8c0 1.988-1.631 3.6-3.643 3.6H7.643C5.63 24 4 22.388 4 20.4V3.6C4 1.612 5.631 0 7.643 0Zm0 2.4H7.643c-.67 0-1.214.537-1.214 1.2v16.8c0 .663.543 1.2 1.214 1.2h9.714c.67 0 1.214-.537 1.214-1.2V3.6c0-.663-.543-1.2-1.214-1.2Z"
            },
            {
                "d": "M8.683 6.983a2.818 2.818 0 0 1 3.824-.424 2.827 2.827 0 0 1 3.672 4.276l-2.795 2.805a1.25 1.25 0 0 1-1.755 0l-2.795-2.805a2.832 2.832 0 0 1-.15-3.852Zm3.542.746a1.535 1.535 0 0 0-2.264 0 1.825 1.825 0 0 0 0 2.426l2.343 2.523a.277.277 0 0 0 .203.091c.077 0 .15-.033.204-.09l2.342-2.512v-.012a1.825 1.825 0 0 0-.03-2.426 1.535 1.535 0 0 0-2.263 0 .365.365 0 0 1-.268.12.365.365 0 0 1-.267-.12Z"
            }
        ]
    },
    "approved": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm3.074 7.338-3.788 3.885-1.36-1.402a1.11 1.11 0 0 0-1.595 0 1.172 1.172 0 0 0 0 1.632l2.157 2.207a1.11 1.11 0 0 0 1.596 0l4.585-4.69a1.172 1.172 0 0 0 0-1.632 1.11 1.11 0 0 0-1.595 0Z"
            }
        ]
    },
    "apps": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10 13a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1Zm-1 2H4v5h5v-5ZM21 2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm-1 2h-5v5h5V4Zm1 9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1Zm-1 2h-5v5h5v-5ZM10 2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1ZM9 4H4v5h5V4Z"
            }
        ]
    },
    "arrow-block": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm-1.32 5.001L9.5 8.181l3.84 3.82-3.84 3.84 1.18 1.16 5-5-5-5Z"
            }
        ]
    },
    "arrow-bottom": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.29 17.71a1 1 0 0 0 .33.21 1 1 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1.004 1.004 0 0 0-1.42-1.42L13 14.59V3a1 1 0 1 0-2 0v11.59l-2.29-2.3a1 1 0 0 0-1.42 0 1 1 0 0 0 0 1.42ZM5 22h14a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2Z"
            }
        ]
    },
    "arrow-from-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 11H5.41l2.3-2.29a1.004 1.004 0 1 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.41 13H17a1 1 0 0 0 0-2Zm4-7a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "arrow-from-right": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 4a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V5a1 1 0 0 0-1-1Zm18.92 7.62a1 1 0 0 0-.21-.33l-4-4a1.004 1.004 0 0 0-1.42 1.42l2.3 2.29H7a1 1 0 0 0 0 2h11.59l-2.3 2.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76Z"
            }
        ]
    },
    "arrow-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19.494 10.5H8.108l4.95-4.93a1.504 1.504 0 0 0 0-2.13 1.507 1.507 0 0 0-2.13 0l-7.5 7.495a1.492 1.492 0 0 0-.315.495 1.5 1.5 0 0 0 0 1.14c.07.183.178.351.315.494l7.5 7.494a1.5 1.5 0 0 0 2.13 0 1.498 1.498 0 0 0 0-2.128l-4.95-4.931h11.386a1.5 1.5 0 1 0 0-2.998Z"
            }
        ]
    },
    "arrow-right-thin": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.92 11.62a1 1 0 0 0-.21-.33l-5-5a1.004 1.004 0 1 0-1.42 1.42l3.3 3.29H7a1 1 0 0 0 0 2h7.59l-3.3 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l5-5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76Z"
            }
        ]
    },
    "arrow-right": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M20.88 11.43a1.499 1.499 0 0 0-.315-.495l-7.5-7.494a1.507 1.507 0 0 0-2.52.674c-.14.52.01 1.074.39 1.454l4.95 4.931H4.5a1.5 1.5 0 1 0 0 2.998h11.385l-4.95 4.93a1.498 1.498 0 0 0 0 2.129 1.5 1.5 0 0 0 2.13 0l7.5-7.494c.137-.143.244-.31.315-.495.15-.365.15-.774 0-1.139Z"
            }
        ]
    },
    "arrow-shrink": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13.79 10.21a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2.5-2.5a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.5 2.5a1.004 1.004 0 0 0 1.42 1.42l.79-.8v5.18l-.79-.8a1.004 1.004 0 1 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2.5-2.5a1.004 1.004 0 1 0-1.42-1.42l-.79.8V9.41l.79.8ZM7 4h10a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2Zm10 16H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "arrow-top": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.71 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1.004 1.004 0 1 0 1.42 1.42L11 9.41V21a1 1 0 0 0 2 0V9.41l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-4-4ZM19 2H5a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "arrow-up-right": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.92 6.62a1 1 0 0 0-.54-.54A1 1 0 0 0 18 6H8a1 1 0 1 0 0 2h7.59l-8.3 8.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L17 9.41V17a1 1 0 0 0 2 0V7a1 1 0 0 0-.08-.38Z"
            }
        ]
    },
    "arrows-right-down": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M20.92 6.62a1 1 0 0 0-.21-.33l-3-3a1.004 1.004 0 0 0-1.42 1.42L17.59 6H9a3 3 0 0 0-3 3v8.59l-1.29-1.3a1.004 1.004 0 1 0-1.42 1.42l3 3a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l3-3a1.004 1.004 0 0 0-1.42-1.42L8 17.59V9a1 1 0 0 1 1-1h8.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76Z"
            }
        ]
    },
    "arrows-shrink-h": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m17.71 11.29-2.5-2.5a1.004 1.004 0 0 0-1.42 1.42l.8.79H9.41l.8-.79a1.004 1.004 0 0 0-1.42-1.42l-2.5 2.5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2.5 2.5a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.8-.79h5.18l-.8.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l2.5-2.5a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33ZM3 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1Zm18 0a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "asincro": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M5.5 3C4.292 3 3.312 4.037 3.312 5.316c0 .662.272 1.29.745 1.723C2.806 7.64 2 8.96 2 10.412a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463c0-1.535 1.175-2.78 2.625-2.78s2.625 1.245 2.625 2.78a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463C8.999 8.958 8.194 7.64 6.943 7.04a2.337 2.337 0 0 0 .745-1.723C7.688 4.037 6.707 3 5.5 3zm0 .926c.725 0 1.313.623 1.313 1.39 0 .369-.14.722-.385.983-.246.26-.58.406-.928.406-.725 0-1.313-.621-1.313-1.389 0-.767.588-1.39 1.313-1.39zM20.996 6.01a.6.6 0 0 0-.426 1.027l.38.373h-5.948a.6.6 0 0 0 0 1.2h5.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176zM5.5 14c-1.208 0-2.188 1.037-2.188 2.316 0 .662.272 1.29.745 1.723C2.806 18.64 2 19.96 2 21.412a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463c0-1.535 1.175-2.78 2.625-2.78s2.625 1.245 2.625 2.78a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463c-.001-1.454-.806-2.773-2.057-3.373a2.337 2.337 0 0 0 .745-1.723C7.688 15.037 6.707 14 5.5 14zm0 .926c.725 0 1.313.623 1.313 1.39 0 .369-.14.722-.385.983-.246.26-.58.406-.928.406-.725 0-1.313-.621-1.313-1.389 0-.767.588-1.39 1.313-1.39zm11.496.084a.6.6 0 0 0-.426 1.027l.38.373h-5.948a.6.6 0 0 0 0 1.2h5.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176z"
            }
        ]
    },
    "asterisk": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m15.579 13.503 3.053 5.079-2.685 1.918L12 15.991 8 20.5l-2.684-1.918 3.052-5.079L3 11.171l1-3.11 5.737 1.296.579-5.857h3.316l.579 5.857L20 8.06l1 3.11z"
            }
        ]
    },
    "audio-doc": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.2 1.5c.188 0 .368.057.5.159l3.843 3.522a.487.487 0 0 1 .207.383v16.395c0 .299-.316.541-.706.541H2.956c-.39 0-.706-.242-.706-.541V2.04c0-.299.316-.541.706-.541Zm-1.69 8.25a.435.435 0 0 0-.324.126l-.058.056a.42.42 0 0 0-.017.587 4.5 4.5 0 0 1 1.177 3.03c0 1.073-.39 2.118-1.1 2.94a.42.42 0 0 0 .026.58l.057.055a.446.446 0 0 0 .311.126h.019a.443.443 0 0 0 .317-.152 5.43 5.43 0 0 0 1.332-3.55c0-1.35-.506-2.647-1.424-3.654a.443.443 0 0 0-.316-.144Zm-3.785.046a.468.468 0 0 0-.506.066l-2.604 2.19H7.227a.481.481 0 0 0-.477.485v1.927a.48.48 0 0 0 .477.483h1.388l2.604 2.192a.47.47 0 0 0 .506.065.483.483 0 0 0 .275-.438v-6.532a.485.485 0 0 0-.275-.438Zm2.254 1.455a.385.385 0 0 0-.306.124l-.055.057a.437.437 0 0 0-.027.566c.343.444.525.98.525 1.552 0 .532-.16 1.04-.463 1.467a.439.439 0 0 0 .038.552l.055.057c.076.08.18.124.286.124l.03-.001a.398.398 0 0 0 .294-.169c.422-.59.644-1.293.644-2.03 0-.792-.252-1.534-.728-2.144a.4.4 0 0 0-.293-.155ZM16.5 3v3.46a.29.29 0 0 0 .29.29h3.46L16.5 3Z"
            }
        ]
    },
    "award-hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.004 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM5.268 13.316 3.135 17a1 1 0 0 0 .869 1.5h2.869l1.461 2.46c.05.082.11.155.18.22a1 1 0 0 0 .69.28h.14a.992.992 0 0 0 .73-.49l1.93-3.32 1.93 3.35a1 1 0 0 0 .73.48h.14a1 1 0 0 0 .7-.28.864.864 0 0 0 .17-.21l1.46-2.46h2.87c.359 0 .69-.19.869-.5a.999.999 0 0 0 0-1.03l-2.133-3.684A7.994 7.994 0 0 1 12.004 17a7.992 7.992 0 0 1-6.736-3.684z"
            }
        ]
    },
    "award": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2.25a7 7 0 0 1 6.16 10.32l2.71 4.68a1 1 0 0 1 0 1.03 1 1 0 0 1-.87.5h-2.87l-1.46 2.46a.87.87 0 0 1-.17.21 1 1 0 0 1-.7.28h-.14a1 1 0 0 1-.73-.48L12 17.9l-1.93 3.32a1 1 0 0 1-.73.49H9.2a1 1 0 0 1-.69-.28 1 1 0 0 1-.18-.22l-1.46-2.46H4a1 1 0 0 1-.87-1.5l2.71-4.68A7 7 0 0 1 12 2.25Zm4.85 12.04a7.06 7.06 0 0 1-3.56 1.84l1.52 2.65.89-1.49a1 1 0 0 1 .85-.49l1.73-.03Zm-9.7.03L5.72 16.8h1.73a1 1 0 0 1 .85.49l.89 1.49 1.53-2.62a7 7 0 0 1-3.57-1.84ZM12 4.25a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
            }
        ]
    },
    "boat": {
        "width": 2960,
        "height": 1024,
        "paths": [
            {
                "d": "M16 0v1024"
            },
            {
                "d": "M32 0v1024"
            },
            {
                "d": "M48 0v1024"
            },
            {
                "d": "M64 0v1024"
            },
            {
                "d": "M80 0v1024"
            },
            {
                "d": "M96 0v1024"
            },
            {
                "d": "M112 0v1024"
            },
            {
                "d": "M128 0v1024"
            },
            {
                "d": "M144 0v1024"
            },
            {
                "d": "M160 0v1024"
            },
            {
                "d": "M176 0v1024"
            },
            {
                "d": "M192 0v1024"
            },
            {
                "d": "M208 0v1024"
            },
            {
                "d": "M224 0v1024"
            },
            {
                "d": "M240 0v1024"
            },
            {
                "d": "M256 0v1024"
            },
            {
                "d": "M272 0v1024"
            },
            {
                "d": "M288 0v1024"
            },
            {
                "d": "M304 0v1024"
            },
            {
                "d": "M320 0v1024"
            },
            {
                "d": "M336 0v1024"
            },
            {
                "d": "M352 0v1024"
            },
            {
                "d": "M368 0v1024"
            },
            {
                "d": "M384 0v1024"
            },
            {
                "d": "M400 0v1024"
            },
            {
                "d": "M416 0v1024"
            },
            {
                "d": "M432 0v1024"
            },
            {
                "d": "M448 0v1024"
            },
            {
                "d": "M464 0v1024"
            },
            {
                "d": "M480 0v1024"
            },
            {
                "d": "M496 0v1024"
            },
            {
                "d": "M512 0v1024"
            },
            {
                "d": "M528 0v1024"
            },
            {
                "d": "M544 0v1024"
            },
            {
                "d": "M560 0v1024"
            },
            {
                "d": "M576 0v1024"
            },
            {
                "d": "M592 0v1024"
            },
            {
                "d": "M608 0v1024"
            },
            {
                "d": "M624 0v1024"
            },
            {
                "d": "M640 0v1024"
            },
            {
                "d": "M656 0v1024"
            },
            {
                "d": "M672 0v1024"
            },
            {
                "d": "M688 0v1024"
            },
            {
                "d": "M704 0v1024"
            },
            {
                "d": "M720 0v1024"
            },
            {
                "d": "M736 0v1024"
            },
            {
                "d": "M752 0v1024"
            },
            {
                "d": "M768 0v1024"
            },
            {
                "d": "M784 0v1024"
            },
            {
                "d": "M800 0v1024"
            },
            {
                "d": "M816 0v1024"
            },
            {
                "d": "M832 0v1024"
            },
            {
                "d": "M848 0v1024"
            },
            {
                "d": "M864 0v1024"
            },
            {
                "d": "M880 0v1024"
            },
            {
                "d": "M896 0v1024"
            },
            {
                "d": "M912 0v1024"
            },
            {
                "d": "M928 0v1024"
            },
            {
                "d": "M944 0v1024"
            },
            {
                "d": "M960 0v1024"
            },
            {
                "d": "M976 0v1024"
            },
            {
                "d": "M992 0v1024"
            },
            {
                "d": "M1008 0v1024"
            },
            {
                "d": "M1024 0v1024"
            },
            {
                "d": "M1040 0v1024"
            },
            {
                "d": "M1056 0v1024"
            },
            {
                "d": "M1072 0v1024"
            },
            {
                "d": "M1088 0v1024"
            },
            {
                "d": "M1104 0v1024"
            },
            {
                "d": "M1120 0v1024"
            },
            {
                "d": "M1136 0v1024"
            },
            {
                "d": "M1152 0v1024"
            },
            {
                "d": "M1168 0v1024"
            },
            {
                "d": "M1184 0v1024"
            },
            {
                "d": "M1200 0v1024"
            },
            {
                "d": "M1216 0v1024"
            },
            {
                "d": "M1232 0v1024"
            },
            {
                "d": "M1248 0v1024"
            },
            {
                "d": "M1264 0v1024"
            },
            {
                "d": "M1280 0v1024"
            },
            {
                "d": "M1296 0v1024"
            },
            {
                "d": "M1312 0v1024"
            },
            {
                "d": "M1328 0v1024"
            },
            {
                "d": "M1344 0v1024"
            },
            {
                "d": "M1360 0v1024"
            },
            {
                "d": "M1376 0v1024"
            },
            {
                "d": "M1392 0v1024"
            },
            {
                "d": "M1408 0v1024"
            },
            {
                "d": "M1424 0v1024"
            },
            {
                "d": "M1440 0v1024"
            },
            {
                "d": "M1456 0v1024"
            },
            {
                "d": "M1472 0v1024"
            },
            {
                "d": "M1488 0v1024"
            },
            {
                "d": "M1504 0v1024"
            },
            {
                "d": "M1520 0v1024"
            },
            {
                "d": "M1536 0v1024"
            },
            {
                "d": "M1552 0v1024"
            },
            {
                "d": "M1568 0v1024"
            },
            {
                "d": "M1584 0v1024"
            },
            {
                "d": "M1600 0v1024"
            },
            {
                "d": "M1616 0v1024"
            },
            {
                "d": "M1632 0v1024"
            },
            {
                "d": "M1648 0v1024"
            },
            {
                "d": "M1664 0v1024"
            },
            {
                "d": "M1680 0v1024"
            },
            {
                "d": "M1696 0v1024"
            },
            {
                "d": "M1712 0v1024"
            },
            {
                "d": "M1728 0v1024"
            },
            {
                "d": "M1744 0v1024"
            },
            {
                "d": "M1760 0v1024"
            },
            {
                "d": "M1776 0v1024"
            },
            {
                "d": "M1792 0v1024"
            },
            {
                "d": "M1808 0v1024"
            },
            {
                "d": "M1824 0v1024"
            },
            {
                "d": "M1840 0v1024"
            },
            {
                "d": "M1856 0v1024"
            },
            {
                "d": "M1872 0v1024"
            },
            {
                "d": "M1888 0v1024"
            },
            {
                "d": "M1904 0v1024"
            },
            {
                "d": "M1920 0v1024"
            },
            {
                "d": "M1936 0v1024"
            },
            {
                "d": "M1952 0v1024"
            },
            {
                "d": "M1968 0v1024"
            },
            {
                "d": "M1984 0v1024"
            },
            {
                "d": "M2000 0v1024"
            },
            {
                "d": "M2016 0v1024"
            },
            {
                "d": "M2032 0v1024"
            },
            {
                "d": "M2048 0v1024"
            },
            {
                "d": "M2064 0v1024"
            },
            {
                "d": "M2080 0v1024"
            },
            {
                "d": "M2096 0v1024"
            },
            {
                "d": "M2112 0v1024"
            },
            {
                "d": "M2128 0v1024"
            },
            {
                "d": "M2144 0v1024"
            },
            {
                "d": "M2160 0v1024"
            },
            {
                "d": "M2176 0v1024"
            },
            {
                "d": "M2192 0v1024"
            },
            {
                "d": "M2208 0v1024"
            },
            {
                "d": "M2224 0v1024"
            },
            {
                "d": "M2240 0v1024"
            },
            {
                "d": "M2256 0v1024"
            },
            {
                "d": "M2272 0v1024"
            },
            {
                "d": "M2288 0v1024"
            },
            {
                "d": "M2304 0v1024"
            },
            {
                "d": "M2320 0v1024"
            },
            {
                "d": "M2336 0v1024"
            },
            {
                "d": "M2352 0v1024"
            },
            {
                "d": "M2368 0v1024"
            },
            {
                "d": "M2384 0v1024"
            },
            {
                "d": "M2400 0v1024"
            },
            {
                "d": "M2416 0v1024"
            },
            {
                "d": "M2432 0v1024"
            },
            {
                "d": "M2448 0v1024"
            },
            {
                "d": "M2464 0v1024"
            },
            {
                "d": "M2480 0v1024"
            },
            {
                "d": "M2496 0v1024"
            },
            {
                "d": "M2512 0v1024"
            },
            {
                "d": "M2528 0v1024"
            },
            {
                "d": "M2544 0v1024"
            },
            {
                "d": "M2560 0v1024"
            },
            {
                "d": "M2576 0v1024"
            },
            {
                "d": "M2592 0v1024"
            },
            {
                "d": "M2608 0v1024"
            },
            {
                "d": "M2624 0v1024"
            },
            {
                "d": "M2640 0v1024"
            },
            {
                "d": "M2656 0v1024"
            },
            {
                "d": "M2672 0v1024"
            },
            {
                "d": "M2688 0v1024"
            },
            {
                "d": "M2704 0v1024"
            },
            {
                "d": "M2720 0v1024"
            },
            {
                "d": "M2736 0v1024"
            },
            {
                "d": "M2752 0v1024"
            },
            {
                "d": "M2768 0v1024"
            },
            {
                "d": "M2784 0v1024"
            },
            {
                "d": "M2800 0v1024"
            },
            {
                "d": "M2816 0v1024"
            },
            {
                "d": "M2832 0v1024"
            },
            {
                "d": "M2848 0v1024"
            },
            {
                "d": "M2864 0v1024"
            },
            {
                "d": "M2880 0v1024"
            },
            {
                "d": "M2896 0v1024"
            },
            {
                "d": "M2912 0v1024"
            },
            {
                "d": "M2928 0v1024"
            },
            {
                "d": "M2944 0v1024"
            },
            {
                "d": "M0 16h2960"
            },
            {
                "d": "M0 32h2960"
            },
            {
                "d": "M0 48h2960"
            },
            {
                "d": "M0 64h2960"
            },
            {
                "d": "M0 80h2960"
            },
            {
                "d": "M0 96h2960"
            },
            {
                "d": "M0 112h2960"
            },
            {
                "d": "M0 128h2960"
            },
            {
                "d": "M0 144h2960"
            },
            {
                "d": "M0 160h2960"
            },
            {
                "d": "M0 176h2960"
            },
            {
                "d": "M0 192h2960"
            },
            {
                "d": "M0 208h2960"
            },
            {
                "d": "M0 224h2960"
            },
            {
                "d": "M0 240h2960"
            },
            {
                "d": "M0 256h2960"
            },
            {
                "d": "M0 272h2960"
            },
            {
                "d": "M0 288h2960"
            },
            {
                "d": "M0 304h2960"
            },
            {
                "d": "M0 320h2960"
            },
            {
                "d": "M0 336h2960"
            },
            {
                "d": "M0 352h2960"
            },
            {
                "d": "M0 368h2960"
            },
            {
                "d": "M0 384h2960"
            },
            {
                "d": "M0 400h2960"
            },
            {
                "d": "M0 416h2960"
            },
            {
                "d": "M0 432h2960"
            },
            {
                "d": "M0 448h2960"
            },
            {
                "d": "M0 464h2960"
            },
            {
                "d": "M0 480h2960"
            },
            {
                "d": "M0 496h2960"
            },
            {
                "d": "M0 512h2960"
            },
            {
                "d": "M0 528h2960"
            },
            {
                "d": "M0 544h2960"
            },
            {
                "d": "M0 560h2960"
            },
            {
                "d": "M0 576h2960"
            },
            {
                "d": "M0 592h2960"
            },
            {
                "d": "M0 608h2960"
            },
            {
                "d": "M0 624h2960"
            },
            {
                "d": "M0 640h2960"
            },
            {
                "d": "M0 656h2960"
            },
            {
                "d": "M0 672h2960"
            },
            {
                "d": "M0 688h2960"
            },
            {
                "d": "M0 704h2960"
            },
            {
                "d": "M0 720h2960"
            },
            {
                "d": "M0 736h2960"
            },
            {
                "d": "M0 752h2960"
            },
            {
                "d": "M0 768h2960"
            },
            {
                "d": "M0 784h2960"
            },
            {
                "d": "M0 800h2960"
            },
            {
                "d": "M0 816h2960"
            },
            {
                "d": "M0 832h2960"
            },
            {
                "d": "M0 848h2960"
            },
            {
                "d": "M0 864h2960"
            },
            {
                "d": "M0 880h2960"
            },
            {
                "d": "M0 896h2960"
            },
            {
                "d": "M0 912h2960"
            },
            {
                "d": "M0 928h2960"
            },
            {
                "d": "M0 944h2960"
            },
            {
                "d": "M0 960h2960"
            },
            {
                "d": "M0 976h2960"
            },
            {
                "d": "M0 992h2960"
            },
            {
                "d": "M0 1008h2960"
            },
            {
                "d": "M169.996 900.482h14.801c8.729 5.693 17.711 10.88 25.933 17.078 35.548 27.072 76.788 26.692 111.197-.885 7.843-6.325 17.204-10.88 25.807-16.192h13.283c8.603 5.44 17.711 10.12 25.68 16.445 35.168 27.704 76.534 27.704 111.829 0 8.096-6.325 17.204-11.005 25.807-16.445h13.283c7.843 4.68 16.699 8.349 23.529 14.295 35.041 29.601 77.673 30.613 114.106 2.404 7.969-6.199 16.952-11.132 25.427-16.699h14.801c6.452 3.668 13.789 6.579 19.228 11.385 18.216 15.813 38.584 25.553 63.125 26.313 8.981.253 15.94 4.175 19.988 12.397 1.392 2.783 2.909 5.567 4.301 8.223v11.639c-6.705 16.445-19.735 20.62-36.433 18.723-21.632-2.531-41.873-8.855-60.342-20.367-5.945-3.668-11.765-7.843-17.078-11.385-59.584 43.137-118.407 42.758-177.104 0-59.33 43.137-118.407 42.885-176.978 0-59.33 43.012-118.154 42.885-177.231-.127-1.265 1.012-2.783 1.897-4.048 2.909-21 15.94-44.656 25.553-70.969 28.716-20.747 2.656-29.222-1.139-38.71-18.469v-11.639c5.187-15.307 16.066-21.379 32.385-21.759 18.596-.38 34.282-9.235 48.83-20.114 8.096-5.945 16.952-11.005 25.553-16.445zm2049.355 0h14.801c8.729 5.693 17.711 10.88 25.933 17.078 35.548 27.072 76.788 26.692 111.197-.885 7.843-6.325 17.204-10.88 25.807-16.192h13.283c8.603 5.44 17.711 10.12 25.68 16.445 35.168 27.704 76.534 27.704 111.829 0 8.096-6.325 17.204-11.005 25.807-16.445h13.283c7.843 4.68 16.699 8.349 23.529 14.295 35.041 29.601 77.673 30.613 114.106 2.404 7.969-6.199 16.952-11.132 25.427-16.699h14.801c6.452 3.668 13.789 6.579 19.228 11.385 18.216 15.813 38.584 25.553 63.125 26.313 8.981.253 15.94 4.175 19.988 12.397 1.392 2.783 2.909 5.567 4.301 8.223v11.639c-6.705 16.445-19.735 20.62-36.433 18.723-21.632-2.531-41.873-8.855-60.342-20.367-5.945-3.668-11.765-7.843-17.078-11.385-59.584 43.137-118.407 42.758-177.104 0-59.33 43.137-118.407 42.885-176.978 0-59.33 43.012-118.154 42.885-177.231-.127-1.265 1.012-2.783 1.897-4.048 2.909-21 15.94-44.656 25.553-70.969 28.716-20.747 2.656-29.222-1.139-38.71-18.469v-11.639c5.187-15.307 16.066-21.379 32.385-21.759 18.596-.38 34.282-9.235 48.83-20.114 8.096-5.945 16.952-11.005 25.553-16.445zM106.745 736.027h14.801c8.729 5.693 17.711 10.88 25.933 17.078 35.548 27.072 76.788 26.692 111.197-.885 7.843-6.325 17.204-10.88 25.807-16.192h13.283c8.603 5.44 17.711 10.12 25.68 16.445 35.168 27.704 76.534 27.704 111.829 0 8.096-6.325 17.204-11.005 25.807-16.445h13.283c7.843 4.68 16.699 8.349 23.529 14.295 35.041 29.601 77.673 30.613 114.106 2.404 7.969-6.199 16.952-11.132 25.427-16.699h14.801c6.452 3.668 13.789 6.579 19.228 11.385 18.216 15.813 38.584 25.553 63.125 26.313 8.981.253 15.94 4.175 19.988 12.397 1.392 2.783 2.909 5.567 4.301 8.223v11.639c-6.705 16.445-19.735 20.62-36.433 18.723-21.632-2.531-41.873-8.855-60.342-20.367-5.945-3.668-11.765-7.843-17.078-11.385-59.584 43.137-118.407 42.758-177.104 0-59.33 43.137-118.407 42.885-176.978 0-59.33 43.012-118.154 42.885-177.231-.127-1.265 1.012-2.783 1.897-4.048 2.909-21 15.94-44.656 25.553-70.969 28.716-20.747 2.656-29.222-1.139-38.71-18.469v-11.639c5.187-15.307 16.066-21.379 32.385-21.759 18.596-.38 34.282-9.235 48.83-20.114 8.096-5.945 16.952-11.005 25.553-16.445zm2201.158-12.649h14.801c8.729 5.693 17.711 10.88 25.933 17.078 35.548 27.072 76.788 26.692 111.197-.885 7.843-6.325 17.204-10.88 25.807-16.192h13.283c8.603 5.44 17.711 10.12 25.68 16.445 35.168 27.704 76.534 27.704 111.829 0 8.096-6.325 17.204-11.005 25.807-16.445h13.283c7.843 4.68 16.699 8.349 23.529 14.295 35.041 29.601 77.673 30.613 114.106 2.404 7.969-6.199 16.952-11.132 25.427-16.699h14.801c6.452 3.668 13.789 6.579 19.228 11.385 18.216 15.813 38.584 25.553 63.125 26.313 8.981.253 15.94 4.175 19.988 12.397 1.392 2.783 2.909 5.567 4.301 8.223v11.639c-6.705 16.445-19.735 20.62-36.433 18.723-21.632-2.531-41.873-8.855-60.342-20.367-5.945-3.668-11.765-7.843-17.078-11.385-59.584 43.137-118.407 42.758-177.104 0-59.33 43.137-118.407 42.885-176.978 0-59.33 43.012-118.154 42.885-177.231-.127-1.265 1.012-2.783 1.897-4.048 2.909-21 15.94-44.656 25.553-70.969 28.716-20.747 2.656-29.222-1.139-38.71-18.469v-11.639c5.187-15.307 16.066-21.379 32.385-21.759 18.596-.38 34.282-9.235 48.83-20.114 8.096-5.945 16.952-11.005 25.553-16.445zm-806.916-571.074.611-.04c-.887-4.303-1.392-8.723-2.765-12.878-1.628-4.929-4.646-9.169-9.004-12.447-5.938-4.467-12.768-5.817-20.107-5.702-10.826.17-18.858 4.834-24.343 13.7-1.541 2.491-2.964 5.066-4.708 7.42-3.526 4.761-6.476 5.044-9.817 1.012-3.099-3.739-5.704-7.852-8.654-11.709-3.856-5.04-8.863-8.598-15.266-10.098-4.231-.992-8.527-1.168-12.872-.632-10.144 1.249-17.838 5.962-21.474 15.245-4.842 12.366-3.479 24.461 3.597 35.827 4.8 7.712 10.635 14.689 17.326 20.97 5.931 5.569 11.761 11.275 18.087 16.408 5.519 4.478 11.608 8.327 17.573 12.275 2.287 1.513 4.854 3.068 7.839 2.384 2.305-.529 4.58-1.379 6.702-2.403 8.006-3.861 15.127-9.001 22.113-14.329 8.847-6.747 16.771-14.337 23.541-23.039 7.376-9.482 12.274-19.774 11.62-31.963zm-98.072-36.071c5.529-.236 11.212.73 16.585 3.245 6.579 3.078 10.869 8.299 14.511 14.14.774 1.242 1.48 2.527 2.321 3.725 1.534 2.184 2.207 2.172 3.64-.013 2.116-3.229 4.076-6.559 6.322-9.702 4.131-5.78 10.081-9.004 17.09-10.508 7.402-1.588 14.703-1.187 21.936 1.094 7.169 2.262 12.61 6.684 16.798 12.471 6.575 9.087 8.115 19.384 7.084 30.172-.892 9.339-5.269 17.336-10.557 24.966-9.037 13.042-20.756 23.661-33.517 33.2-6.253 4.675-13.153 8.573-19.871 12.656-4.33 2.631-8.856 3.114-13.246-.058-7.12-5.143-14.46-10.037-21.289-15.514-9.697-7.778-18.558-16.431-26.614-25.792-5.729-6.659-11.233-13.511-14.471-21.689-2.572-6.495-4.362-13.133-3.774-20.23.985-11.891 5.866-21.593 16.805-27.843 6.061-3.463 12.851-4.449 20.246-4.318z"
            },
            {
                "d": "M1406.844 123.349c7.081 1.16 12.205 5.59 16.237 11.104 2.483 3.397 4.707 6.97 7.292 10.293 3.286 4.224 9.362 4.074 12.478-.263 2.026-2.818 3.786-5.811 5.665-8.724 6.192-9.604 15.272-13.393 26.918-12.368 4.004.353 7.762 1.231 11.319 2.952 6.417 3.105 10.077 8.355 11.881 14.719 1.14 4.02 1.494 8.243 2.201 12.375l-.538.077c.417 9.641-3.239 18.048-8.737 25.861-5.259 7.473-11.532 14.099-18.545 20.136-8.751 7.533-17.967 14.485-28.482 19.614-8.563 4.177-7.457 4.388-16.218-.91-9.215-5.574-17.681-12.212-25.288-19.714-6.376-6.288-12.594-12.724-18.701-19.248-1.861-1.989-3.126-4.483-4.659-6.748-3.556-5.255-6.156-10.854-6.726-17.161-.655-7.246-.258-14.395 3.374-20.97 3.483-6.303 9.309-9.994 16.519-11.068 4.572-.682 9.458-.702 14.011.046zm29.777 89.185c-1.738-.065-2.876 1.032-2.825 2.639.049 1.534 1.329 2.777 2.852 2.772 1.547-.007 2.536-1.068 2.529-3.139-.057-1.158-.774-2.203-2.556-2.27zm13.217-7.117c-2.19 0-3.229.949-3.224 2.945.005 1.9 1.049 2.817 3.146 2.764 1.717-.045 2.704-1.084 2.691-2.832-.013-1.807-.984-2.874-2.613-2.875zm-27.066-.818c-1.544.043-2.477.68-2.486 2.239-.012 1.89 1.377 3.573 2.851 3.478 1.171-.076 2.731-1.848 2.703-3.07-.041-1.761-1.145-2.701-3.067-2.647zm-27.557-63.733c-3.221 1.634-5.408 4.225-6.308 7.712-1.302 5.049.221 9.667 2.426 14.125 3.94 7.966 9.849 14.598 16.341 20.728 3.616 3.414 7.704 6.376 11.575 9.544 4.616 3.777 9.821 6.667 15.608 8.342 3.733 1.081 7.564 1.479 11.468-.465 3.488-1.737 6.895-3.521 9.959-5.81l2.23-1.817 5.015-4.377c1.658-1.472 3.269-2.982 4.728-4.614 4.601-5.145 8.643-10.706 11.463-16.991 1.883-4.197 3.176-8.51 3.539-13.51-.377-3.51-1.135-7.34-4.537-10.024-4.916-3.878-10.064-3.829-15.486.374-4.333 3.359-8.375 7.057-12.52 10.631-3.023 2.606-5.874 5.406-9.036 7.844-3.75 2.892-6.354 2.925-10.124.133-4.409-3.264-8.56-6.841-12.908-10.182-4.561-3.503-9.119-7.021-13.877-10.271-2.81-1.919-6.153-3.098-9.556-1.372zm66.67 55.807c-1.392.012-2.696.284-2.752 1.995-.057 1.715 1.654 3.43 3.396 3.342 1.568-.08 2.334-.98 2.399-2.176.001-1.819-1.373-3.177-3.042-3.161zm-50.817-2.301c-1.595-.004-2.649 1.049-2.653 2.654-.005 1.77.995 2.796 2.726 2.798 1.635.002 2.646-.99 2.683-2.63.036-1.624-1.13-2.817-2.756-2.822zm-10.144-9.008c-1.816-.061-3.264 1.071-3.281 2.564-.016 1.436 1.695 3.082 3.235 2.963 1.528-.119 2.592-.823 2.56-2.474.027-1.641-1.096-3.007-2.513-3.053zm74.375-.083c-1.749.025-3.245 1.24-3.273 2.661-.027 1.403 1.497 2.755 3.143 2.786 1.558.028 2.627-1.058 2.616-2.656-.012-1.668-1.03-2.812-2.486-2.791zm-84.203-9.466c-1.547.094-2.593.829-2.595 2.455-.003 1.689 1.403 3.276 2.952 3.168 1.583-.112 2.457-1.02 2.445-2.587-.003-1.658-1.291-3.128-2.802-3.035zm93.912-2.636c-2.595.144-3.549 1.039-3.39 3.183.088 1.196 1.737 2.486 3.07 2.402 1.495-.095 2.802-1.487 2.627-2.996-.151-1.297-.406-2.667-2.308-2.587zm-101.54-8.102c-1.548.109-2.609.927-2.722 2.425-.102 1.357 1.844 3.066 3.224 3.034 1.421-.033 2.658-1.301 2.668-2.734.011-1.424-1.571-2.836-3.171-2.725zm107.57-6.771c-1.856.011-2.518 1.007-2.466 2.651.056 1.715.992 2.768 2.498 2.73 1.569-.038 2.875-1.184 2.876-2.524.001-1.764-1.127-2.873-2.908-2.858zm-53.994-5.784c-1.395.015-2.991 1.531-2.967 2.816.023 1.227 1.743 2.926 2.903 2.867 1.713-.087 3.033-1.381 2.987-2.927-.045-1.476-1.42-2.774-2.924-2.756zm-57.088-.792c-1.267-.069-2.987 1.522-2.998 2.771-.013 1.608 1.061 2.566 2.936 2.62 1.764.051 2.979-.873 3.014-2.288.033-1.397-1.515-3.025-2.952-3.101zm43-7.241c-1.548-.092-3.061 1.094-3.196 2.505-.133 1.384 1.388 2.853 3.231 2.937 1.41-.105 2.349-.859 2.461-2.446.124-1.759-.814-2.894-2.495-2.995zm68.784-.746c-1.354.026-2.691 1.4-2.671 2.747.021 1.388 1.495 2.636 3.051 2.582 1.436-.051 2.741-1.359 2.691-2.703-.051-1.33-1.598-2.653-3.07-2.627zm-42.027-.059c-1.602.012-2.706 1.102-2.64 2.666s.948 2.441 2.6 2.474c1.637.031 2.813-1.082 2.803-2.546-.011-1.507-1.182-2.608-2.764-2.594zm-70.312-4.157c-1.259.013-2.819 1.622-2.846 2.933-.03 1.476 1.449 2.84 3.049 2.816 1.654-.025 2.658-1.017 2.646-2.616-.01-1.393-1.607-3.147-2.85-3.133zm33.79-5.314c-1.597.014-3.046 1.288-3.031 2.662s1.348 2.631 2.803 2.641c1.756.011 3.227-1.191 3.256-2.659.026-1.391-1.424-2.658-3.028-2.644zm45.353-.76c-1.463.032-2.928 1.297-2.943 2.538-.015 1.339 1.645 2.932 3.072 2.947 1.512.017 2.873-1.325 2.832-2.794-.041-1.465-1.427-2.725-2.962-2.69zm27.812-2.315c-1.574.045-2.631.726-2.712 2.369-.076 1.527 1.181 2.902 2.686 2.938 1.599.037 3.028-1.215 3.02-2.645-.008-1.449-1.366-2.709-2.993-2.663zm-99.87-1.561c-1.471.009-2.631 1.383-2.548 3.02.077 1.511 1.406 2.727 2.956 2.702 1.645-.027 2.81-1.219 2.754-2.817-.046-1.306-1.795-2.912-3.163-2.904zm85.219-1.66c-1.64.041-2.586.823-2.648 2.423-.057 1.473 1.402 2.911 2.982 2.982 1.366.062 2.786-1.278 2.801-2.644.017-1.531-1.408-2.806-3.135-2.762zm-71.72-1.09c-1.47-.048-2.537 1.216-2.532 2.998.003 1.381 1.222 2.4 2.907 2.433 1.783.035 3.015-.892 3.019-2.276.004-1.523-1.695-3.101-3.395-3.156zm338.619 100.948.002.012c14.417 0 28.833-.008 43.251.005 3.598.003 5.534-1.654 5.68-5.127.424-10.1 1.198-20.203 1.153-30.3-.064-14.085-.679-28.172-1.186-42.253-.258-7.148-.743-14.29-1.23-21.427-.232-3.41.686-4.572 4.315-4.663 3.073-.078 6.168.165 9.222-.08 5.478-.44 7.472-4.71 4.303-8.911-.694-.92-1.377-1.861-2.175-2.693a65396.081 65396.081 0 0 0-50.93-53.142c-6.01-6.263-11.959-12.585-18.122-18.708-3.32-3.296-5.602-3.153-9.191-.083-.795.679-1.535 1.42-2.258 2.171-14.39 14.9-28.758 29.819-43.163 44.705-7.97 8.236-16.104 16.331-23.935 24.687-2.263 2.416-5.671 5.207-3.803 8.871 1.767 3.47 5.905 3.213 9.5 3.204 8.495-.016 8.353-.01 8.241 8.368-.284 21.262-.613 42.526-.535 63.788.029 7.931.952 15.879 1.838 23.78.527 4.696 2.199 6.072 6.996 6.777 3.383.498 6.814.957 10.227.976 17.266.096 34.534.045 51.8.045zm-4.213 11.599c-18.698 0-37.396.013-56.095-.021-1.756-.003-3.595-.052-5.253-.53-8.625-2.493-10.424-5.058-10.402-13.767.051-19.543.044-39.085.009-58.629-.017-8.862-.13-17.723-.258-26.585-.059-4.133-.866-4.783-5.306-4.969-4.482-.185-9.027-.064-13.42-.784-7.831-1.283-10.165-8.023-4.857-13.649 8.412-8.922 16.984-17.704 25.467-26.566 18.889-19.736 37.76-39.489 56.65-59.223 3.537-3.696 6.994-7.799 13.013-6.924 2.043.299 4.44 1.242 5.783 2.667 19.775 20.975 39.381 42.1 59.068 63.152 8.619 9.216 17.346 18.338 25.995 27.528 2.029 2.158 3.791 4.385 2.206 7.623-1.587 3.243-4.279 4.305-7.772 4.258-3.667-.05-7.337-.008-11.004.031-6.154.067-7.219 1.142-7.221 7.016-.005 29.806-.009 59.611-.052 89.417-.012 7.515-2.619 9.968-10.457 9.977-18.698.02-37.396.007-56.095.007v-.03z"
            },
            {
                "d": "M1698.362 174.731c.323.003.646.009.967.012 0 7.784-.157 15.573.044 23.349.216 8.331 2.128 10.243 10.081 11.541 12.663 2.067 25.249 1.372 37.812-.864 3.149-.559 5.257-2.41 5.778-5.75.534-3.42 1.116-6.889 1.101-10.333-.059-12.218-.333-24.437-.586-36.653-.137-6.674-2.433-9.521-8.674-10.922-1.56-.351-3.151-.577-4.739-.75-11.724-1.273-23.439-2.401-34.927 1.743-3.453 1.245-5.722 3.444-5.914 7.452-.339 7.058-.631 14.116-.942 21.173zm26.905-52.988c16.005 0 32.007-.003 48.011.004 4.001.002 4.91.778 4.973 4.574.502 30.215.979 60.428 1.435 90.643.023 1.55-.097 3.12-.329 4.651-.795 5.226-1.412 5.99-6.603 6-21.26.046-42.524.06-63.782-.169-10.042-.107-20.077-.896-30.119-1.152-3.614-.093-5.571-1.45-5.804-5.369-.318-5.377-1.096-10.744-1.116-16.118-.1-26.033-.023-52.067.017-78.099.005-4.134.867-4.939 4.967-4.941 16.116-.005 32.234-.002 48.351-.002v-.022z"
            },
            {
                "d": "M1765.615 124.536c-2.068.043-4.504-2.707-6.417-4.658-9.227-9.403-18.398-18.883-27.454-28.507-5.575-5.923-10.81-12.286-16.397-18.192-2.497-2.64-2.52-4.788-.742-7.612 1.783-2.832 3.156-6.029 4.98-8.819 2.104-3.217 3.004-2.959 5.67-.073 8.987 9.73 18.095 19.308 27.097 29.022 8.098 8.741 16.105 17.597 24.176 26.375 2.584 2.809 5.242 5.525 7.867 8.286l-.385 1.86c-6.128.861-12.228 2.192-18.394 2.32zm26.367-5.54c-5.342 2.715-9.01-1.302-12.884-5.881-10.146-11.991-20.581-23.646-30.83-35.521-5.781-6.7-11.434-13.557-17.123-20.371-1.336-1.601-1.146-3.222-.057-4.862 2.012-3.025 3.986-3.952 6.106-2.403 1.652 1.208 3.186 2.687 4.657 4.203 16.052 16.548 32.106 33.087 48.093 49.722 3.215 3.345 6.191 7.019 9.188 10.643 1.796 2.171 1.505 3.3-.942 3.783-1.883.372-3.818.437-6.211.688zm-51.039 2.567c-.642 0-1.296-.064-1.926.011-6.326.745-10.755-.983-14.523-5.467-3.642-4.335-8.698-7.902-13.226-11.733-5.682-4.806-11.553-9.466-17.092-14.375-.865-.766-1.131-2.963-.416-3.74 3.442-3.749 7.206-7.319 11.078-10.787 1.891-1.693 3.377-.369 4.666.96 5.47 5.637 10.832 11.348 16.487 16.861 8.364 8.151 16.966 16.143 25.403 24.246.835.801 1.241 1.894 1.846 2.852-1.271.378-2.522 1.002-3.822 1.078-2.812.167-5.65.052-8.477.052v.043zm-26.865.085c-5.398 0-10.822.28-16.185-.125-2.46-.184-5.187-1.272-7.117-2.714-5.386-4.025-10.421-8.449-15.594-12.712-4.325-3.562-4.294-4.234-.518-8.259 2.858-3.044 5.464-6.289 8.233-9.406 2.399-2.702 3.497-2.602 6.116-.005 9.539 9.462 19.157 18.854 28.684 28.326.925.921 1.412 2.215 2.101 3.335-1.522.422-3.035.869-4.57 1.244-.343.083-.761-.083-1.142-.134-.004.15-.006.301-.007.45zm-30.217-.61c-2.956.263-5.72.759-8.471.699-4.459-.093-8.91-.522-13.359-.883-.727-.059-1.419-.498-2.128-.763.307-.645.455-1.432.951-1.915 2.648-2.572 5.29-5.168 8.157-7.524.742-.609 2.792-.919 3.393-.449 3.785 2.96 7.337 6.171 10.937 9.329.246.216.243.671.519 1.505zm42.023 39.216c0 3.995-.074 7.993.026 11.986.069 2.779-1.249 4.012-4.378 4.047-3.902.043-7.803.297-11.702.509-4.259.231-5.24-.364-5.439-4.157-.186-3.578-.18-7.182.085-10.755.315-4.247 2.372-6.029 7.039-6.626 2.321-.297 4.649-.553 6.98-.788 6.484-.65 7.233-.013 7.389 5.784zm0 34.359c0-3.995-.074-7.993.026-11.986.069-2.779-1.249-4.012-4.378-4.047-3.902-.043-7.803-.297-11.702-.509-4.259-.231-5.24.364-5.439 4.157-.186 3.578-.18 7.182.085 10.755.315 4.247 2.372 6.029 7.039 6.626 2.321.297 4.649.553 6.98.788 6.484.65 7.233.013 7.389-5.784zm2.464 0c0-3.995.074-7.993-.026-11.986-.069-2.779 1.249-4.012 4.378-4.047 3.902-.043 7.803-.297 11.702-.509 4.259-.231 5.24.364 5.439 4.157.186 3.578.18 7.182-.085 10.755-.315 4.247-2.372 6.029-7.039 6.626-2.321.297-4.649.553-6.98.788-6.484.65-7.233.013-7.389-5.784zm0-34.359c0 3.995.074 7.993-.026 11.986-.069 2.779 1.249 4.012 4.378 4.047 3.902.043 7.803.297 11.702.509 4.259.231 5.24-.364 5.439-4.157.186-3.578.18-7.182-.085-10.755-.315-4.247-2.372-6.029-7.039-6.626a262.199 262.199 0 0 0-6.98-.788c-6.484-.65-7.233-.013-7.389 5.784zm-127.837 60.812c3.932-.223 7.001-2.738 8.397-7.073.797-2.476 2.501-3.8 5.088-4.013a45.159 45.159 0 0 0 3.385-.406c4.771-.759 7.948-4.916 7.326-9.554-.421-3.131.741-5.31 3.516-6.95 1.623-.959 3.475-1.827 4.623-3.211 2.18-2.627 2.405-5.578.643-8.745-1.858-3.339-1.899-6.653.749-9.903 3.663-4.494 2.979-8.85-1.632-12.443-2.52-1.965-3.593-4.401-2.729-7.542.276-1.004.478-2.04.576-3.073.368-3.885-1.79-7.038-5.531-8.254-1.214-.394-2.421-.837-3.577-1.369-2.536-1.168-3.881-3.224-4.104-5.897-.425-5.114-4.071-8.128-9.212-7.438-4.1.551-7.683-.011-9.862-3.975-.197-.36-.516-.666-.818-.96-3.863-3.781-6.379-4.101-10.35-1.665-3.796 2.328-7.64 2.339-11.445-.072a9.096 9.096 0 0 0-1.717-.838c-1.777-.653-3.59-1.141-5.248.236-1.925 1.599-3.929 3.137-5.65 4.931-1.649 1.722-3.497 2.536-5.854 2.345-.85-.068-1.707-.3-2.546-.244-3.302.215-6.682.384-8.151 4.084a29.026 29.026 0 0 0-1.114 3.354c-.918 3.496-2.473 6.35-6.581 7.037-.953.159-1.821.77-2.746 1.127-2.57.995-3.786 2.921-3.74 5.522.034 1.935.407 3.863.555 5.797.179 2.344-.008 4.518-2.216 6.139-1.291.947-2.28 2.28-3.421 3.425-1.709 1.714-1.72 3.804-1.076 5.843.496 1.568 1.231 3.162 2.241 4.459 1.997 2.566 2.807 5.105 1.005 8.064-.322.528-.502 1.156-.66 1.759-.834 3.179-1.402 6.357 1.539 8.874 1.005.86 2.144 1.679 3.367 2.168 3.395 1.357 4.321 3.892 4.201 7.197-.057 1.563-.013 3.272.567 4.686 1.603 3.908 5.264 5.082 9.095 5.46 2.702.266 4.345 1.159 5.479 3.725 3.011 6.808 6.507 8.249 13.769 6.169.138-.038.277-.072.408-.123 2.809-1.067 5.14-.387 7.093 1.801a11.995 11.995 0 0 0 1.708 1.569c3.218 2.419 6.994 2.436 10.202.068 1.247-.921 2.466-1.882 3.721-2.794 1.591-1.157 3.242-1.479 5.207-.737 1.766.665 3.672.972 5.517 1.436zm6.35 11.521c-.855-.203-2.31-.344-3.585-.886-4.522-1.921-8.285-.678-11.774 2.313-1.379 1.182-2.76 2.488-4.381 3.251-4.431 2.087-8.723 1.071-12.676-3.475-2.682-3.084-5.384-3.236-8.882-1.92-4.759 1.79-9.878.517-13.053-3.052-.642-.721-1.225-1.569-1.564-2.457-1.685-4.412-5.15-7.002-9.843-7.23-6.089-.296-10.999-6.046-10.276-11.968.457-3.744-1.155-6.615-4.161-8.819-.967-.709-1.993-1.342-2.973-2.033-4.677-3.294-5.831-7.818-3.08-13.225 2.553-5.019 2.408-7.763-1.13-12.016-3.796-4.566-3.422-9.328 1.045-13.291.316-.28.65-.539.985-.798 3.673-2.839 4.603-5.692 3.29-10.112-1.29-4.343-.385-8.152 2.69-10.363 1.111-.799 2.488-1.378 3.833-1.711 4.951-1.227 7.849-3.925 8.403-9.167.59-5.581 5.119-8.55 10.818-7.624 5.771.939 8.147.01 11.084-4.74 3.33-5.382 9.796-5.806 15.082-3.47.967.427 1.975.892 2.757 1.569 2.121 1.84 4.161 1.295 6.248.041 1.09-.655 2.141-1.382 3.268-1.969 4.574-2.386 9.631-1.223 12.691 2.879.712.955 1.531 1.858 2.089 2.894 1.488 2.766 3.758 3.56 6.788 2.982 1.385-.264 2.826-.352 4.241-.345 6.253.028 9.83 4.493 11.424 9.585 1.04 3.323 2.143 6.31 5.675 7.763 1.428.588 2.961 1.013 4.268 1.797 3.747 2.245 7.409 7.627 5.324 12.233-2.052 4.531-.722 7.767 2.893 10.724 1.338 1.094 2.459 2.519 3.427 3.954 2.197 3.254 1.969 6.744-.461 9.891-.427.554-.901 1.075-1.366 1.6-2.2 2.49-2.794 5.234-1.446 8.32.753 1.72 1.743 3.407 2.107 5.21.883 4.378-1.147 8.153-5.415 10.049-4.338 1.927-6.335 4.885-6.1 9.66.352 7.155-2.853 10.239-10.218 10.616-3.772.194-6.669 1.771-8.131 5.389-.546 1.351-1.152 2.692-1.857 3.968-1.599 2.895-4.338 3.806-8.059 3.984z"
            },
            {
                "d": "M1559.795 165.654c1.569-.024 3.043-1.299 3.029-2.619-.017-1.455-1.867-3.224-3.342-3.196-1.544.029-2.579 1.223-2.559 2.949.021 1.809 1.108 2.894 2.873 2.866zm10.909-12.94c-.007 1.753 1.342 3.254 2.926 3.255 1.528 0 3.036-1.647 2.983-3.258-.043-1.338-1.52-2.513-3.18-2.481-1.655.033-2.764.68-2.73 2.484zm29.618 27.948c1.55.036 3.009-1.37 3.004-2.894-.005-1.528-1.556-2.932-3.28-2.88-1.693.051-2.609.956-2.682 2.603-.076 1.664 1.313 3.132 2.959 3.171zm-39.219-5.418c-1.997.029-2.912.833-2.906 2.55.006 1.902 1.102 2.922 3.117 2.9 1.893-.019 3.01-1.086 2.952-2.819-.057-1.707-1.202-2.661-3.163-2.631zm8.843 13.794c-.035 1.706 1.465 3.278 3.116 3.265 1.315-.011 2.76-1.437 2.756-2.719-.006-1.584-1.489-3.349-2.868-3.414-1.585-.073-2.97 1.249-3.004 2.868zm22.131.878c.02-2.002-1.426-3.662-3.015-3.726-1.474-.059-3.302 1.597-3.285 2.975.018 1.508 1.571 2.809 3.364 2.807 1.62-.002 2.762-.586 2.937-2.056zm-4.223-39.994c-1.416.182-2.121 1.22-2.123 2.817-.003 1.784 1.229 2.93 3.13 2.929 1.777-.001 2.894-1.105 2.923-2.888.031-1.926-1.169-2.876-3.93-2.858zm14.519 15.67c1.531-.04 3.06-1.349 3.072-2.629.013-1.384-2.289-3.551-3.694-3.474-1.457.078-2.71 1.613-2.635 3.227.076 1.624 1.544 2.921 3.256 2.875zm-57.495 2.544-.333.67c-.749.074-1.496.185-2.248.215-1.216.048-2.472-.125-3.638.123-.659.141-1.172.933-1.75 1.431.565.441 1.084 1.167 1.705 1.262 1.256.19 2.57-.003 3.856.048.581.023 1.155.25 1.732.384-.237.544-.338 1.219-.736 1.612-1.656 1.633-3.528 3.075-5.06 4.805-.719.813-1.463 2.806-1.134 3.086 1.305 1.107 2.263-.278 3.134-1.108 2.705-2.578 5.321-5.242 8.057-7.787.61-.567 1.561-1.095 2.366-1.112 6.42-.139 12.843-.148 19.266-.202 1.509-.012 3.036-.191 3.787 1.607.714 1.71-.21 2.733-1.347 3.806-2.667 2.516-5.358 5.015-7.902 7.647-5.045 5.221-5.006 5.253-12.266 5.237-1.792-.004-3.596-.105-5.368.077-.769.079-1.471.764-2.203 1.173.74.406 1.452 1.099 2.222 1.165 2.064.178 4.15.07 6.227.114.671.014 1.34.144 2.609.289-1.558 1.583-2.725 2.757-3.879 3.943-.688.706-1.551 1.339-1.966 2.178-.314.635-.048 1.541-.038 2.327.704-.173 1.539-.172 2.083-.558.904-.641 1.575-1.58 2.428-2.303.866-.732 1.832-1.355 2.753-2.026.208.097.416.192.624.29-.087 1.622-.162 3.244-.264 4.864-.057.899-.289 1.809-.187 2.686.059.508.623.959.96 1.436.451-.386 1.018-.703 1.319-1.179.283-.448.344-1.057.401-1.607.271-2.625.383-5.272.806-7.872.235-1.446.589-3.158 1.545-4.156 4.039-4.215 8.271-8.262 12.573-12.226.797-.733 2.383-1.289 3.339-1.022.703.194 1.352 1.855 1.374 2.874.124 6.039-.027 12.081.096 18.12.048 2.299-.88 3.962-2.414 5.545-2.255 2.327-4.502 4.675-6.541 7.176-.56.687-.369 1.951-.523 2.95.837-.356 1.882-.515 2.471-1.103 1.738-1.74 3.265-3.679 4.952-5.471.367-.39 1.059-.493 1.601-.728.154.504.404 1.002.442 1.513.07.967-.172 1.992.072 2.901.219.812.921 1.501 1.409 2.245.459-.718 1.117-1.387 1.326-2.168.244-.918.068-1.935.135-2.905.034-.503.201-.998.455-2.194 1.837 2.162 3.179 3.934 4.742 5.495.735.735 1.896 1.073 2.864 1.59-.295-1.043-.322-2.276-.935-3.095-1.591-2.129-3.515-4.022-5.156-6.12-.836-1.068-1.863-2.352-1.92-3.578a395.054 395.054 0 0 1-.391-20.218c.005-1 .961-2.429 1.874-2.853.731-.339 2.353.253 3.087.933 4.603 4.279 9.132 8.639 13.526 13.121.882.901 1.391 2.408 1.524 3.687.24 2.342.009 4.726.096 7.087.042 1.15-.528 2.757 1.276 3.013.264.036 1.089-1.942 1.209-3.034.205-1.871.057-3.781.057-5.673l.698-.208c.615.51 1.251.999 1.841 1.533.993.897 1.884 1.922 2.969 2.69.424.301 1.259.058 1.905.062-.081-.633.063-1.447-.291-1.864-.76-.899-1.832-1.543-2.662-2.397-.397-.407-.534-1.054-.788-1.592.543-.241 1.104-.716 1.627-.681 1.923.133 3.828.552 5.749.612.723.022 1.469-.641 2.204-.992-.633-.443-1.225-1.184-1.905-1.274-3.116-.41-6.279-.51-9.381-.99-1.386-.214-2.95-.769-3.952-1.672-4.763-4.3-9.406-8.731-13.964-13.236-.637-.631-1.018-2.108-.704-2.883.361-.889 1.612-2.015 2.501-2.037 6.359-.157 12.723-.098 19.086.007.832.014 1.836.498 2.443 1.078 2.446 2.327 4.712 4.834 7.169 7.151.832.784 2.819 1.827 2.941 1.685 1.264-1.493-.209-2.524-1.092-3.471-1.243-1.329-2.797-2.384-4.072-3.688-.522-.534-.666-1.416-.981-2.139.7-.231 1.399-.647 2.102-.655 1.641-.018 3.292.291 4.921.189.632-.038 1.216-.825 1.821-1.27-.57-.472-1.104-1.286-1.719-1.349-1.552-.163-3.141.04-4.716.037-.625 0-1.251-.156-2.24-.29.608-.811.864-1.318 1.267-1.659 1.506-1.275 3.157-2.406 4.555-3.78.59-.581.686-1.634 1.005-2.472-.969.149-2.177-.007-2.868.5a92.461 92.461 0 0 0-7.21 5.91c-1.423 1.287-2.954 1.739-4.855 1.729-5.513-.027-11.027.053-16.538.145-1.386.022-2.732.221-3.532-1.276-.884-1.656-.003-2.695 1.144-3.805 3.856-3.729 7.664-7.504 11.459-11.291 1.836-1.833 3.881-2.896 6.652-2.726 2.996.183 6.016.07 9.024-.006.623-.016 1.234-.441 1.852-.676-.51-.486-.97-1.323-1.538-1.397-2.042-.266-4.123-.24-6.183-.398-.95-.072-1.887-.313-2.83-.477.546-.829 1.014-1.72 1.659-2.468.687-.793 1.708-1.346 2.269-2.199.432-.656.378-1.616.539-2.439-.885.162-1.806.231-2.642.526-.408.144-.663.704-.98 1.082-1.016 1.204-2.029 2.412-3.043 3.618l-.814-.514c-.109-.648-.291-1.295-.311-1.946-.049-1.46.027-2.924-.032-4.381-.043-1.042.365-2.527-1.29-2.567-.424-.01-1.198 1.491-1.273 2.342-.257 2.905-.177 5.837-.433 8.742-.09 1.016-.525 2.227-1.239 2.931a494.417 494.417 0 0 1-13.503 12.834c-.696.637-2.176 1.157-2.924.858-.772-.309-1.514-1.67-1.54-2.591a311.689 311.689 0 0 1-.043-15.829c.167-7.018.252-7.007 5.307-12.149.884-.902 1.755-1.858 2.4-2.923.281-.464-.024-1.262-.064-1.91-.58.1-1.32.016-1.714.334-1.091.881-2.03 1.941-3.046 2.912-.569.542-1.174 1.048-2.005 1.786-.261-.84-.388-1.28-.535-1.715-.467-1.391.333-4.024-1.616-3.888-2.123.149-1.127 2.705-1.345 4.255-.122.862-.276 1.72-.504 3.13-2.331-2.395-4.105-4.28-5.968-6.079-.358-.344-1.064-.347-1.61-.509-.101.568-.363 1.165-.261 1.697.096.503.515.99.892 1.394 1.918 2.055 3.95 4.016 5.765 6.151.773.909 1.553 2.153 1.58 3.262.159 6.535.08 13.074.124 19.612.01 1.481-.443 2.834-1.964 3.037-.981.132-2.361-.384-3.101-1.076-4.529-4.229-8.923-8.593-13.368-12.907-1.581-1.535-2.571-3.222-2.29-5.55.298-2.479.417-4.991.384-7.485-.01-.788-.765-1.567-1.179-2.349-.465.691-1.192 1.333-1.343 2.084-.314 1.555-.305 3.17-.465 4.757-.071.711-.23 1.414-.448 2.706-1.719-1.36-2.977-2.442-4.338-3.384-.427-.297-1.131-.218-1.707-.311.003.52-.141 1.096.041 1.549.378.946.927 1.826 1.657 3.212-2.143-.18-3.874-.449-5.598-.41-.658.015-1.3.729-1.949 1.125.579.463 1.105 1.225 1.748 1.335 2.887.494 5.829.694 8.707 1.228 1.194.222 2.513.779 3.371 1.588 4.986 4.695 9.845 9.52 14.766 14.284 1.012.979 1.831 1.947 1.262 3.473-.607 1.627-1.979 1.571-3.365 1.579-6.59.04-13.179.114-19.769.098-.696-.002-1.572-.345-2.056-.824-1.896-1.875-3.666-3.872-5.493-5.816-.767-.816-1.465-1.74-2.377-2.361-.433-.294-1.296.008-1.964.04.04.568-.133 1.285.157 1.678.828 1.12 1.828 2.121 2.789 3.144.983 1.047 1.998 2.068 3 3.098zm-5.186 32.185c.257-4.796-1.598-7.899-5.67-10.025-4.611-2.407-5.265-4.79-3.094-9.421 1.724-3.679 2.004-7.112-1.124-10.377-2.209-2.306-2.823-5.132-1.462-8.122.314-.691.885-1.402 1.536-1.798 3.73-2.272 5.515-6.501 4.378-10.653-1.289-4.713-.618-6.23 3.884-8.563a61.877 61.877 0 0 1 4.632-2.183c2.366-.989 3.39-2.83 3.814-5.162.211-1.155.449-2.34.923-3.408 1.642-3.706 3.192-4.535 7.243-3.888 4.344.693 7.761-.374 10.419-4.057 3.299-4.571 7.052-5.045 11.852-1.948 3.124 2.014 5.572 1.954 8.678-.214 4.517-3.154 8.84-2.324 11.826 2.272 1.971 3.031 5.132 4.396 8.798 3.799 4.963-.807 7.337.474 9.203 5.019.475 1.155.974 2.324 1.24 3.532.635 2.892 2.571 4.406 5.382 5.01 5.079 1.094 7.288 4.083 6.221 9.004-.96 4.435-.206 7.973 3.919 10.719 3.005 2 3.462 5.629 1.617 8.753a66.29 66.29 0 0 1-2.267 3.538c-1.836 2.697-1.52 5.421-.024 8.084 2.695 4.802 1.897 7.581-3.097 10.248-3.053 1.629-5.379 3.642-5.045 7.472.107 1.223-.2 2.489-.39 3.726-.524 3.384-2.484 5.162-5.996 5.339-5.531.278-8.813 3.235-10.829 8.044-1.137 2.713-3.103 3.757-5.469 3.381-1.481-.234-2.964-.518-4.405-.92-3.664-1.024-6.93-.679-9.526 2.332-.138.159-.3.299-.453.445-3.18 3.019-6.126 3.205-9.43.389-1.68-1.431-3.213-3.03-5.579-3.232-1.57-.133-3.169-.179-4.737-.049-1.974.165-3.933.805-5.892.78-2.66-.034-4.331-1.719-4.766-4.207-.502-2.862-3.941-5.897-6.897-6.223-1.772-.196-3.553-.471-5.275-.915-2.911-.752-4.183-2.991-4.142-6.527zm-52.76 609.769h-49.681v-49.681h49.681v49.681zm141.947-49.682h49.681v49.681h-49.681v-49.681zm-621.017 0v49.681h-49.681v-49.681h49.681zm95.814 49.682h-49.681v-49.681h49.681v49.681zm46.133 0v-49.681h49.681v49.681h-49.681zm145.495-49.682v49.681h-49.681v-49.681h49.681zm46.133 49.682v-49.681h49.681v49.681h-49.681zm191.628-49.682h49.681v49.681h-49.681v-49.681zm195.176-447.131v49.681h-49.681v-49.681h49.681zm-95.222 49.681h-49.681v-49.681h49.681v49.681zm-95.222 0h-49.681v-49.681h49.681v49.681zm-144.905 0v-49.681h49.681v49.681h-49.681z"
            },
            {
                "d": "M1782.725 226.334c20.876 0 29.045 8.115 29.045 28.855v39.675c21.784 0 42.66.902 62.629 0 13.615-.902 22.692 5.411 29.045 18.034 9.984 20.739 19.969 40.577 30.86 60.414 9.984 18.936 16.338 38.773 13.615 60.414-1.815 12.624-.908 24.346 3.631 34.265-15.43-12.624-32.676-21.641-51.737-28.855l2.089.81.719.078.823.014c-1.815-9.918-.908-22.543-5.446-33.364-8.169-20.739-19.061-39.675-29.045-58.611-1.815-2.705-5.446-7.214-8.169-7.214h-49.921v87.466h1.815c-29.045 2.705-55.367 11.723-78.967 25.247h-380.31c0 12.624.908 22.543 0 32.462s2.723 12.624 12.707 12.624h314.051c-10.892 14.427-20.876 29.756-28.138 46.888H966.736v43.282h672.578a195.915 195.915 0 0 0-2.723 32.462c0 4.509.908 9.017.908 13.526H840.571c.908 2.705.908 4.509 1.815 6.312 38.122 100.992 76.244 201.081 112.55 302.073 3.631 8.115 8.169 8.115 15.43 8.115h993.89c9.984 0 13.615-3.607 16.338-11.723 13.615-38.773 28.138-76.646 42.66-114.517a5957.64 5957.64 0 0 0 38.122-100.09c-23.599 0-44.475.902-66.259 0 9.077-13.526 16.338-28.855 21.784-45.085h56.275c1.815 0 5.446-2.705 6.354-4.509 5.446-12.624 9.984-25.247 15.43-39.675h-69.89c.908-5.411.908-9.918.908-14.427 0-11.723-.908-21.641-2.723-32.462h98.935c24.507 0 33.583 13.526 25.415 36.068-44.475 117.222-88.043 233.542-132.519 350.766-6.354 17.132-11.8 20.739-29.953 20.739H949.49c-18.153 0-23.599-3.607-29.953-20.739-42.66-114.517-86.228-229.936-129.796-342.649-1.815-4.509-3.631-8.115-5.446-11.723v-16.231c8.169-11.723 19.969-14.427 33.583-14.427 33.583.902 67.167 0 103.473 0 0-15.329.908-29.756 0-44.184-1.815-21.641 3.631-39.675 18.153-55.906 16.338-18.936 31.768-39.675 45.383-60.414 10.892-16.231 24.507-21.641 43.568-21.641h279.56V259.694c0-25.247 7.261-32.462 32.676-32.462h34.491l301.344-.902zm-480.154 227.231h-270.483c-3.631 0-8.169.902-9.984 2.705-10.892 12.624-20.876 26.15-31.768 41.479h316.774v-43.282c-1.815 0-3.631-.902-4.538-.902zm460.186-180.342h-408.449v133.453h408.449V273.223z"
            },
            {
                "d": "M1877.213 742.283c9.626-.556 17.139-6.825 20.558-17.628 1.952-6.169 6.123-9.471 12.458-9.999 2.774-.234 5.544-.566 8.29-1.013 11.682-1.892 19.459-12.252 17.935-23.811-1.03-7.805 1.814-13.235 8.608-17.322 3.972-2.39 8.506-4.554 11.32-8.003 5.338-6.547 5.889-13.901 1.574-21.797-4.548-8.32-4.651-16.582 1.832-24.682 8.968-11.201 7.294-22.055-3.995-31.011-6.171-4.897-8.797-10.967-6.682-18.798.674-2.502 1.171-5.084 1.411-7.66.901-9.681-4.383-17.542-13.542-20.572-2.972-.983-5.926-2.085-8.755-3.411-6.208-2.91-9.501-8.036-10.047-14.695-1.041-12.745-9.968-20.257-22.554-18.535-10.037 1.374-18.808-.028-24.143-9.907-.482-.897-1.263-1.658-2-2.393-9.458-9.423-15.617-10.22-25.34-4.15-9.291 5.801-18.703 5.829-28.021-.18a22.048 22.048 0 0 0-4.204-2.088c-4.35-1.628-8.789-2.843-12.848.59-4.713 3.985-9.621 7.82-13.831 12.29-4.039 4.292-8.562 6.319-14.333 5.844-2.082-.17-4.179-.747-6.233-.61-8.085.536-16.359.957-19.953 10.18a72.995 72.995 0 0 0-2.727 8.358c-2.248 8.714-6.054 15.825-16.111 17.54-2.334.396-4.459 1.918-6.722 2.809-6.292 2.479-9.269 7.28-9.157 13.763.084 4.823.998 9.626 1.359 14.449.439 5.841-.02 11.262-5.427 15.3-3.159 2.359-5.582 5.684-8.376 8.537-4.184 4.272-4.212 9.481-2.633 14.563 1.215 3.909 3.013 7.878 5.485 11.114 4.888 6.395 6.873 12.721 2.46 20.097-.788 1.316-1.23 2.88-1.618 4.383-2.041 7.922-3.431 15.844 3.768 22.116 2.46 2.144 5.248 4.183 8.243 5.402 8.31 3.383 10.578 9.7 10.284 17.938-.138 3.896-.033 8.156 1.388 11.68 3.923 9.74 12.887 12.666 22.265 13.608 6.615.663 10.637 2.888 13.414 9.283 7.371 16.968 15.931 20.56 33.71 15.376.336-.096.676-.18 1-.305 6.878-2.659 12.583-.965 17.366 4.488a29.392 29.392 0 0 0 4.182 3.911c7.878 6.029 17.122 6.073 24.977.17 3.054-2.295 6.037-4.691 9.108-6.964 3.896-2.883 7.937-3.685 12.749-1.839 4.322 1.656 8.991 2.423 13.507 3.581zm15.545 28.715c-2.092-.505-5.654-.858-8.777-2.209-11.07-4.788-20.286-1.689-28.826 5.763-3.375 2.946-6.758 6.2-10.726 8.102-10.848 5.202-21.356 2.669-31.034-8.66-6.567-7.686-13.182-8.064-21.744-4.785-11.652 4.462-24.184 1.288-31.955-7.607-1.571-1.798-2.998-3.911-3.829-6.124-4.125-10.995-12.608-17.451-24.1-18.02-14.908-.736-26.929-15.069-25.158-29.827 1.117-9.331-2.826-16.486-10.187-21.979-2.367-1.768-4.878-3.345-7.279-5.067-11.45-8.211-14.274-19.485-7.539-32.959 6.25-12.511 5.896-19.346-2.766-29.95-9.291-11.378-8.379-23.247 2.559-33.125.773-.696 1.592-1.343 2.411-1.989 8.994-7.076 11.269-14.187 8.054-25.203-3.156-10.825-.941-20.316 6.585-25.827 2.72-1.992 6.09-3.434 9.384-4.265 12.121-3.058 19.216-9.784 20.571-22.846 1.444-13.908 12.532-21.309 26.485-19 14.129 2.339 19.946.025 27.138-11.813 8.152-13.412 23.982-14.469 36.922-8.648 2.367 1.065 4.837 2.225 6.751 3.911 5.195 4.584 10.187 3.225 15.298.101 2.668-1.633 5.24-3.444 8.001-4.907 11.198-5.945 23.579-3.048 31.069 7.175 1.742 2.38 3.748 4.63 5.113 7.213 3.643 6.893 9.2 8.872 16.619 7.434 3.391-.657 6.919-.876 10.383-.861 15.311.071 24.066 11.198 27.967 23.889 2.546 8.282 5.245 15.726 13.895 19.346 3.498 1.466 7.248 2.524 10.447 4.478 9.175 5.595 18.14 19.008 13.034 30.488-5.024 11.292-1.768 19.356 7.082 26.726 3.276 2.728 6.018 6.279 8.391 9.855 5.378 8.109 4.822 16.806-1.127 24.652-1.046 1.382-2.204 2.679-3.342 3.987-5.386 6.205-6.84 13.045-3.538 20.735 1.842 4.287 4.268 8.49 5.158 12.984 2.164 10.911-2.806 20.318-13.256 25.045-10.618 4.803-15.509 12.173-14.935 24.074.86 17.832-6.983 25.518-25.015 26.46-9.236.485-16.326 4.414-19.908 13.431-1.337 3.368-2.819 6.707-4.546 9.89-3.913 7.216-10.618 9.486-19.729 9.931z"
            },
            {
                "d": "M1775.88 604.31c3.827-.062 7.422-3.268 7.386-6.589-.041-3.66-4.554-8.112-8.151-8.043-3.766.074-6.29 3.078-6.241 7.42.051 4.552 2.703 7.282 7.005 7.212zm26.605-32.559c-.018 4.409 3.273 8.187 7.136 8.189 3.725 0 7.404-4.144 7.276-8.197-.104-3.367-3.705-6.324-7.755-6.242-4.037.085-6.74 1.711-6.658 6.25zm72.23 70.322c3.779.092 7.338-3.447 7.325-7.282-.013-3.844-3.794-7.376-8-7.248-4.129.129-6.361 2.406-6.543 6.55-.184 4.188 3.201 7.881 7.218 7.979zm-95.645-13.631c-4.871.074-7.102 2.095-7.087 6.417.015 4.785 2.688 7.35 7.602 7.297 4.617-.049 7.34-2.731 7.199-7.094-.138-4.296-2.933-6.697-7.714-6.62zm21.564 34.709c-.087 4.293 3.572 8.248 7.599 8.215 3.206-.028 6.731-3.616 6.721-6.843-.015-3.985-3.631-8.428-6.995-8.589-3.866-.184-7.243 3.141-7.325 7.218zm53.975 2.208c.049-5.037-3.48-9.215-7.353-9.374-3.595-.149-8.053 4.017-8.013 7.486.044 3.796 3.832 7.069 8.204 7.064 3.95-.005 6.737-1.472 7.161-5.175zm-10.3-100.634c-3.454.459-5.172 3.07-5.178 7.089-.008 4.489 2.996 7.371 7.634 7.369 4.334-.003 7.059-2.78 7.129-7.266.077-4.845-2.851-7.238-9.585-7.191zm35.409 39.431c3.733-.1 7.463-3.396 7.494-6.615.033-3.483-5.584-8.933-9.01-8.74-3.554.198-6.609 4.057-6.425 8.12.184 4.085 3.766 7.348 7.941 7.235zm-140.217 6.399-.813 1.685c-1.825.187-3.649.467-5.481.541-2.966.121-6.028-.313-8.872.308-1.609.354-2.859 2.347-4.27 3.601 1.378 1.108 2.644 2.937 4.157 3.175 3.063.479 6.267-.008 9.404.121 1.419.059 2.817.628 4.223.966-.577 1.37-.826 3.067-1.795 4.055-4.04 4.109-8.606 7.735-12.342 12.09-1.754 2.046-3.567 7.061-2.764 7.764 3.183 2.786 5.52-.698 7.644-2.788 6.597-6.486 12.978-13.19 19.648-19.595 1.488-1.428 3.807-2.754 5.77-2.798 15.657-.348 31.322-.372 46.985-.508 3.681-.03 7.404-.482 9.235 4.042 1.741 4.303-.512 6.876-3.285 9.577-6.505 6.332-13.067 12.621-19.27 19.243-12.303 13.137-12.208 13.219-29.913 13.177-4.369-.01-8.77-.264-13.09.194-1.874.2-3.587 1.921-5.374 2.952 1.802 1.023 3.542 2.765 5.418 2.932 5.032.449 10.122.177 15.187.288 1.636.035 3.268.362 6.361.726-3.799 3.983-6.645 6.938-9.46 9.92-1.678 1.778-3.782 3.37-4.797 5.48-.767 1.598-.115 3.878-.094 5.855 1.718-.436 3.753-.434 5.08-1.405 2.204-1.614 3.842-3.975 5.921-5.793 2.112-1.844 4.466-3.411 6.714-5.099.507.244 1.015.485 1.522.728-.212 4.08-.396 8.161-.644 12.239-.138 2.262-.703 4.552-.458 6.758.143 1.277 1.519 2.413 2.342 3.613 1.099-.972 2.483-1.77 3.216-2.967.69-1.125.841-2.659.98-4.042.663-6.604.933-13.265 1.966-19.807.572-3.637 1.434-7.946 3.768-10.459 9.851-10.605 20.172-20.79 30.663-30.764 1.943-1.847 5.812-3.242 8.144-2.572 1.716.49 3.298 4.668 3.349 7.233.302 15.193-.067 30.401.235 45.594.115 5.783-2.148 9.969-5.888 13.952-5.5 5.855-10.978 11.764-15.951 18.056-1.366 1.728-.9 4.909-1.275 7.422 2.04-.896 4.589-1.296 6.026-2.775 4.239-4.378 7.961-9.259 12.075-13.768.894-.983 2.582-1.241 3.904-1.834.376 1.269.987 2.521 1.077 3.809.171 2.434-.419 5.011.176 7.3.534 2.044 2.245 3.778 3.436 5.648 1.119-1.808 2.725-3.491 3.235-5.455.596-2.309.166-4.868.33-7.31.084-1.267.488-2.511 1.109-5.522 4.48 5.44 7.752 9.897 11.564 13.827 1.795 1.852 4.625 2.698 6.985 4.001-.718-2.627-.785-5.728-2.28-7.787-3.881-5.358-8.573-10.121-12.574-15.399-2.038-2.688-4.543-5.919-4.681-9.003-.757-16.941-1.04-33.914-.953-50.872.013-2.516 2.344-6.112 4.572-7.179 1.785-.854 5.74.636 7.527 2.347 11.226 10.767 22.271 21.739 32.987 33.013 2.153 2.267 3.393 6.058 3.715 9.279.586 5.894.023 11.89.235 17.833.102 2.893-1.287 6.938 3.114 7.581.644.092 2.656-4.886 2.948-7.635.498-4.708.138-9.512.138-14.275l1.703-.523c1.501 1.282 3.05 2.513 4.49 3.858 2.421 2.257 4.594 4.834 7.241 6.768 1.035.757 3.07.146 4.648.156-.197-1.592.153-3.64-.708-4.691-1.854-2.262-4.466-3.883-6.491-6.029-.969-1.026-1.302-2.652-1.923-4.006 1.324-.608 2.693-1.803 3.968-1.713 4.689.333 9.337 1.39 14.021 1.539 1.764.057 3.582-1.614 5.377-2.495-1.544-1.113-2.986-2.98-4.648-3.206-7.599-1.033-15.312-1.282-22.878-2.49-3.38-.539-7.194-1.934-9.636-4.209-11.615-10.821-22.939-21.969-34.056-33.306-1.555-1.587-2.483-5.304-1.718-7.255.879-2.239 3.929-5.07 6.1-5.127 15.506-.395 31.031-.246 46.548.018 2.027.035 4.477 1.254 5.96 2.711 5.968 5.855 11.49 12.164 17.483 17.994 2.027 1.972 6.875 4.599 7.171 4.239 3.084-3.757-.509-6.353-2.664-8.733-3.032-3.344-6.822-5.999-9.931-9.282-1.273-1.344-1.624-3.563-2.391-5.383 1.708-.582 3.411-1.629 5.126-1.649 4.001-.047 8.028.731 12.001.477 1.542-.097 2.966-2.075 4.441-3.196-1.391-1.187-2.693-3.235-4.193-3.396-3.784-.41-7.66.1-11.5.095-1.524 0-3.05-.392-5.461-.728 1.483-2.041 2.107-3.317 3.091-4.176 3.674-3.208 7.698-6.053 11.107-9.51 1.436-1.462 1.672-4.111 2.451-6.22-2.365.375-5.31-.018-6.995 1.259-6.111 4.632-11.971 9.639-17.583 14.87-3.472 3.237-7.205 4.375-11.84 4.352-13.446-.069-26.891.134-40.335.365-3.38.057-6.663.556-8.614-3.211-2.158-4.168-.008-6.781 2.79-9.574 9.404-9.382 18.692-18.882 27.947-28.41 4.477-4.611 9.465-7.287 16.224-6.858 7.307.462 14.673.177 22.008-.015 1.519-.042 3.01-1.108 4.515-1.701-1.243-1.224-2.367-3.329-3.751-3.516-4.98-.67-10.055-.606-15.08-1.003-2.317-.182-4.602-.787-6.903-1.2 1.332-2.085 2.473-4.33 4.047-6.21 1.675-1.996 4.165-3.389 5.533-5.535 1.054-1.651.921-4.065 1.314-6.138-2.161.408-4.406.582-6.443 1.323-.995.362-1.616 1.772-2.388 2.721-2.478 3.032-4.948 6.068-7.422 9.105l-1.987-1.293c-.265-1.631-.708-3.257-.76-4.896-.118-3.673.067-7.356-.079-11.024-.104-2.624.889-6.361-3.144-6.458-1.035-.025-2.923 3.752-3.107 5.894-.626 7.31-.433 14.689-1.056 21.998-.22 2.557-1.28 5.601-3.022 7.374a1211.17 1211.17 0 0 1-32.933 32.293c-1.698 1.603-5.308 2.911-7.131 2.16-1.882-.777-3.694-4.204-3.756-6.52-.347-13.267-.409-26.558-.104-39.831.406-17.658.616-17.631 12.942-30.57 2.158-2.27 4.28-4.675 5.852-7.353.685-1.167-.059-3.175-.156-4.804-1.416.251-3.219.042-4.181.841-2.661 2.219-4.95 4.884-7.429 7.327-1.388 1.365-2.864 2.639-4.889 4.494-.636-2.113-.946-3.221-1.304-4.316-1.138-3.501.813-10.126-3.94-9.782-5.178.375-2.748 6.806-3.28 10.706-.297 2.17-.673 4.33-1.23 7.876-5.684-6.024-10.01-10.769-14.553-15.297-.872-.867-2.595-.874-3.924-1.279-.248 1.431-.884 2.932-.636 4.27.235 1.267 1.255 2.49 2.176 3.509 4.676 5.173 9.634 10.105 14.06 15.478 1.884 2.285 3.787 5.417 3.852 8.207.389 16.442.194 32.898.302 49.349.025 3.727-1.079 7.133-4.792 7.643-2.391.331-5.758-.966-7.563-2.706-11.045-10.641-21.761-21.624-32.601-32.477-3.856-3.863-6.27-8.107-5.587-13.965.726-6.237 1.017-12.559.936-18.836-.025-1.982-1.866-3.942-2.876-5.912-1.136 1.739-2.907 3.355-3.275 5.242-.767 3.914-.744 7.976-1.136 11.97-.174 1.79-.56 3.558-1.092 6.809-4.193-3.424-7.261-6.145-10.58-8.515-1.043-.747-2.756-.549-4.162-.782.008 1.308-.342 2.757.099 3.898.921 2.381 2.26 4.596 4.042 8.084-5.226-.454-9.447-1.128-13.652-1.033-1.606.038-3.171 1.837-4.753 2.831 1.414 1.164 2.695 3.083 4.265 3.36 7.041 1.244 14.216 1.746 21.234 3.091 2.912.559 6.129 1.959 8.223 3.996 12.16 11.816 24.01 23.955 36.012 35.94 2.468 2.463 4.464 4.899 3.079 8.738-1.48 4.094-4.827 3.953-8.207 3.973-16.071.1-32.141.288-48.212.246-1.698-.005-3.835-.869-5.016-2.073-4.625-4.72-8.941-9.743-13.395-14.634-1.869-2.054-3.572-4.378-5.796-5.942-1.056-.738-3.161.02-4.792.1.097 1.431-.325 3.232.384 4.221 2.017 2.818 4.459 5.338 6.8 7.913 2.396 2.637 4.873 5.202 7.315 7.794zm-12.648 80.985c.626-12.067-3.896-19.877-13.827-25.224-11.248-6.056-12.84-12.052-7.545-23.706 4.206-9.259 4.886-17.897-2.743-26.111-5.387-5.802-6.885-12.914-3.564-20.439.767-1.739 2.161-3.526 3.745-4.524 9.097-5.716 13.449-16.358 10.677-26.804-3.142-11.857-1.506-15.675 9.473-21.547 3.691-1.974 7.456-3.837 11.295-5.494 5.77-2.488 8.266-7.123 9.302-12.991.514-2.906 1.094-5.889 2.25-8.574 4.003-9.326 7.785-11.411 17.664-9.782 10.592 1.744 18.927-.941 25.408-10.208 8.046-11.501 17.197-12.693 28.906-4.901 7.619 5.068 13.589 4.916 21.165-.539 11.017-7.935 21.558-5.848 28.84 5.716 4.807 7.628 12.515 11.062 21.456 9.559 12.104-2.031 17.895 1.192 22.445 12.631 1.158 2.906 2.376 5.848 3.025 8.889 1.549 7.276 6.27 11.084 13.127 12.608 12.387 2.752 17.771 10.274 15.172 22.654-2.342 11.159-.501 20.064 9.56 26.971 7.327 5.032 8.444 14.165 3.943 22.026-1.736 3.032-3.607 5.989-5.53 8.904-4.477 6.786-3.705 13.639-.059 20.341 6.57 12.082 4.627 19.077-7.553 25.786-7.446 4.099-13.119 9.164-12.303 18.803.26 3.078-.486 6.263-.951 9.374-1.278 8.515-6.057 12.991-14.622 13.435-13.489.698-21.494 8.138-26.411 20.241-2.772 6.828-7.568 9.453-13.338 8.507-3.612-.59-7.228-1.303-10.741-2.314-8.936-2.577-16.9-1.708-23.232 5.868-.335.4-.731.752-1.104 1.118-7.755 7.597-14.939 8.067-22.997.98-4.096-3.601-7.837-7.625-13.605-8.13-3.83-.333-7.729-.452-11.551-.124-4.814.415-9.59 2.026-14.369 1.962-6.486-.087-10.562-4.327-11.623-10.585-1.225-7.202-9.61-14.838-16.818-15.658-4.321-.492-8.664-1.185-12.863-2.301-7.1-1.89-10.201-7.528-10.102-16.422z"
            }
        ]
    },
    "bold": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 6a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-1.06 2.5A3.49 3.49 0 0 1 13 18H8.5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Zm0 7H9.5v3H13a1.5 1.5 0 0 0 0-3Zm0-5H9.5v3H13a1.5 1.5 0 0 0 0-3Z"
            }
        ]
    },
    "bookmark-full": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16 2H8a3 3 0 0 0-3 3v16a1 1 0 0 0 1.5.87l5.5-3.18 5.5 3.18a1 1 0 0 0 .5.13 1 1 0 0 0 .5-.13A1 1 0 0 0 19 21V5a3 3 0 0 0-3-3Z"
            }
        ]
    },
    "bookmark": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16 2a3 3 0 0 1 3 3v16a1 1 0 0 1-.5.87 1 1 0 0 1-.5.13 1 1 0 0 1-.5-.13L12 18.69l-5.5 3.18A1 1 0 0 1 5 21V5a3 3 0 0 1 3-3Zm0 2H8a1 1 0 0 0-1 1v14.27l4.5-2.6a1 1 0 0 1 1 0l4.5 2.6V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "bookmarks-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 6a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M15 2a3 3 0 0 1 2.995 2.824L18 5v10a3 3 0 0 1-2.824 2.995L15 18H5a3 3 0 0 1-2.995-2.824L2 15V5a3 3 0 0 1 2.824-2.995L5 2h10ZM8 4H5a1 1 0 0 0-.993.883L4 5v10a1 1 0 0 0 .883.993L5 16h10a1 1 0 0 0 .993-.883L16 15V5a1 1 0 0 0-.883-.993L15 4h-1v7a1 1 0 0 1-.58.91 1 1 0 0 1-.956-.066l-.114-.084L11 10.63l-1.35 1.13a1 1 0 0 1-1.642-.631L8 11V4Zm4 0h-2v4.86l.36-.3a1 1 0 0 1 1.28 0l.36.3V4Z"
            }
        ]
    },
    "books-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M22.346 19.5H1.654a.897.897 0 0 0-.904.888v.147c0 .49.406.888.904.888h2.865c-.004.032-.01.063-.01.096v.904c0 .455.378.827.84.827h.237c.462 0 .84-.372.84-.827v-.904c0-.033-.006-.064-.01-.096h11.192c-.004.032-.01.063-.01.096v.904c0 .455.378.827.84.827h.237c.463 0 .84-.372.84-.827v-.904c0-.033-.005-.064-.01-.096h2.841a.897.897 0 0 0 .904-.888v-.147a.897.897 0 0 0-.904-.888"
            },
            {
                "d": "M7.276.75c.499 0 .911.342.967.78l.007.104v14.733c0 .453-.377.826-.86.877l-.114.006H3.224c-.499 0-.911-.341-.967-.78l-.007-.103V1.634c0-.453.377-.827.86-.878L3.224.75h4.052Zm-.561 12.717h-2.93c-.317 0-.574.234-.574.52 0 .259.208.474.48.514l.094.007h2.93c.316 0 .574-.233.574-.52 0-.287-.258-.52-.574-.52Zm0-1.788h-2.93c-.317 0-.574.233-.574.52 0 .288.257.521.574.521h2.93c.316 0 .574-.233.574-.52 0-.288-.258-.52-.574-.52Zm0-8.18h-2.93c-.317 0-.574.233-.574.52 0 .287.257.52.574.52h2.93c.316 0 .574-.233.574-.52 0-.287-.258-.52-.574-.52ZM20.1 3.75c.496 0 .9.39.9.867v11.766c0 .478-.404.867-.9.867h-1.95c-.496 0-.9-.389-.9-.867V4.617c0-.478.404-.867.9-.867Zm-.531 9.783h-.888a.522.522 0 0 0-.531.511c0 .282.239.511.531.511h.888a.522.522 0 0 0 .531-.51.522.522 0 0 0-.531-.512Zm0-1.755h-.888a.522.522 0 0 0-.531.51c0 .283.239.512.531.512h.888c.292 0 .531-.23.531-.511a.522.522 0 0 0-.531-.511Zm0-5.351h-.888a.522.522 0 0 0-.531.51c0 .283.239.512.531.512h.888c.292 0 .531-.23.531-.511a.522.522 0 0 0-.531-.511ZM14.776.75c.537 0 .974.396.974.884v14.733c0 .487-.437.883-.974.883h-4.052c-.537 0-.974-.396-.974-.883V1.634c0-.488.437-.884.974-.884Zm-.561 12.714h-2.93c-.316 0-.574.234-.574.52 0 .288.258.521.574.521h2.93c.316 0 .574-.233.574-.52 0-.287-.258-.521-.574-.521Zm0-1.788h-2.93c-.316 0-.574.234-.574.52 0 .288.258.521.574.521h2.93c.316 0 .574-.233.574-.52 0-.287-.258-.52-.574-.52Zm0-8.18h-2.93c-.316 0-.574.233-.574.52 0 .287.258.52.574.52h2.93c.316 0 .574-.233.574-.52 0-.287-.258-.52-.574-.52Z"
            }
        ]
    },
    "books": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16.89 3.031a.955.955 0 0 1 1.165.673l3.007 10.98.955 3.657a.988.988 0 0 1-.067.672.954.954 0 0 1-.582.446l-4.61 1.222a1.152 1.152 0 0 1-.249 0 .954.954 0 0 1-.954-.701l-2.1-7.788v7.58a.951.951 0 0 1-.955.947H2.955A.951.951 0 0 1 2 19.77V4.613a.95.95 0 0 1 .955-.947H12.5a.958.958 0 0 1 .697.313ZM6.745 16.967H3.88v1.895h2.864v-1.895Zm4.773 0H8.653v1.895h2.864v-1.895Zm7.846-.881-2.768.739.496 1.828 2.769-.739-.497-1.828ZM6.744 9.388H3.88v5.684h2.864V9.388Zm4.773 0H8.653v5.684h2.864V9.388Zm5.908-.625-2.768.739 1.48 5.494 2.768-.738-1.48-5.495Zm-.992-3.657-2.768.739.496 1.828 2.768-.739-.496-1.828Zm-9.689.493H3.88v1.894h2.864V5.6Zm4.773 0H8.653v1.894h2.864V5.6Z"
            }
        ]
    },
    "briefcase-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 2.5a3 3 0 0 1 3 3v1h3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3v-1a3 3 0 0 1 3-3ZM20 13a21.27 21.27 0 0 1-3 .94v.59a1 1 0 0 1-2 0v-.21a23 23 0 0 1-3 .21 23 23 0 0 1-3-.21v.21a1 1 0 0 1-2 0v-.59A21.27 21.27 0 0 1 4 13v5.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1Zm-1-4.5H5a1 1 0 0 0-1 1v1.33c.973.41 1.976.745 3 1v-.33a1 1 0 0 1 2 0v.74c1.989.3 4.011.3 6 0v-.74a1 1 0 0 1 2 0v.31a20.39 20.39 0 0 0 3-1V9.5a1 1 0 0 0-1-1Zm-6-4h-2a1 1 0 0 0-1 1v1h4v-1a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "briefcase": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 2.5a3 3 0 0 1 3 3v1h3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3v-1a3 3 0 0 1 3-3ZM20 13a21.27 21.27 0 0 1-3 .94v.59a1 1 0 0 1-2 0v-.21a23 23 0 0 1-3 .21 23 23 0 0 1-3-.21v.21a1 1 0 0 1-2 0v-.59A21.27 21.27 0 0 1 4 13v5.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1Zm-1-4.5H5a1 1 0 0 0-1 1v1.33c.973.41 1.976.745 3 1v-.33a1 1 0 0 1 2 0v.74c1.989.3 4.011.3 6 0v-.74a1 1 0 0 1 2 0v.31a20.39 20.39 0 0 0 3-1V9.5a1 1 0 0 0-1-1Zm-6-4h-2a1 1 0 0 0-1 1v1h4v-1a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "brush-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M23.791 23.8c-1.02.978-5.495-1.723-9.989-6.032a44.487 44.487 0 0 1-2.851-2.983C8.203 11.637 6.734 8.945 7.51 8.2c.778-.746 3.604.662 6.905 3.314a44.183 44.183 0 0 1 3.085 2.71c4.493 4.308 7.31 8.6 6.29 9.577"
            },
            {
                "d": "M.207 0a10.05 10.05 0 0 0 .38 5.413c.48 1.325 1.408 2.48 2.654 3.298 1.497.972 4.44 2.199 5.706.27.78-1.185.442-2.985-.304-4.115-.75-1.122-2.034-1.863-3.471-2a23.984 23.984 0 0 1-2.525-.144C1.37 2.455-.08 1.306.207 0"
            }
        ]
    },
    "brush": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
            },
            {
                "d": "M18 1a1 1 0 0 1 .993.883L19 2v9a3 3 0 0 1-2.824 2.995L16 14h-1v2.37a4 4 0 1 1-6.141.17L9 16.37V14H8a3 3 0 0 1-2.995-2.824L5 11V2a1 1 0 0 1 .883-.993L6 1h12Zm-5 13h-2v2.78a1 1 0 0 1-.33.74A2 2 0 0 0 12 21a2 2 0 0 0 1.33-3.48 1 1 0 0 1-.323-.62L13 16.78V14Zm4-4H7v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1Zm0-7H7v5h10V3Z"
            }
        ]
    },
    "bug": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 14h2a1 1 0 0 0 0-2h-2v-1a5.15 5.15 0 0 0-.21-1.36A5 5 0 0 0 22 5a1 1 0 0 0-2 0 3 3 0 0 1-2.14 2.87A5 5 0 0 0 16 6.4a2.58 2.58 0 0 0 0-.4 4 4 0 0 0-8 0 2.58 2.58 0 0 0 0 .4 5 5 0 0 0-1.9 1.47A3 3 0 0 1 4 5a1 1 0 0 0-2 0 5 5 0 0 0 3.21 4.64A5.15 5.15 0 0 0 5 11v1H3a1 1 0 0 0 0 2h2v1a7 7 0 0 0 .14 1.38A5 5 0 0 0 2 21a1 1 0 0 0 2 0 3 3 0 0 1 1.81-2.74 7 7 0 0 0 12.38 0A3 3 0 0 1 20 21a1 1 0 0 0 2 0 5 5 0 0 0-3.14-4.62A7 7 0 0 0 19 15Zm-8 5.9A5 5 0 0 1 7 15v-4a3 3 0 0 1 3-3h1ZM10 6a2 2 0 0 1 4 0Zm7 9a5 5 0 0 1-4 4.9V8h1a3 3 0 0 1 3 3Z"
            }
        ]
    },
    "burger": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 8h18a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm18 8H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Zm0-5H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "calendar-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 1c.6 0 1 .4 1 1v1h1c1.7 0 3 1.3 3 3v14c0 1.7-1.3 3-3 3H5c-1.7 0-3-1.3-3-3V6c0-1.7 1.3-3 3-3h1V2c0-.6.4-1 1-1s1 .4 1 1v1h8V2c0-.6.4-1 1-1Zm3 10H4v9c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-9ZM6 5H5c-.6 0-1 .4-1 1v3h16V6c0-.6-.4-1-1-1h-1v1c0 .6-.4 1-1 1s-1-.4-1-1V5H8v1c0 .6-.4 1-1 1s-1-.4-1-1V5Z"
            },
            {
                "d": "M7.5 16c.8 0 1.5-.7 1.5-1.5S8.3 13 7.5 13 6 13.7 6 14.5 6.7 16 7.5 16Z"
            }
        ]
    },
    "calendar-slash": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.69 7.455h3.037v.909a.91.91 0 0 0 1.818 0v-.91h.91a.91.91 0 0 1 .909.91v2.727h-1.219a.91.91 0 0 0 0 1.818h1.219v1.218a.91.91 0 1 0 1.818 0V8.364a2.727 2.727 0 0 0-2.727-2.728h-.91v-.909a.91.91 0 1 0-1.818 0v.91h-3.036a.91.91 0 1 0 0 1.818ZM3.582 2.936a.913.913 0 0 1 .882.237l14.909 14.909 1.454 1.454a.91.91 0 1 1-1.29 1.282l-.91-.909c-.365.177-.766.27-1.172.273H6.545a2.727 2.727 0 0 1-2.727-2.727V8.364A2.727 2.727 0 0 1 4.91 6.19L3.173 4.464a.913.913 0 0 1 .409-1.528Zm8.045 9.973h-5.99v4.546c0 .502.406.909.908.909h10.537l-5.455-5.455Zm-5.39-5.39a.91.91 0 0 0-.6.845v2.727h4.172Z"
            }
        ]
    },
    "calendar": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16 2a1 1 0 0 1 1 1v1h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h2V3a1 1 0 1 1 2 0v1h6V3a1 1 0 0 1 1-1Zm4 10H4v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7ZM7 6H5a1 1 0 0 0-1 1v3h16V7a1 1 0 0 0-1-1h-2v1a1 1 0 0 1-2 0V6H9v1a1 1 0 1 1-2 0V6Z"
            }
        ]
    },
    "call": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8.19 7c2.137 0 3.87 1.844 3.87 4.118 0 1.176-.48 2.294-1.316 3.063 2.212 1.066 3.634 3.41 3.636 5.995 0 .455-.346.824-.773.824-.428 0-.774-.369-.774-.824 0-2.728-2.079-4.94-4.643-4.94-2.564 0-4.642 2.212-4.642 4.94 0 .455-.347.824-.774.824-.428 0-.774-.369-.774-.824.002-2.584 1.424-4.929 3.637-5.995-.836-.77-1.316-1.887-1.316-3.063C4.321 8.844 6.053 7 8.191 7Zm0 1.647c-1.282 0-2.321 1.106-2.321 2.47 0 1.365 1.04 2.471 2.321 2.471.616 0 1.206-.26 1.642-.723.435-.464.68-1.092.68-1.747 0-1.365-1.04-2.47-2.322-2.47ZM20.65 3.9h-.9v-.45a.45.45 0 0 0-.9 0v.45h-2.7v-.45a.45.45 0 0 0-.9 0v.45h-.9A1.35 1.35 0 0 0 13 5.25v5.4c0 .746.604 1.35 1.35 1.35h6.3A1.35 1.35 0 0 0 22 10.65v-5.4a1.35 1.35 0 0 0-1.35-1.35Zm.083 6.353a.45.45 0 0 1-.45.45h-5.549a.45.45 0 0 1-.45-.45v-2.43h6.449v2.43ZM20.705 6.6h-6.48V5.418a.45.45 0 0 1 .45-.45h.575v.45a.45.45 0 0 0 .9 0v-.45h2.7v.45a.45.45 0 0 0 .9 0v-.45h.505a.45.45 0 0 1 .45.45V6.6Z"
            }
        ]
    },
    "call_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.225 21.12C2.359 21.123 2 20.723 2 20.156 2 16.756 4.708 14 8.047 14c3.34 0 6.048 2.756 6.048 6.156 0 .567-.284.988-1.228.974-.944-.013-8.777-.014-9.642-.01ZM8.1 13.2a3.1 3.1 0 1 1 0-6.2 3.1 3.1 0 0 1 0 6.2Zm14.119-9.894h-1.237v-.619a.619.619 0 1 0-1.238 0v.62h-3.712v-.62a.619.619 0 0 0-1.238 0v.62h-1.237 8.662Zm.114 7.322c0 .363-.277.657-.619.657h-7.629c-.341 0-.618-.294-.618-.657v-3.55h8.866v3.55Zm-.053-4.719h-8.909l.014-1.89a.62.62 0 0 1 .62-.62h.79v.62a.619.619 0 0 0 1.237 0v-.62h3.712v.62a.619.619 0 1 0 1.238 0v-.62h.694c.342 0 .619.277.619.62l-.015 1.89Z"
            }
        ]
    },
    "camera": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M14.56 3.5a3 3 0 0 1 2.77 1.823l.07.177.32 1H19a3 3 0 0 1 2.997 2.85l.003.2v8a3 3 0 0 1-2.824 2.995L19 20.55H5a3 3 0 0 1-2.995-2.824L2 17.55v-8a3 3 0 0 1 2.824-2.995L5 6.55h1.28l.32-1a3 3 0 0 1 2.648-2.044L9.44 3.5h5.12Zm.05 2H9.49a1 1 0 0 0-.902.562l-.048.118L8 7.82a1 1 0 0 1-.879.679L7 8.5H5a1 1 0 0 0-.993.883L4 9.5v8a1 1 0 0 0 .883.993L5 18.5h14a1 1 0 0 0 .993-.883L20 17.5v-8a1 1 0 0 0-.883-.993L19 8.5h-2a1 1 0 0 1-.854-.567L16.1 7.82l-.54-1.64a1 1 0 0 0-.95-.68ZM12 8.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "cart": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a4 4 0 0 1 4 4v1h3a1 1 0 0 1 1 1v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8a1 1 0 0 1 1-1h3V6a4 4 0 0 1 4-4ZM8 9H6v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9h-2v1a1 1 0 0 1-2 0V9h-4v1a1 1 0 0 1-2 0V9Zm4-5a2 2 0 0 0-2 2v1h4V6a2 2 0 0 0-2-2Z"
            }
        ]
    },
    "chart-line": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8 16a1.5 1.5 0 0 0 1.5-1.5.77.77 0 0 0 0-.15l2.79-2.79h.46l1.61 1.61v.08a1.5 1.5 0 0 0 3 0v-.08L21 9.5A1.5 1.5 0 1 0 19.5 8a.77.77 0 0 0 0 .15l-3.61 3.61h-.16L14 10a1.5 1.5 0 0 0-3 0l-3 3a1.5 1.5 0 0 0 0 3Z"
            },
            {
                "d": "M21.5 20h-17V3a1 1 0 1 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "chart-pie-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 12h-7V5c0-.6-.4-1-1-1-5 0-9 4-9 9s4 9 9 9 9-4 9-9c0-.6-.4-1-1-1Zm-7 7.9c-3.8.6-7.4-2.1-7.9-5.9-.6-3.8 2.1-7.4 5.9-7.9V13c0 .6.4 1 1 1h6.9c-.4 3.1-2.8 5.5-5.9 5.9ZM15 2c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h6c.6 0 1-.4 1-1 0-3.9-3.1-7-7-7Zm1 6V4.1c2 .4 3.5 1.9 3.9 3.9H16Z"
            }
        ]
    },
    "check-round": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.454 6.378a1.504 1.504 0 0 0-.911.426l-7.07 6.952-2.767-2.726a1.535 1.535 0 0 0-1.474-.367 1.508 1.508 0 0 0-1.057 1.077 1.488 1.488 0 0 0 .421 1.447l3.82 3.75a1.505 1.505 0 0 0 2.117-.001l8.126-7.981a1.47 1.47 0 0 0-.015-2.165 1.49 1.49 0 0 0-1.042-.42l-.148.008Z"
            }
        ]
    },
    "check": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19.633 7.318A1.172 1.172 0 0 0 18.825 7c-.303 0-.594.115-.808.318l-8.482 8.028-3.563-3.379a1.211 1.211 0 0 0-1.13-.266c-.399.108-.707.41-.807.791a1.06 1.06 0 0 0 .32 1.057l4.372 4.133c.214.203.505.318.808.318.304 0 .595-.115.809-.318l9.29-8.782A1.05 1.05 0 0 0 20 8.11a1.05 1.05 0 0 0-.367-.792Z"
            }
        ]
    },
    "checkbox-check": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm-5.926 7.338-3.788 3.885-1.36-1.402a1.11 1.11 0 0 0-1.595 0 1.172 1.172 0 0 0 0 1.632l2.157 2.207a1.11 1.11 0 0 0 1.596 0l4.585-4.69a1.172 1.172 0 0 0 0-1.632 1.11 1.11 0 0 0-1.595 0Z"
            }
        ]
    },
    "checkbox-empty": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm-1 2H4v16h16V4Z"
            }
        ]
    },
    "city": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M14 8h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2Zm0 4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2ZM9 8h1a1 1 0 0 0 0-2H9a1 1 0 1 0 0 2Zm0 4h1a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2Zm12 8h-1V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Zm-8 0h-2v-4h2v4Zm5 0h-3v-5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5H6V4h12v16Z"
            }
        ]
    },
    "clip_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.893 2.89a3.238 3.238 0 0 0-4.46 0L4.352 12.97a5.355 5.355 0 0 0 .215 7.344c2.005 2.005 5.832 2.087 7.951.203l7.434-7.419c.192-.77-.011-1.185-.3-1.432-.45-.382-.967-.387-1.553-.016l-6.2 6.21a3.553 3.553 0 0 1-4.902 0 3.452 3.452 0 0 1 0-4.902l6.464-6.477a1.265 1.265 0 0 1 1.79 1.79l-6.464 6.451a.963.963 0 0 0 1.41 1.31l8.695-8.681a3.175 3.175 0 0 0 0-4.46Z"
            }
        ]
    },
    "clock-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 6a1 1 0 0 0-1 1v4.384l-2.43 1.223a1 1 0 1 0 .898 1.786l2.981-1.5A.999.999 0 0 0 13 12V7a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M12 2c5.52.006 9.994 4.48 10 10 0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8.01 8.01 0 0 0 8-8 8 8 0 0 0-8-8Z"
            }
        ]
    },
    "clock": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15 11h-2V7a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h3a1 1 0 0 0 0-2Z"
            },
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            }
        ]
    },
    "close": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.968 6.416 13.4 11.984l5.568 5.568-1.416 1.416-5.568-5.568-5.568 5.568L5 17.552l5.568-5.568L5 6.416 6.416 5l5.568 5.568L17.552 5z"
            },
            {
                "d": "m13.41 12 6.3-6.29a1.004 1.004 0 1 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 0 0-1.42 1.42l6.3 6.29-6.3 6.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L13.41 12Z"
            }
        ]
    },
    "code": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8.38 13.08A1 1 0 0 0 7 14a1 1 0 0 0 1.38.92 1.15 1.15 0 0 0 .33-.21A1 1 0 0 0 9 14a1 1 0 0 0-.29-.71.93.93 0 0 0-.33-.21ZM18 13h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm-3 0h-4a1 1 0 1 0 0 2h4a1 1 0 0 0 0-2Zm3-4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm2-4H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3Zm1 11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8Zm-9.29-6.71A1 1 0 0 0 10 10a1 1 0 1 0 1.92-.38 1 1 0 0 0-.21-.33Z"
            }
        ]
    },
    "coins": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11 3a3 3 0 0 1 2.882 3.802L13.82 7H19a3 3 0 0 1 3 3 3 3 0 0 1-.78 2 3 3 0 0 1 0 4 3 3 0 0 1-2.024 4.993L19 21H5a3 3 0 0 1-3-3 3 3 0 0 1 .78-2 3 3 0 0 1 0-4 3 3 0 0 1 0-4A3 3 0 0 1 2 6a3 3 0 0 1 2.824-2.995L5 3h6Zm0 14H5a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm8 0h-5.18a2.87 2.87 0 0 1 0 2H19a.93.93 0 0 0 .69-.29A1 1 0 0 0 20 18a1 1 0 0 0-1-1Zm-8-4H5a1 1 0 0 0-.117 1.993L5 15h6a1 1 0 0 0 0-2Zm8 0h-5.18a2.87 2.87 0 0 1 .071 1.783L13.82 15H19a.93.93 0 0 0 .69-.29A1 1 0 0 0 20 14a1 1 0 0 0-1-1Zm-8-4H5a1 1 0 0 0-.117 1.993L5 11h6a1 1 0 0 0 0-2Zm8 0h-5.18a2.87 2.87 0 0 1 .071 1.783L13.82 11H19a.93.93 0 0 0 .69-.29A1 1 0 0 0 20 10a1 1 0 0 0-1-1Zm-8-4H5a1 1 0 0 0-.117 1.993L5 7h6a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "comment-alt-lines": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 11H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-4H7a1 1 0 1 0 0 2h10a1 1 0 0 0 0-2Zm2-5H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71a1 1 0 0 0 1.09.21A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1 1 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z"
            }
        ]
    },
    "comment-full": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19.143 2H4.857A2.866 2.866 0 0 0 2 4.857v10a2.866 2.866 0 0 0 2.857 2.857h1.429v2.857C6.286 21.51 7.1 22 7.714 22c.503 0 .782-.167 1.429-.737l4.286-3.549h5.714A2.866 2.866 0 0 0 22 14.857v-10A2.866 2.866 0 0 0 19.143 2Z"
            }
        ]
    },
    "comment": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 2a3 3 0 0 1 3 3v16a1 1 0 0 1-.62.92 1 1 0 0 1-1.09-.21L16.59 18H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm0 2H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 1 .71.29l2.29 2.3V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "comments-alt-hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M5.285 2C3.142 2 2 3.373 2 5.285v11.572C2 17.607 2.509 18 3 18c.402 0 .537-.132 1.055-.588l2.465-2.521.625-.002.001-5.053.004-.201C7.22 7.923 8.2 7 9.885 7h7.959V4.697C17.844 3.02 16.41 2 15.213 2H5.285zm5.461 6c-1.82 0-2.61.929-2.61 2.646v6.633c0 1.1.9 2 2 2h7.909l2.16 2.205c.452.4.569.516.921.516.43 0 .875-.344.875-1V10.875C22 9.202 21 8 19.125 8h-8.379z"
            }
        ]
    },
    "comments-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15 2a3 3 0 0 1 3 3v3h1a3 3 0 0 1 3 3v10a1 1 0 0 1-.62.92 1 1 0 0 1-1.09-.21l-2.37-2.38H11a3 3 0 0 1-3-3v-1.44H6.52l-2.81 2.82a1 1 0 0 1-1.09.21A1 1 0 0 1 2 17V5a3 3 0 0 1 3-3Zm4 8h-8a1 1 0 0 0-1 1v5.29a1 1 0 0 0 1 1h7.29a1 1 0 0 1 .71.3l1 1V11a1 1 0 0 0-1-1Zm-4-6H5a1 1 0 0 0-1 1v9.59l1.4-1.41a1 1 0 0 1 .71-.29H8V11a3 3 0 0 1 3-3h5V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "comments-notification": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15 2a3 3 0 0 1 3 3v3h1a3 3 0 0 1 3 3v10a1 1 0 0 1-.62.92 1 1 0 0 1-1.09-.21l-2.37-2.38H11a3 3 0 0 1-3-3v-1.44H6.52l-2.81 2.82a1 1 0 0 1-1.09.21A1 1 0 0 1 2 17V5a3 3 0 0 1 3-3Zm4 8h-8a1 1 0 0 0-1 1v5.29a1 1 0 0 0 1 1h7.29a1 1 0 0 1 .71.3l1 1V11a1 1 0 0 0-1-1Zm-4-6H5a1 1 0 0 0-1 1v9.59l1.4-1.41a1 1 0 0 1 .71-.29H8V11a3 3 0 0 1 3-3h5V5a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M24 22a2 2 0 0 1-2 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2 2 2 0 0 1 2 2z"
            }
        ]
    },
    "config": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13.5 2a1 1 0 0 1 .94.68l.63 1.89 1.78-.89a1 1 0 0 1 1.15.19L20.13 6a1 1 0 0 1 .19 1.14l-.89 1.78 1.89.63a1 1 0 0 1 .68.95v3a1 1 0 0 1-.68.94l-1.89.63.89 1.78a1 1 0 0 1-.19 1.15L18 20.13a1 1 0 0 1-1.13.19l-1.78-.89-.63 1.89a1 1 0 0 1-.95.68h-3a1 1 0 0 1-.95-.68l-.63-1.89-1.78.89A1 1 0 0 1 6 20.13L3.87 18a1 1 0 0 1-.19-1.14l.89-1.78-1.89-.63A1 1 0 0 1 2 13.5v-3a1 1 0 0 1 .68-.94l1.89-.63-.89-1.78A1 1 0 0 1 3.87 6L6 3.87a1 1 0 0 1 1.14-.19l1.78.89.63-1.89A1 1 0 0 1 10.5 2Zm-.72 2h-1.56l-.4 1.2A2 2 0 0 1 8 6.36l-1.11-.57-1.1 1.1L6.36 8a2 2 0 0 1-1.16 2.82l-1.2.4v1.56l1.2.4A2 2 0 0 1 6.36 16l-.6 1.11 1.1 1.1L8 17.64a2 2 0 0 1 2.82 1.16l.4 1.2h1.59l.4-1.2A2 2 0 0 1 16 17.64l1.11.6 1.1-1.1-.57-1.14a2 2 0 0 1 1.16-2.82l1.2-.4v-1.59l-1.2-.4A2 2 0 0 1 17.64 8l.6-1.11-1.1-1.1-1.14.57a2 2 0 0 1-2.82-1.16l-.4-1.2Z"
            },
            {
                "d": "M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "config_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13.5 2a1 1 0 0 1 .94.68l.63 1.89 1.78-.89a1 1 0 0 1 1.15.19L20.13 6a1 1 0 0 1 .19 1.14l-.89 1.78 1.89.63a1 1 0 0 1 .68.95v3a1 1 0 0 1-.68.94l-1.89.63.89 1.78a1 1 0 0 1-.19 1.15L18 20.13a1 1 0 0 1-1.13.19l-1.78-.89-.63 1.89a1 1 0 0 1-.95.68h-3a1 1 0 0 1-.95-.68l-.63-1.89-1.78.89A1 1 0 0 1 6 20.13L3.87 18a1 1 0 0 1-.19-1.14l.89-1.78-1.89-.63A1 1 0 0 1 2 13.5v-3a1 1 0 0 1 .68-.94l1.89-.63-.89-1.78A1 1 0 0 1 3.87 6L6 3.87a1 1 0 0 1 1.14-.19l1.78.89.63-1.89A1 1 0 0 1 10.5 2h3ZM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
            }
        ]
    },
    "copy": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M14.05 2a.88.88 0 0 1 .33.11.32.32 0 0 1 .09 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V15a3 3 0 0 1-3 3h-1v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1V5a3 3 0 0 1 3-3ZM7 8H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h-5a3 3 0 0 1-3-3V8Zm6-4h-3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h-3a3 3 0 0 1-3-3V4Zm2 1.41V7a1 1 0 0 0 1 1h1.59L15 5.41Z"
            }
        ]
    },
    "corner-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.624 8.549H6.832l1.463-1.524a1.228 1.228 0 0 0 0-1.678 1.092 1.092 0 0 0-1.598 0L3.32 8.892a1.19 1.19 0 0 0-.237.39 1.24 1.24 0 0 0 0 .897c.054.145.134.278.237.39l3.376 3.544a1.1 1.1 0 0 0 .799.35c.3 0 .587-.126.799-.35.213-.222.333-.524.333-.839 0-.315-.12-.616-.333-.838l-1.463-1.524h10.792c.621 0 1.125.529 1.125 1.181v4.726c0 .652.504 1.181 1.126 1.181.621 0 1.125-.529 1.125-1.181v-4.726c0-1.957-1.512-3.544-3.376-3.544Z"
            }
        ]
    },
    "corner-right": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M6.376 8.549h10.792l-1.463-1.524a1.228 1.228 0 0 1 0-1.678 1.092 1.092 0 0 1 1.598 0l3.376 3.545c.103.112.183.244.237.39.112.287.112.61 0 .897a1.19 1.19 0 0 1-.237.39l-3.376 3.544a1.1 1.1 0 0 1-.799.35 1.1 1.1 0 0 1-.799-.35 1.212 1.212 0 0 1-.333-.839c0-.315.12-.616.333-.838l1.463-1.524H6.376c-.621 0-1.125.529-1.125 1.181v4.726C5.25 17.47 4.747 18 4.125 18 3.504 18 3 17.471 3 16.819v-4.726C3 10.136 4.512 8.55 6.376 8.55Z"
            }
        ]
    },
    "coursing": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Z"
            }
        ]
    },
    "crop": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M5.188.235a2.156 2.156 0 0 0-2.106 2.154v.693h-.693A2.157 2.157 0 0 0 .234 5.237c0 1.188.967 2.156 2.155 2.156h.693v11.371c0 1.189.966 2.154 2.154 2.154H16.61v.694c0 1.188.967 2.154 2.155 2.154a2.157 2.157 0 0 0 2.154-2.154v-.694h.693c1.414 0 2.155-1.084 2.155-2.154 0-1.071-.74-2.154-2.155-2.154h-.693V5.633l2.24-2.236a1.8 1.8 0 0 0-.012-2.545 1.89 1.89 0 0 0-1.279-.527 1.782 1.782 0 0 0-1.258.53l-2.216 2.227H7.39V2.39A2.148 2.148 0 0 0 5.299.235h-.112zm.013 1.46h.035c.382 0 .694.312.694.694v.693H4.543V2.39c0-.37.293-.675.658-.693zm16.668.089a.382.382 0 0 1 .25.103.333.333 0 0 1 .098.238c0 .09-.035.176-.098.239l-1.611 1.61a2.116 2.116 0 0 0-.475-.474l1.613-1.62a.318.318 0 0 1 .223-.096zM2.354 4.545h16.41c.382 0 .693.31.693.692v16.375a.693.693 0 1 1-1.385 0V6.662a.734.734 0 0 0-.732-.732H2.389a.694.694 0 0 1-.035-1.385zm2.189 2.848H5.93v9.947c0 .404.327.73.73.73h9.95v1.387H5.235a.695.695 0 0 1-.693-.693zm2.848 0h6.71l-6.71 6.74zm8.77 0h.448v.478L7.867 16.61h-.476v-.405zm.448 2.549v6.668H9.936Zm4.309 8.129h.693c.511 0 .692.373.692.693 0 .319-.18.693-.692.693h-.693z"
            }
        ]
    },
    "cross_fat": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.895 4.145a1.62 1.62 0 0 1 2.291 0L11.75 9.71l5.564-5.564a1.62 1.62 0 0 1 2.29 2.291L14.042 12l5.564 5.564a1.62 1.62 0 0 1 .105 2.175l-.105.116a1.62 1.62 0 0 1-2.291 0L11.75 14.29l-5.564 5.564a1.62 1.62 0 0 1-2.29-2.291L9.458 12 3.895 6.436a1.62 1.62 0 0 1-.105-2.175Z"
            }
        ]
    },
    "crosshair": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 11h-1.07A8 8 0 0 0 13 4.07V3a1 1 0 0 0-2 0v1.07A8 8 0 0 0 4.07 11H3a1 1 0 0 0 0 2h1.07A8 8 0 0 0 11 19.93V21a1 1 0 0 0 2 0v-1.07A8 8 0 0 0 19.93 13H21a1 1 0 0 0 0-2Zm-4 2h.91A6 6 0 0 1 13 17.91V17a1 1 0 0 0-2 0v.91A6 6 0 0 1 6.09 13H7a1 1 0 0 0 0-2h-.91A6 6 0 0 1 11 6.09V7a1 1 0 0 0 2 0v-.91A6 6 0 0 1 17.91 11H17a1 1 0 0 0 0 2Zm-5-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
            }
        ]
    },
    "dailymotion": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13.551 11.485a2.327 2.327 0 0 0-2.328 2.332c0 1.314 1.013 2.313 2.441 2.313l-.012.002c1.192 0 2.193-.983 2.193-2.28.001-1.349-1.001-2.367-2.294-2.367z"
            },
            {
                "d": "M3 3v18h18V3H3zm15.52 15.605h-2.682v-1.058c-.825.81-1.667 1.103-2.786 1.103-1.142 0-2.124-.371-2.947-1.114-1.086-.956-1.648-2.227-1.648-3.701 0-1.351.524-2.561 1.507-3.506.878-.859 1.946-1.298 3.139-1.298 1.14 0 2.018.385 2.647 1.192V6.118l2.77-.574v-.002l.002.003h-.002v13.06z"
            }
        ]
    },
    "dashboard": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M4.955 4.911c3.895-3.881 10.195-3.881 14.09 0 .008.008.018.01.026.018.007.007.01.018.017.026 3.891 3.91 3.881 10.233-.023 14.13-3.904 3.898-10.226 3.898-14.13 0-3.904-3.897-3.914-10.22-.023-14.13.007-.008.01-.019.017-.026.008-.008.018-.01.026-.018ZM9.78 17H5.765A7.985 7.985 0 0 0 12 20a7.985 7.985 0 0 0 6.235-3H14.22a2.964 2.964 0 0 1-4.44 0ZM12 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm1-9.93V5a1 1 0 0 1-2 0v-.93a7.952 7.952 0 0 0-3.897 1.618l.654.655a1 1 0 1 1-1.414 1.414l-.655-.655A7.951 7.951 0 0 0 4.07 11H5a1 1 0 1 1 0 2h-.93c.085.687.26 1.36.52 2.002L4.6 15H9a2.995 2.995 0 0 1 2-2.816V9a1 1 0 1 1 2 0v3.184A2.995 2.995 0 0 1 15 15h4.4l.01.002A7.93 7.93 0 0 0 19.93 13H19a1 1 0 0 1 0-2h.93a7.951 7.951 0 0 0-1.619-3.898l-.654.655a1 1 0 0 1-1.414-1.414l.654-.655A7.952 7.952 0 0 0 13 4.07Z"
            }
        ]
    },
    "debug": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 14h2a1 1 0 0 0 0-2h-2v-1a5.15 5.15 0 0 0-.21-1.36A5 5 0 0 0 22 5a1 1 0 1 0-2 0 3 3 0 0 1-2.14 2.87A5 5 0 0 0 16 6.4a2.58 2.58 0 0 0 0-.4 4 4 0 1 0-8 0 2.58 2.58 0 0 0 0 .4 5 5 0 0 0-1.9 1.47A3 3 0 0 1 4 5a1 1 0 1 0-2 0 5 5 0 0 0 3.21 4.64c-.13.442-.201.9-.21 1.36v1H3a1 1 0 1 0 0 2h2v1a7 7 0 0 0 .14 1.38A5 5 0 0 0 2 21a1 1 0 0 0 2 0 3 3 0 0 1 1.81-2.74 7 7 0 0 0 12.38 0A3 3 0 0 1 20 21a1 1 0 0 0 2 0 5 5 0 0 0-3.14-4.62A7 7 0 0 0 19 15v-1Zm-8 5.9A5 5 0 0 1 7 15v-4a3 3 0 0 1 3-3h1v11.9ZM10 6a2 2 0 1 1 4 0h-4Zm7 9a5 5 0 0 1-4 4.9V8h1a3 3 0 0 1 3 3v4Z"
            }
        ]
    },
    "desktop": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-6v2h4a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Zm0 2H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "directory": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 6a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M15 2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm-1.25 2h-7.5A2.25 2.25 0 0 0 4 6.25v7.5A2.25 2.25 0 0 0 6.25 16h7.5A2.25 2.25 0 0 0 16 13.75v-7.5A2.25 2.25 0 0 0 13.75 4Z"
            },
            {
                "d": "M10 5c2.071 0 3.75 1.712 3.75 3.824 0 1.091-.465 2.13-1.275 2.844 2.144.99 3.523 3.167 3.525 5.567a.757.757 0 0 1-.75.765.757.757 0 0 1-.75-.765c0-2.534-2.015-4.588-4.5-4.588s-4.5 2.054-4.5 4.588a.757.757 0 0 1-.75.765.757.757 0 0 1-.75-.765c.002-2.4 1.38-4.577 3.525-5.567A3.794 3.794 0 0 1 6.25 8.824C6.25 6.712 7.929 5 10 5Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "dot": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0Z"
            }
        ]
    },
    "download-arrow": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M11.29 15.71a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1.004 1.004 0 1 0-1.42-1.42L13 12.59V3a1 1 0 0 0-2 0v9.59l-2.29-2.3a1.004 1.004 0 1 0-1.42 1.42l4 4Z"
            }
        ]
    },
    "dropbox": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21.61,11.81,18.36,9.28l3.26-2.56A1,1,0,0,0,22,5.86a1.06,1.06,0,0,0-.5-.8L16.36,2.13a1,1,0,0,0-1.15.12L12,5.05,8.79,2.25a1,1,0,0,0-1.15-.12L2.5,5.06a1.06,1.06,0,0,0-.5.8,1,1,0,0,0,.38.86L5.64,9.28,2.39,11.77a1,1,0,0,0-.39.86,1,1,0,0,0,.5.8l3.41,2v2.47a1,1,0,0,0,.48.85l5.09,3.13a1,1,0,0,0,1,0l5.09-3.13a1,1,0,0,0,.48-.85V15.42l3.41-1.95a1,1,0,0,0,.5-.8A1,1,0,0,0,21.61,11.81ZM16,4.22l3.23,1.84-2.55,2-3-1.84ZM14.91,9.34l-2.91,2-2.91-2L12,7.55ZM4.79,6.06,8,4.22l2.31,2-3,1.84Zm0,6.39,2.5-1.92,3,2.08L8.07,14.34Zm11.29,4.86L12,19.83,7.91,17.31v-.8a1,1,0,0,0,.85-.18L12,13.83l3.24,2.5a1,1,0,0,0,.61.21,1,1,0,0,0,.24,0Zm-.15-3L13.7,12.61l3-2.08,2.51,1.94Z"
            }
        ]
    },
    "edit": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16.76 2a1 1 0 0 1 .61.203l.1.087 4.24 4.24a1 1 0 0 1 .282.578L22 7.24l-.07.05a.7.7 0 0 1 0 .14 1 1 0 0 1 0 .24 1.19 1.19 0 0 1-.134.228L21.71 8l-2.84 2.78L8 21.71a1 1 0 0 1-.64.29H3a1 1 0 0 1-.993-.883L2 21v-4.24a1 1 0 0 1 .203-.61l.087-.1L16.05 2.29a1 1 0 0 1 .71-.29Zm-2.83 5.24L4 17.17V20h2.83l9.93-9.93-2.83-2.83Zm2.83-2.82-1.42 1.41 2.83 2.83 1.41-1.42-2.82-2.82Z"
            }
        ]
    },
    "ellipsis-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "entry": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M20 12a1 1 0 0 0-1-1h-7.59l2.3-2.29a1.004 1.004 0 0 0-1.42-1.42l-4 4a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l4 4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L11.41 13H19a1 1 0 0 0 1-1Z"
            },
            {
                "d": "M17 2H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-3a1 1 0 0 0-2 0v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3Z"
            }
        ]
    },
    "envelope-open": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10.1 2.779a2.83 2.83 0 0 1 3.9 0l6.21 6.04.132.14A2.67 2.67 0 0 1 21 10.71v8.58A2.75 2.75 0 0 1 18.22 22H5.78A2.75 2.75 0 0 1 3 19.29v-8.58a2.6 2.6 0 0 1 .89-1.93Zm8.9 8.57-4 3.9 1.67 1.6a1 1 0 0 1 0 1.41 1 1 0 0 1-.72.31 1 1 0 0 1-.69-.28l-1.77-1.7a2.8 2.8 0 0 1-2.92 0l-1.77 1.7a1 1 0 0 1-.69.28 1 1 0 0 1-.72-.31 1 1 0 0 1 0-1.41l1.66-1.6-4.05-3.9v7.94a.76.76 0 0 0 .78.71h12.44a.76.76 0 0 0 .78-.71v-7.94Zm-6.44-7.13a.83.83 0 0 0-1.12 0L6 9.499l5.41 5.28a.83.83 0 0 0 1.12 0L18 9.499Z"
            }
        ]
    },
    "equal": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M4.32 5.5C2.762 5.5 1.5 6.638 1.5 8.041s1.262 2.541 2.82 2.541h15.36c1.557 0 2.82-1.138 2.82-2.541S21.237 5.5 19.68 5.5H4.32zm0 7.918c-1.558 0-2.82 1.138-2.82 2.541S2.762 18.5 4.32 18.5h15.36c1.557 0 2.82-1.138 2.82-2.541s-1.263-2.541-2.82-2.541H4.32z"
            }
        ]
    },
    "exam": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11 2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-1.18A3 3 0 0 0 13 2h-2zm0 2h2a1 1 0 0 1 1 1v1h-4V5a1 1 0 0 1 1-1zM7 6h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm8.076 4.705c-.252.025-.49.138-.67.32l-3.586 3.608-2.164-1.613-.064.011a1.123 1.123 0 0 0-.553 1.902l2.033 2.042c.205.207.486.326.778.326.29 0 .57-.118.777-.326l4.33-4.35a1.11 1.11 0 0 0-.01-1.613c-.189-.191-.473-.313-.857-.307h-.014zm.026.3c.317-.002.504.085.634.218l.002.004.004.002a.808.808 0 0 1 .258.593.806.806 0 0 1-.246.582l-.002.004-4.338 4.356a.792.792 0 0 1-1.127 0h-.002L8.25 14.719h-.002a.823.823 0 0 1-.225-.79c.072-.288.31-.49.592-.568l2.235 1.668 3.77-3.793h.001a.79.79 0 0 1 .48-.23z"
            }
        ]
    },
    "exclamation-circle": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1Zm1.104 9.344a.912.912 0 0 0-.108-.216l-.144-.18a1.2 1.2 0 0 0-1.308-.252 1.38 1.38 0 0 0-.396.252 1.2 1.2 0 0 0-.348.852 1.2 1.2 0 0 0 .096.456c.11.301.347.539.648.648.29.128.622.128.912 0a1.08 1.08 0 0 0 .648-.648 1.2 1.2 0 0 0 .096-.456c.006-.08.006-.16 0-.24a.768.768 0 0 0-.096-.216Z"
            },
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            }
        ]
    },
    "exclamation-triangle": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.04 16.069a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10.67 1.47-8.05-14a3 3 0 0 0-5.24 0l-8 14a3 3 0 0 0 2.56 4.53H20.1a3 3 0 0 0 2.61-4.53Zm-1.73 2a1 1 0 0 1-.88.51H3.98a1 1 0 0 1-.88-.51 1 1 0 0 1 0-1l8-14a1 1 0 0 1 1.78 0l8.05 14a1 1 0 0 1 .05 1.02v-.02Zm-8.94-11.47a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "expand-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9.79 12.79 4 18.59V17a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h4a1 1 0 0 0 0-2H5.41l5.8-5.79a1.004 1.004 0 0 0-1.42-1.42ZM21.92 2.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-4a1 1 0 0 0 0 2h1.59l-5.8 5.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V7a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38Z"
            }
        ]
    },
    "expand-arrows-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9.29 13.29 4 18.59V17a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h4a1 1 0 0 0 0-2H5.41l5.3-5.29a1.004 1.004 0 1 0-1.42-1.42ZM5.41 4H7a1 1 0 1 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v4a1 1 0 1 0 2 0V5.41l5.29 5.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42L5.41 4ZM21 16a1 1 0 0 0-1 1v1.59l-5.29-5.3a1.004 1.004 0 1 0-1.42 1.42l5.3 5.29H17a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-4a1 1 0 0 0-1-1Zm.92-13.38a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-4a1 1 0 0 0 0 2h1.59l-5.3 5.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V7a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38Z"
            }
        ]
    },
    "expand-arrows": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 8a1 1 0 0 0 1-1V3a1 1 0 0 0-.08-.38 1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-4a1 1 0 0 0 0 2h1.59L12 10.59 5.41 4H7a1 1 0 1 0 0-2H3a1 1 0 0 0-.38.08 1 1 0 0 0-.54.54A1 1 0 0 0 2 3v4a1 1 0 1 0 2 0V5.41L10.59 12 4 18.59V17a1 1 0 0 0-2 0v4a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54A1 1 0 0 0 3 22h4a1 1 0 0 0 0-2H5.41L12 13.41 18.59 20H17a1 1 0 0 0 0 2h4a1 1 0 0 0 .38-.08 1 1 0 0 0 .54-.54A1 1 0 0 0 22 21v-4a1 1 0 0 0-2 0v1.59L13.41 12 20 5.41V7a1 1 0 0 0 1 1Z"
            }
        ]
    },
    "export": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8.71 7.71 11 5.41V15a1 1 0 0 0 2 0V5.41l2.29 2.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-4-4a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1.004 1.004 0 1 0 1.42 1.42Z"
            },
            {
                "d": "M21 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "external-link": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18 10.82a1 1 0 0 0-1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7.18a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7.18a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M21.92 2.62a1 1 0 0 0-.54-.54A1 1 0 0 0 21 2h-6a1 1 0 0 0 0 2h3.59L8.29 14.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L20 5.41V9a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38Z"
            }
        ]
    },
    "eye-full": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 5c5.128 0 10 5.81 10 7.5 0 1.69-4.872 7.5-10 7.5S2 14.19 2 12.5C2 10.81 6.872 5 12 5Zm0 2.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2.5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1-2.5-2.5A2.5 2.5 0 0 0 12 10Z"
            }
        ]
    },
    "eye-slash": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10.944 6.084a6.93 6.93 0 0 1 1.06-.08c3.18 0 6.17 2.29 7.91 6a15.23 15.23 0 0 1-.9 1.64 1 1 0 1 0 1.7 1.05 15.77 15.77 0 0 0 1.21-2.3 1 1 0 0 0 0-.79c-2.02-4.69-5.82-7.6-9.92-7.6a7.78 7.78 0 0 0-1.4.12 1.014 1.014 0 1 0 .34 2v-.04Zm-7.23-3.79a1.004 1.004 0 1 0-1.42 1.42l3.1 3.09a14.62 14.62 0 0 0-3.31 4.8 1 1 0 0 0 0 .8c2.02 4.69 5.82 7.6 9.92 7.6a9.26 9.26 0 0 0 5.05-1.54l3.24 3.25a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-18-18Zm6.36 9.19 2.45 2.45a2 2 0 0 1-2.45-2.45Zm1.93 6.52c-3.18 0-6.17-2.29-7.9-6a12.09 12.09 0 0 1 2.7-3.79l1.77 1.79a4 4 0 0 0 5.43 5.43l1.59 1.57a7.24 7.24 0 0 1-3.59 1Z"
            }
        ]
    },
    "eye": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 4c4.1 0 7.9 2.91 9.92 7.6a1 1 0 0 1 0 .8C19.9 17.09 16.1 20 12 20s-7.9-2.91-9.92-7.6a1 1 0 0 1 0-.8C4.1 6.91 7.9 4 12 4Zm0 2c-3.17 0-6.17 2.29-7.9 6 1.73 3.71 4.73 6 7.9 6s6.17-2.29 7.9-6c-1.73-3.71-4.73-6-7.9-6Z"
            },
            {
                "d": "M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "failed": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm2.996 6a.999.999 0 0 0-.71.295L12 10.592 9.713 8.295a1.003 1.003 0 0 0-1.418 1.418L10.592 12l-2.297 2.287a.999.999 0 0 0 0 1.418.999.999 0 0 0 1.418 0L12 13.408l2.287 2.297a.999.999 0 0 0 1.418 0 .999.999 0 0 0 0-1.418L13.408 12l2.297-2.287a.999.999 0 0 0 0-1.418.999.999 0 0 0-.71-.295Z"
            }
        ]
    },
    "file-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9 10h1a1 1 0 0 0 0-2H9a1 1 0 1 0 0 2Zm0 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2H9Z"
            },
            {
                "d": "M13.05 2a.88.88 0 0 1 .33.11.32.32 0 0 1 .09 0c.069.032.133.071.194.117l.086.073 6 6 .073.086.064.094.053.1v.09l.037.133.023.137V19a3 3 0 0 1-2.824 2.995L17 22H7a3 3 0 0 1-2.995-2.824L4 19V5a3 3 0 0 1 2.824-2.995L7 2h6.05ZM12 4H7a1 1 0 0 0-.993.883L6 5v14a1 1 0 0 0 .883.993L7 20h10a1 1 0 0 0 .993-.883L18 19v-9h-3a3 3 0 0 1-2.995-2.824L12 7V4Zm2 1.41V7a1 1 0 0 0 1 1h1.59L14 5.41Z"
            },
            {
                "d": "M15 16H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "file-bookmark": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7.5 10h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2Zm4 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm0-4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
            },
            {
                "d": "m11.56 2 .28.1a.32.32 0 0 1 .09 0c.103.048.197.112.28.19l6 6a1 1 0 0 1 .21 1.09 1 1 0 0 1-.92.62h-4a3 3 0 0 1-3-3V4h-5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6a1 1 0 0 1 0 2h-6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6.06Zm.94 3.41V7a1 1 0 0 0 1 1h1.59L12.5 5.41Z"
            },
            {
                "d": "M20.5 12a1 1 0 0 1 1 1v8a1 1 0 0 1-1.5.83l-2-1.3-1.97 1.3a1 1 0 0 1-1 .05 1 1 0 0 1-.53-.88v-8a1 1 0 0 1 1-1Zm-1 2h-3v5.12l.94-.63a1 1 0 0 1 1.12 0l.94.63V14Z"
            }
        ]
    },
    "file-check": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.56 2a1.1 1.1 0 0 1 .31.11.29.29 0 0 1 .1 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V15a1 1 0 0 1-2 0v-5h-3a3 3 0 0 1-3-3V4h-5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6a1 1 0 0 1 0 2h-6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm.94 3.41V7a1 1 0 0 0 1 1h1.59L12.5 5.41Z"
            },
            {
                "d": "M7.5 14h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2Zm4 2h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm-4-6h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2Zm13.71 6.29a1 1 0 0 0-1.42 0l-3.29 3.3-1.29-1.3a1.004 1.004 0 1 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l4-4a1 1 0 0 0 0-1.42Z"
            }
        ]
    },
    "file-download": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13.06 2a1.1 1.1 0 0 1 .31.11h.1c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM12 4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9h-3a3 3 0 0 1-3-3V4Zm2 1.41V7a1 1 0 0 0 1 1h1.59L14 5.41Z"
            },
            {
                "d": "m13.29 14.29-.29.3V12a1 1 0 0 0-2 0v2.59l-.29-.3a1.004 1.004 0 1 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1.004 1.004 0 1 0-1.42-1.42Z"
            }
        ]
    },
    "file-edit-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.58 13.994a1 1 0 0 1 .71.296l2.42 2.42a1 1 0 0 1 0 1.42l-3.58 3.58a1 1 0 0 1-.71.29H14a1 1 0 0 1-1-1v-2.42a1 1 0 0 1 .29-.71l3.58-3.58a1 1 0 0 1 .71-.296Zm0 2.426L15 19v1h1l2.58-2.58-1-1Z"
            },
            {
                "d": "m12.06 2 .32.11a.32.32 0 0 1 .09 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V11a1 1 0 0 1-2 0v-1h-3a3 3 0 0 1-3-3V4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4a1 1 0 0 1 0 2H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6.06ZM13 5.41V7a1 1 0 0 0 1 1h1.59L13 5.41Z"
            },
            {
                "d": "M8 14h6a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2Zm0-4h1a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2Zm2 6H8a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "file-exclamation-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9 10h1a1 1 0 0 0 0-2H9a1 1 0 1 0 0 2Zm6 2H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm0 4H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4.71 4.29a1.58 1.58 0 0 0-.15-.12.76.76 0 0 0-.18-.09L19.2 20a1 1 0 0 0-.58.06.9.9 0 0 0-.54.54.84.84 0 0 0-.08.4 1 1 0 1 0 1.92-.38 1.15 1.15 0 0 0-.21-.33Z"
            },
            {
                "d": "M13.05 2a.88.88 0 0 1 .33.11.32.32 0 0 1 .09 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V12a1 1 0 0 1-2 0v-2h-3a3 3 0 0 1-3-3V4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 1 0 2H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM14 5.41V7a1 1 0 0 0 1 1h1.59L14 5.41Z"
            },
            {
                "d": "M19 15a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "file-network": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.05 1a.88.88 0 0 1 .33.11.32.32 0 0 1 .09 0c.069.032.133.071.194.117l.086.073 6 6 .073.086.064.094.053.1v.09l.037.133.023.137V12a3 3 0 0 1-2.824 2.995L16 15h-3v2.18a3 3 0 0 1 1.75 1.64l.07.18H21a1 1 0 0 1 .117 1.993L21 21h-6.18a3 3 0 0 1-5.57.175L9.18 21H3a1 1 0 0 1-.117-1.993L3 19h6.18a3 3 0 0 1 1.64-1.75l.18-.07V15H8a3 3 0 0 1-2.995-2.824L5 12V4a3 3 0 0 1 2.824-2.995L8 1h4.05ZM12 19a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM11 3H8a1 1 0 0 0-.993.883L7 4v8a1 1 0 0 0 .883.993L8 13h8a1 1 0 0 0 .993-.883L17 12V9h-3a3 3 0 0 1-2.995-2.824L11 6V3Zm2 1.41V6a1 1 0 0 0 .883.993L14 7h1.59L13 4.41Z"
            }
        ]
    },
    "file-plus-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13.05 2a.88.88 0 0 1 .33.11.32.32 0 0 1 .09 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM12 4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9h-3a3 3 0 0 1-3-3V4Zm0 8a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0v-1h-1a1 1 0 0 1 0-2h1v-1a1 1 0 0 1 1-1Zm2-6.59V7a1 1 0 0 0 1 1h1.59L14 5.41Z"
            }
        ]
    },
    "file-plus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M20 18h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2ZM8 8a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H8Zm5 8H8a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2Zm1-4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z"
            },
            {
                "d": "M12.06 2a1.1 1.1 0 0 1 .31.11.29.29 0 0 1 .1 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V13a1 1 0 0 1-2 0v-3h-3a3 3 0 0 1-3-3V4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7a1 1 0 0 1 0 2H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM13 5.41V7a1 1 0 0 0 1 1h1.59L13 5.41Z"
            }
        ]
    },
    "file-search-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.05 2a.88.88 0 0 1 .33.11.32.32 0 0 1 .09 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V11a1 1 0 0 1-2 0v-1h-3a3 3 0 0 1-3-3V4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7a1 1 0 0 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM12 5.41V7a1 1 0 0 0 1 1h1.59L12 5.41Z"
            },
            {
                "d": "M7 8a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H7Zm9.152 6.2A3.49 3.49 0 0 1 20 15l.137.147a3.44 3.44 0 0 1 .403 3.983l1.17 1.16a1 1 0 0 1 0 1.42 1 1 0 0 1-1.42 0l-1.16-1.17A3.46 3.46 0 0 1 14 17.49a3.49 3.49 0 0 1 2.152-3.29Zm1.44 1.8h-.152a1.48 1.48 0 0 0-1 .43 1.5 1.5 0 0 0-.01 2.11 1.54 1.54 0 0 0 2.11 0 1.5 1.5 0 0 0 .46-1.05A1.47 1.47 0 0 0 17.44 16ZM13 12H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm-2 6a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2h4Z"
            }
        ]
    },
    "file-upload": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.05 2a.88.88 0 0 1 .33.11.32.32 0 0 1 .09 0c.103.048.197.112.28.19l6 6 .073.086c.046.06.085.125.117.194v.09c.03.088.05.178.06.27V12a1 1 0 0 1-2 0v-2h-3a3 3 0 0 1-3-3V4H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7a1 1 0 0 1 0 2H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM13 5.41V7a1 1 0 0 0 1 1h1.59L13 5.41Z"
            },
            {
                "d": "M8 8a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2H8Zm6 4H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm6.71 5.29-2-2a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1.004 1.004 0 1 0 1.42 1.42l.29-.3V21a1 1 0 0 0 2 0v-2.59l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42ZM12 18a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2h4Z"
            }
        ]
    },
    "file": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m13.06 2 .32.11h.09c.069.032.133.071.194.117l.086.073 6 6 .073.086.064.094.053.1v.09l.037.133.023.137V19a3 3 0 0 1-2.824 2.995L17 22H7a3 3 0 0 1-2.995-2.824L4 19V5a3 3 0 0 1 2.824-2.995L7 2h6.06ZM12 4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4Zm2 1.41V8h2.59L14 5.41Z"
            }
        ]
    },
    "filter": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.976 2a1 1 0 0 1 1 1v5.18a3 3 0 0 1 0 5.64V21a1 1 0 0 1-2 0v-7.18a3 3 0 0 1 0-5.64V3a1 1 0 0 1 1-1Zm0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7-8a1 1 0 0 1 1 1v11.18a3 3 0 0 1 0 5.64V21a1 1 0 0 1-2 0v-1.18a3 3 0 0 1 0-5.64V3a1 1 0 0 1 1-1Zm0 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7-14a1 1 0 0 1 1 1v3.18a3 3 0 0 1 0 5.64V21a1 1 0 0 1-2 0v-9.18a3 3 0 0 1 0-5.64V3a1 1 0 0 1 1-1Zm0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
            }
        ]
    },
    "focus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8 2H3a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V4h4a1 1 0 1 0 0-2Zm0 18H4v-4a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2ZM21 2h-5a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Zm0 13a1 1 0 0 0-1 1v4h-4a1 1 0 0 0 0 2h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "folder": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10.426 4.425a2.55 2.55 0 0 1 2.414 1.7l.272.85h5.338A2.55 2.55 0 0 1 21 9.525v8.5a2.55 2.55 0 0 1-2.55 2.55H6.55A2.55 2.55 0 0 1 4 18.025V6.975a2.55 2.55 0 0 1 2.55-2.55Zm0 1.7H6.55a.85.85 0 0 0-.85.85v11.05c0 .47.38.85.85.85h11.9c.47 0 .85-.38.85-.85v-8.5a.85.85 0 0 0-.85-.85H12.5a.85.85 0 0 1-.807-.578l-.46-1.394a.85.85 0 0 0-.807-.578Z"
            }
        ]
    },
    "format-clear": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.411 3 2 4.434l7.744 7.842L7 18.75h3.333l1.745-4.117L18.367 21l1.41-1.434L3.718 3.309 3.41 3zm3.033 0v.203l3.134 3.172h2.66l-.8 1.884 2.334 2.363 1.8-4.247H22V3z"
            }
        ]
    },
    "fullscreen-exit": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15.968 8h3v1.969h-4.969V5h1.969v3zM14 18.968v-4.969h4.969v1.969h-3v3zM8 8V5h1.969v4.969H5V8h3zm-3 7.968v-1.969h4.969v4.969H8v-3H5z"
            }
        ]
    },
    "fundaecheckpoll": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11 2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-1.18A3 3 0 0 0 13 2h-2zm0 2h2a1 1 0 0 1 1 1v1h-4V5a1 1 0 0 1 1-1zM7 6h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm8.299 6.004a4.02 4.02 0 0 0-1.94.394c-.48.235-.934.51-1.396.772-.082.046-.133.054-.2-.016-.086-.09-.185-.17-.275-.258a.444.444 0 0 0-.355-.132 1.766 1.766 0 0 0-.362.06c-.43.125-.79.359-1.13.615-.212.16-.414.329-.621.493-.022.017-.048.028-.073.043-.01-.027-.027-.053-.031-.08-.011-.075-.017-.15-.025-.225-.016-.136-.076-.176-.215-.12a1.74 1.74 0 0 0-.354.19c-.58.423-.996.952-1.232 1.588a1.608 1.608 0 0 0-.09.494c-.007.17.13.228.287.131.092-.057.178-.128.25-.205.283-.3.558-.607.838-.91.023-.025.06-.04.09-.059.009.03.021.058.025.088.024.176.04.353.07.528.055.317.28.44.618.34a.995.995 0 0 0 .277-.12c.226-.156.448-.317.66-.488.385-.31.76-.63 1.14-.943.123-.1.126-.098.222.03.154.211.31.423.466.632.255.34.607.548 1.057.623.325.054.655.057.97-.012 1.389-.303 2.524-.898 3.03-2.187v-.399c-.12-.387-.43-.61-.834-.72a3.91 3.91 0 0 0-.867-.147zm-.51.377c.163.03.331.048.488.096.483.145.628.478.403.89-.132.24-.34.423-.57.584a2.67 2.67 0 0 1-1.422.5c-.324.016-.618-.058-.85-.271-.206-.19-.402-.39-.606-.582-.048-.046-.056-.077.008-.114.501-.288.994-.59 1.506-.861.313-.166.704-.226 1.043-.242zm-4.193.83a.248.248 0 0 1 .236.11c.08.11.157.224.24.333.041.054.038.09-.02.135-.395.312-.785.63-1.183.94a1.844 1.844 0 0 1-.377.228c-.248.11-.397.038-.451-.203-.009-.039-.006-.081-.021-.117-.112-.266-.01-.455.234-.621.274-.187.522-.405.793-.596.158-.112.34-.194.549-.21zm-2.18.74.049.211c.004.017 0 .035 0 .074.035.129-.038.235-.15.342-.203.192-.386.4-.58.6-.072.072-.15.14-.233.2-.033.025-.1.041-.133.026-.03-.013-.055-.077-.047-.111.036-.14.067-.286.133-.416a2.35 2.35 0 0 1 .7-.826c.007-.006.014-.013.023-.016l.238-.084z"
            }
        ]
    },
    "geo": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16.37 12.803a1 1 0 0 0-.74 1.86c1.46.58 2.37 1.48 2.37 2.35 0 1.42-2.46 3-6 3s-6-1.58-6-3c0-.87.91-1.77 2.37-2.35a1 1 0 1 0-.74-1.86c-2.27.9-3.63 2.47-3.63 4.21 0 2.8 3.51 5 8 5s8-2.2 8-5c0-1.74-1.36-3.31-3.63-4.21ZM11 9.873v7.14a1 1 0 1 0 2 0v-7.14a4 4 0 1 0-2 0Zm1-5.86a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
            }
        ]
    },
    "globe": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.02 2.03a10 10 0 0 1 9.39 6.56v.05l.118.344a9.86 9.86 0 0 1-.118 6.376v.05l-.102.267A10 10 0 0 1 2.63 15.41v-.05a9.86 9.86 0 0 1 0-6.72v-.05a10 10 0 0 1 9.39-6.56ZM11 16H8.57A6.34 6.34 0 0 0 11 19.7V16Zm4.43 0H13v3.7a6.34 6.34 0 0 0 2.43-3.7Zm-8.95 0h-1.4a8 8 0 0 0 2.4 2.57 12.15 12.15 0 0 1-1-2.57Zm12.47 0h-1.4a12.15 12.15 0 0 1-1 2.57 8 8 0 0 0 2.4-2.57ZM6.12 10H4.26a7.82 7.82 0 0 0 0 4h1.86a16.73 16.73 0 0 1 0-4ZM11 10H8.14a14.36 14.36 0 0 0 0 4H11v-4Zm4.86 0H13v4h2.86a14.36 14.36 0 0 0 0-4Zm3.88 0h-1.86c.081.664.121 1.332.12 2a16.16 16.16 0 0 1-.12 2h1.86a7.82 7.82 0 0 0 0-4ZM7.45 5.43A8 8 0 0 0 5.08 8h1.4c.225-.89.55-1.753.97-2.57ZM11 4.3A6.34 6.34 0 0 0 8.57 8H11Zm5.52 1.13c.43.816.765 1.678 1 2.57h1.4a8 8 0 0 0-2.4-2.57ZM13 4.3V8h2.43A6.34 6.34 0 0 0 13 4.3Z"
            }
        ]
    },
    "graduation-hat": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.19 4.58c.065.014.129.034.19.06h.11l9 5 1 .55a1 1 0 0 1 .51.87v3.44a1 1 0 0 1-2 0v-2.86l-2 1.12v4.74a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-4.74l-2.49-1.38a1 1 0 0 1 0-1.74l9-5h.11a1.17 1.17 0 0 1 .2-.06ZM17 13.87l-4.51 2.5a.47.47 0 0 1-.15.06h-.09a1 1 0 0 1-.25 0l-.125.008-.125-.008h-.09l-.15-.06L7 13.87v3.63a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.63Zm-5-7.23L5.06 10.5 12 14.36l6.94-3.86L12 6.64Z"
            }
        ]
    },
    "graduation": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.19 4.58c.065.014.129.034.19.06h.11l9 5 1 .55a1 1 0 0 1 .51.87v3.44a1 1 0 0 1-2 0v-2.86l-2 1.12v4.74a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-4.74l-2.49-1.38a1 1 0 0 1 0-1.74l9-5h.11a1.17 1.17 0 0 1 .2-.06ZM17 13.87l-4.51 2.5a.47.47 0 0 1-.15.06h-.09a1 1 0 0 1-.25 0l-.125.008-.125-.008h-.09l-.15-.06L7 13.87v3.63a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-3.63Zm-5-7.23L5.06 10.5 12 14.36l6.94-3.86L12 6.64Z"
            }
        ]
    },
    "grip-horizontal-line": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 11h18a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm18 2H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "groupwork": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M20.64 15.767a3.468 3.468 0 0 0 .86-2.272 3.5 3.5 0 0 0-7 0c.003.837.309 1.643.86 2.272A4.988 4.988 0 0 0 13 19.995a1 1 0 1 0 2 0 3 3 0 0 1 6 0 1 1 0 1 0 2 0 4.988 4.988 0 0 0-2.36-4.228ZM18 14.995a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM6.793 7.703l2 2a1 1 0 0 0 1.414-1.415l-.293-.293h4.172l-.293.293a1 1 0 1 0 1.414 1.414l2-2a1.004 1.004 0 0 0 0-1.414l-2-2a1 1 0 0 0-1.414 1.414l.293.293H9.914l.293-.293a1 1 0 0 0-1.414-1.414l-2 2a1.004 1.004 0 0 0 0 1.415Zm1.847 8.064a3.468 3.468 0 0 0 .86-2.272 3.5 3.5 0 1 0-7 0c.003.837.309 1.643.86 2.272A4.988 4.988 0 0 0 1 19.995a1 1 0 0 0 2 0 3 3 0 1 1 6 0 1 1 0 0 0 2 0 4.988 4.988 0 0 0-2.36-4.228ZM6 14.995a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
            }
        ]
    },
    "headphones": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 3a8 8 0 0 1 7.996 7.75L20 11v2.18a3 3 0 0 1 1.994 2.63L22 16v2a3 3 0 0 1-2.824 2.995L19 21h-3a1 1 0 0 1-.993-.883L15 20v-6a1 1 0 0 1 .883-.993L16 13h2v-2a6 6 0 0 0-11.996-.225L6 11v2h2a1 1 0 0 1 .993.883L9 14v6a1 1 0 0 1-.883.993L8 21H5a3 3 0 0 1-2.995-2.824L2 18v-2a3 3 0 0 1 1.824-2.751L4 13.18V11a8 8 0 0 1 8-8ZM7 15H5a1 1 0 0 0-.993.883L4 16v2a1 1 0 0 0 .883.993L5 19h2v-4Zm12 0h-2v4h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "heart-full": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M20.172 4.88a6.29 6.29 0 0 0-8.16-.64 6.27 6.27 0 0 0-8.16 9.48l6.21 6.22a2.78 2.78 0 0 0 3.9 0l6.21-6.22a6.27 6.27 0 0 0 0-8.84Z"
            }
        ]
    },
    "heart": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.518 5.18a6.27 6.27 0 0 1 8.494-.94 6.29 6.29 0 0 1 8.16.64 6.27 6.27 0 0 1 0 8.84l-6.21 6.22a2.78 2.78 0 0 1-3.9 0l-6.21-6.22a6.27 6.27 0 0 1-.334-8.54Zm7.744 1.13a4.27 4.27 0 0 0-6 0 4.29 4.29 0 0 0 0 6l6.21 6.24a.76.76 0 0 0 1.08 0l6.21-6.21v-.03a4.29 4.29 0 0 0-.08-6 4.27 4.27 0 0 0-6 0 1 1 0 0 1-1.42 0Z"
            }
        ]
    },
    "history-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 6.88 2.77V3a1 1 0 0 1 2 0v4.5a1 1 0 0 1-1 1h-4.5a1 1 0 0 1 0-2h2.4A8 8 0 1 0 20 12a1 1 0 0 1 2 0c0 5.523-4.478 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 6a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1z"
            }
        ]
    },
    "history": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 1 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 1 0 0-2h-2.4A8 8 0 1 1 4 12a1 1 0 0 0-2 0c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2Z"
            },
            {
                "d": "M12 8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h2a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "home": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.34 2.25a1 1 0 0 1 1.32 0l9 8A1 1 0 0 1 21 12h-1v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H3a1 1 0 0 1-.66-1.75ZM18 12H6v8h12v-8Zm-6-7.66L5.63 10h12.74L12 4.34Z"
            }
        ]
    },
    "ia": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9.816 1a3.298 3.298 0 0 0-3.092 2.184h-.2A3.301 3.301 0 0 0 3.23 6.49c-.016.19-.016.382 0 .572a4.408 4.408 0 0 0-2.214 3.471 4.414 4.414 0 0 0 1.61 3.791 4.423 4.423 0 0 0 .11 4.36 4.39 4.39 0 0 0 3.789 2.132h.2a3.298 3.298 0 0 0 2.29 2.082 3.285 3.285 0 0 0 3.003-.738 3.285 3.285 0 0 0 3.002.738 3.298 3.298 0 0 0 2.29-2.082h.198a4.392 4.392 0 0 0 3.75-2.156 4.424 4.424 0 0 0 .096-4.336A4.41 4.41 0 0 0 23 10.898a4.413 4.413 0 0 0-2.197-3.835 3.426 3.426 0 0 0 0-.573 3.301 3.301 0 0 0-3.295-3.306h-.197a3.298 3.298 0 0 0-2.291-2.082 3.285 3.285 0 0 0-3.002.738A3.29 3.29 0 0 0 9.816 1zm.004 2.184c.607 0 1.1.495 1.1 1.103v3.91a5.184 5.184 0 0 0-.748-.35 1.096 1.096 0 0 0-1.078.217 1.107 1.107 0 0 0 .375 1.875A2.205 2.205 0 0 1 10.919 12v1.71a5.195 5.195 0 0 0-.747-.355 1.1 1.1 0 0 0-1.395.694 1.106 1.106 0 0 0 .692 1.4 2.205 2.205 0 0 1 1.45 2.06v2.204c0 .608-.492 1.103-1.1 1.103a1.097 1.097 0 0 1-.997-.662c.184-.108.36-.23.528-.363a1.106 1.106 0 0 0-.323-1.883 1.097 1.097 0 0 0-1.084.186 2.199 2.199 0 0 1-3.613-1.686 2.21 2.21 0 0 1 .352-1.168c.246.045.495.067.746.067a1.1 1.1 0 0 0 1.097-1.104 1.1 1.1 0 0 0-1.097-1.1 2.014 2.014 0 0 1-.758-.144 2.209 2.209 0 0 1-.34-3.99c.156.144.324.274.504.386a1.102 1.102 0 0 0 1.506-.408 1.108 1.108 0 0 0-.406-1.51.988.988 0 0 1-.506-.947 1.1 1.1 0 0 1 1.097-1.1.83.83 0 0 1 .23 0c.059.177.129.35.21.517a1.099 1.099 0 0 0 1.506.408c.506-.305.68-.957.394-1.476a1.17 1.17 0 0 1-.142-.55A1.1 1.1 0 0 1 9.82 3.183zm4.395 0a1.1 1.1 0 0 1 1.098 1.103 1.17 1.17 0 0 1-.143.55 1.102 1.102 0 0 0 .394 1.51 1.097 1.097 0 0 0 1.506-.408 4.24 4.24 0 0 0 .207-.55.83.83 0 0 1 .23 0 1.1 1.1 0 0 1 1.1 1.101 1.104 1.104 0 0 1-.187.606.987.987 0 0 1-.361.341c-.528.305-.71.98-.407 1.51a1.1 1.1 0 0 0 1.504.408c.197-.107.38-.237.55-.386a2.207 2.207 0 0 1-.298 3.99h-.043a2.014 2.014 0 0 1-.758.143 1.103 1.103 0 0 0 0 2.205c.25 0 .5-.022.747-.067.224.35.346.753.35 1.168a2.2 2.2 0 0 1-2.196 2.203 2.19 2.19 0 0 1-1.416-.517 1.097 1.097 0 0 0-1.55.142 1.107 1.107 0 0 0 .144 1.555c.166.134.343.255.527.363-.174.4-.564.66-.998.662-.607 0-1.1-.495-1.1-1.103V17.51a2.203 2.203 0 0 1 1.45-2.06c.576-.196.887-.823.693-1.4a1.1 1.1 0 0 0-1.395-.695 5.195 5.195 0 0 0-.748.354V12a2.203 2.203 0 0 1 1.45-2.06c.576-.195.887-.823.693-1.4a1.1 1.1 0 0 0-1.395-.694 5.184 5.184 0 0 0-.748.351v-3.91c0-.608.493-1.103 1.1-1.103z"
            }
        ]
    },
    "image-bank": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M22.917 11.582a1.1 1.1 0 0 0-.23-.363l-2.752-2.75a1.105 1.105 0 0 0-1.563 1.562l.88.869h-2.85a1.1 1.1 0 1 0 0 2.2h2.85l-.88.869a1.1 1.1 0 0 0 0 1.562 1.1 1.1 0 0 0 1.563 0l2.751-2.75a1.1 1.1 0 0 0 .231-.363 1.1 1.1 0 0 0 0-.836zM7.597 10.9h-2.85l.88-.869a1.105 1.105 0 1 0-1.562-1.562l-2.751 2.75a1.1 1.1 0 0 0-.231.363 1.1 1.1 0 0 0 0 .836 1.1 1.1 0 0 0 .23.363l2.752 2.75a1.1 1.1 0 0 0 1.563 0 1.1 1.1 0 0 0 0-1.562l-.88-.869h2.85a1.1 1.1 0 1 0 0-2.2zM12 6.5a1.1 1.1 0 0 0-1.1 1.1v8.8a1.1 1.1 0 0 0 2.2 0V7.6A1.1 1.1 0 0 0 12 6.5Z"
            }
        ]
    },
    "image-edit": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11 4.48a1 1 0 0 1 .117 1.993L11 6.48H5a1 1 0 0 0-.993.883L4 7.48v5.61l1.47-1.49a2.78 2.78 0 0 1 3.781-.13l.139.13 2.49 2.49.7-.7a2.83 2.83 0 0 1 3.78-.126l.14.126 1.5 1.48v-2.39a1 1 0 0 1 1.993-.117l.007.117v7a3 3 0 0 1-2.824 2.995L17 22.48H5a3 3 0 0 1-2.995-2.824L2 19.48v-12a3 3 0 0 1 2.824-2.995L5 4.48h6Zm-3.56 8.283a.78.78 0 0 0-.466.154L6.88 13 4 15.92v3.56a1 1 0 0 0 .883.993L5 20.48l10.43-.05L8 13a.78.78 0 0 0-.56-.237Zm7.65 2.047a.78.78 0 0 0-1.1 0l-.7.69 4.54 4.52a1 1 0 0 0 .17-.54V17.7Z"
            },
            {
                "d": "M17.89 1.81a1 1 0 0 1 1.41 0l2.42 2.42a1 1 0 0 1-.02 1.42l-4.58 4.58a1 1 0 0 1-.7.29H14a1 1 0 0 1-1-1V7.1a1 1 0 0 1 .31-.71Zm.71 2.12L15 7.52v1h1l3.6-3.59-1-1Z"
            }
        ]
    },
    "image-plus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 4a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v5.61l1.48-1.49a2.79 2.79 0 0 1 3.93 0l2.48 2.49.7-.71a2.79 2.79 0 0 1 3.93 0L18 14.38V11a1 1 0 0 1 1-1 1 1 0 0 1 1.02 1v8.23a2.74 2.74 0 0 1-2 2.65l-.196.051a2.88 2.88 0 0 1-.604.069H4.78A2.79 2.79 0 0 1 2 19.22V7a3 3 0 0 1 3-3Zm-5.01 8.54a.78.78 0 0 0-1.1 0L4 15.43V19a1 1 0 0 0 1 1h10.46Zm6.57 1.529a.77.77 0 0 0-.55.231l-.71.7 4.52 4.54A1 1 0 0 0 18 19v-1.79l-2.89-2.91a.77.77 0 0 0-.55-.231ZM21 4h-1V3a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0V6h1a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "image-upload": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.997 4.995a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v5.6l1.48-1.48a2.849 2.849 0 0 1 3.929 0l2.48 2.48.7-.7a2.789 2.789 0 0 1 3.928 0l1.48 1.48v-.38a1 1 0 1 1 1.999 0v5a3 3 0 0 1-3 3H5a3 3 0 0 1-2.999-3v-12a3 3 0 0 1 3-3Zm-4.009 8.53a.79.79 0 0 0-1.09 0L4 16.425v3.57a1 1 0 0 0 1 1h10.457l-4.299-4.3Zm6.569 1.539a.77.77 0 0 0-.55.231l-.7.7 4.509 4.53a.89.89 0 0 0 .18-.53v-1.79l-2.89-2.91a.77.77 0 0 0-.55-.231Zm8.147-9.779-2.999-3a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2.999 3a1.004 1.004 0 0 0 1.42 1.42l1.29-1.3v5.59a1 1 0 1 0 1.999 0v-5.59l1.29 1.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z"
            }
        ]
    },
    "image": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 2a3 3 0 0 1 3 3v14a2.6 2.6 0 0 1-.1.6v.15c-.04.13-.07.26-.12.38a1 1 0 0 1-.07.15 2.31 2.31 0 0 1-.18.35l-.09.13a2.69 2.69 0 0 1-.27.32l-.07.09a3.79 3.79 0 0 1-.38.32c-.1.07-.21.12-.31.18l-.13.07-.37.14h-.12l-.3.07A2.81 2.81 0 0 1 19 22H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM8 11.094a1 1 0 0 0-.71.296L4 14.69V19a1 1 0 0 0 1 1h12.31l-8.6-8.61a1 1 0 0 0-.71-.296Zm8 2a1 1 0 0 0-.71.296l-.88.88 5.35 5.35a.94.94 0 0 0 .09-.12 1 1 0 0 0 .08-.14A1 1 0 0 0 20 19v-2.31l-3.29-3.3-.1-.088a1 1 0 0 0-.61-.208ZM19 4H5a1 1 0 0 0-1 1v6.86L5.88 10a3.08 3.08 0 0 1 4.24 0L13 12.88l.88-.88a3.08 3.08 0 0 1 4.24 0L20 13.86V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "img-doc": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.201 1.5c.187 0 .367.057.499.159l3.843 3.522a.487.487 0 0 1 .207.383v16.395c0 .299-.316.541-.706.541H2.956c-.39 0-.706-.242-.706-.541V2.04c0-.299.316-.541.706-.541Zm-8.47 9c-1.785.013-3.197 1.204-4.231 2.56v7.19l15-.007v-5.28c-2.728-1.158-4.35 1.907-4.35 1.907s-2.259-6.398-6.42-6.37ZM15.747 9a1.5 1.5 0 0 0 0 3 1.5 1.5 0 0 0 0-3Zm.752-6v3.46a.29.29 0 0 0 .29.29h3.46L16.5 3Z"
            }
        ]
    },
    "info": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 11a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1Zm.38-3.92a1 1 0 0 0-.76 0 1 1 0 0 0-.33.21 1.15 1.15 0 0 0-.21.33 1 1 0 0 0 .21 1.09c.097.088.209.16.33.21A1 1 0 0 0 13 8a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-.33-.21Z"
            },
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            }
        ]
    },
    "info_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 10.75c-.69 0-1.25.56-1.25 1.25v5a1.25 1.25 0 0 0 2.5 0v-5c0-.69-.56-1.25-1.25-1.25Zm.475-4.9a1.25 1.25 0 0 0-.95 0 1.25 1.25 0 0 0-.412.263c-.11.121-.2.26-.263.412a1.05 1.05 0 0 0-.1.475 1.25 1.25 0 0 0 .363.888c.121.11.26.199.412.262A1.25 1.25 0 0 0 13.25 7a1.312 1.312 0 0 0-.363-.888 1.25 1.25 0 0 0-.412-.262ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a10 10 0 0 1-10 10Z"
            }
        ]
    },
    "italic": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 6h-6a1 1 0 0 0 0 2h1.52l-3.2 8H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-1.52l3.2-8H17a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "key": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m21.679 6.532-1.418-1.41 1.418-1.409a1.005 1.005 0 0 0 0-1.419 1.001 1.001 0 0 0-1.418 0L9.74 12.83a4.986 4.986 0 0 0-6.616 1.012 5.003 5.003 0 0 0 .338 6.694 4.986 4.986 0 0 0 6.684.339 5.003 5.003 0 0 0 1.011-6.626l4.872-4.888 1.407 1.42a.998.998 0 0 0 .709.29.998.998 0 0 0 1.004-1 1 1 0 0 0-.295-.71l-1.418-1.36 1.418-1.419 1.407 1.42a.998.998 0 0 0 .709.29.998.998 0 0 0 .709-.29 1 1 0 0 0 0-1.47ZM7 19.778a2.778 2.778 0 1 1 0-5.556 2.778 2.778 0 0 1 0 5.556Z"
            }
        ]
    },
    "language": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 7h1c.552 0 .999.448 1 1v1a1 1 0 1 0 2 0V8a3.003 3.003 0 0 0-3-3h-1a1 1 0 1 0 0 2Zm-4 9H8a1 1 0 0 1-1-1v-1a1 1 0 0 0-2 0v1a3.003 3.003 0 0 0 3 3h1a1 1 0 1 0 0-2Zm11-1a1 1 0 1 0 0-2h-3v-.5a1 1 0 0 0-2 0v.5h-3a1 1 0 0 0 0 2h5.184a6.728 6.728 0 0 1-1.226 2.527 6.668 6.668 0 0 1-.629-.983 1 1 0 0 0-1.78.912c.27.52.592 1.012.96 1.468-.726.527-1.55.9-2.425 1.099a1 1 0 0 0 .427 1.954 8.635 8.635 0 0 0 3.445-1.622 8.724 8.724 0 0 0 3.468 1.622 1 1 0 1 0 .431-1.954 6.725 6.725 0 0 1-2.446-1.09A8.736 8.736 0 0 0 19.221 15H20ZM6 2a2.28 2.28 0 0 1 2.212 1.728l1.758 7.03a1 1 0 0 1-1.94.485L7.468 9H4.53l-.56 2.243a1 1 0 0 1-1.94-.486l1.757-7.03A2.281 2.281 0 0 1 6 2Zm0 2.025a.291.291 0 0 0-.273.188L5.03 7h1.94l-.697-2.787A.291.291 0 0 0 6 4.025Z"
            }
        ]
    },
    "launch": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M6 12H3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Zm1-4H3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2Z"
            },
            {
                "d": "M12.5 6c1.898 0 3.438 1.58 3.438 3.53a3.513 3.513 0 0 1-1.17 2.625c1.966.914 3.23 2.924 3.232 5.14a.697.697 0 0 1-.688.705.697.697 0 0 1-.687-.706c0-2.339-1.847-4.235-4.125-4.235s-4.125 1.896-4.125 4.235c0 .39-.308.706-.688.706A.697.697 0 0 1 7 17.294c.002-2.215 1.266-4.225 3.231-5.139A3.513 3.513 0 0 1 9.063 9.53C9.063 7.58 10.601 6 12.5 6Zm0 1.412c-1.14 0-2.063.948-2.063 2.117 0 1.17.924 2.118 2.063 2.118.547 0 1.072-.223 1.458-.62.387-.397.604-.936.604-1.498 0-1.17-.923-2.117-2.062-2.117Zm6.67 4.461c.875-1.04 1.09-2.523.55-3.79C19.18 6.814 17.986 6 16.67 6c-.37 0-.669.316-.669.706 0 .39.3.706.669.706 1.108 0 2.007.948 2.007 2.117a2.144 2.144 0 0 1-1.004 1.829.713.713 0 0 0-.334.593.718.718 0 0 0 .3.607l.262.183.087.05c1.646.824 2.69 2.58 2.675 4.503 0 .39.3.706.669.706.37 0 .669-.316.669-.706.011-2.202-1.06-4.254-2.83-5.421Z"
            }
        ]
    },
    "left-indent": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3 7h18a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm0 4h10a1 1 0 0 0 0-2H3a1 1 0 1 0 0 2Zm18.77-1.31a1 1 0 0 0-1.41-.12l-2 1.66a1 1 0 0 0 0 1.54l2 1.66a1 1 0 0 0 .64.24 1 1 0 0 0 .64-1.77l-1.08-.9 1.08-.9a1 1 0 0 0 .13-1.41ZM21 17H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2ZM3 15h10a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2Z"
            }
        ]
    },
    "light": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m16.417 4.316.22.174v-.016c2.749 2.284 3.159 6.372.918 9.163a4.24 4.24 0 0 0-.978 2.371l-.014.239v2.299a2.448 2.448 0 0 1-2.277 2.449l-.16.005h-3.25a2.445 2.445 0 0 1-2.433-2.293l-.005-.161V16.09a3.728 3.728 0 0 0-.927-2.348 6.635 6.635 0 0 1-1.397-5.44 6.523 6.523 0 0 1 5.095-5.171 6.466 6.466 0 0 1 5.208 1.184Zm-1.479 13.411h-4.875v.819c0 .451.364.818.812.818h3.25a.815.815 0 0 0 .813-.818v-.819Zm-3.42-12.991a4.886 4.886 0 0 0-3.616 3.19 4.935 4.935 0 0 0 .86 4.762 5.337 5.337 0 0 1 1.29 3.135l.01.268h1.626v-2.454c0-.452.364-.818.812-.818.415 0 .757.312.807.715l.006.103v2.454h1.625a5.856 5.856 0 0 1 1.357-3.469 4.84 4.84 0 0 0 1.08-3.076 4.922 4.922 0 0 0-1.793-3.807 4.85 4.85 0 0 0-4.065-1.003Z"
            }
        ]
    },
    "lightbulb-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m16.417 4.316.22.174v-.016c2.749 2.284 3.159 6.372.918 9.163a4.24 4.24 0 0 0-.978 2.371l-.014.239v2.299a2.448 2.448 0 0 1-2.277 2.449l-.16.005h-3.25a2.445 2.445 0 0 1-2.433-2.293l-.005-.161V16.09a3.728 3.728 0 0 0-.927-2.348 6.635 6.635 0 0 1-1.397-5.44 6.523 6.523 0 0 1 5.095-5.171 6.466 6.466 0 0 1 5.208 1.184Zm-1.479 13.411h-4.875v.819c0 .451.364.818.812.818h3.25a.815.815 0 0 0 .813-.818v-.819Zm-3.42-12.991a4.886 4.886 0 0 0-3.616 3.19 4.935 4.935 0 0 0 .86 4.762 5.337 5.337 0 0 1 1.29 3.135l.01.268h1.626v-2.454c0-.452.364-.818.812-.818.415 0 .757.312.807.715l.006.103v2.454h1.625a5.856 5.856 0 0 1 1.357-3.469 4.84 4.84 0 0 0 1.08-3.076 4.922 4.922 0 0 0-1.793-3.807 4.85 4.85 0 0 0-4.065-1.003Z"
            }
        ]
    },
    "link": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m11.98 15.385-3.88 3.88a2.52 2.52 0 0 1-3.5 0 2.47 2.47 0 0 1 0-3.5l3.88-3.88a1.004 1.004 0 0 0-1.42-1.42l-3.88 3.89a4.48 4.48 0 0 0 6.33 6.33l3.89-3.88a1.004 1.004 0 1 0-1.42-1.42Zm8.58-12.08a4.49 4.49 0 0 0-6.33 0l-3.89 3.88a1.004 1.004 0 0 0 1.42 1.42l3.88-3.88a2.52 2.52 0 0 1 3.5 0 2.47 2.47 0 0 1 0 3.5l-3.88 3.88a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l3.88-3.89a4.49 4.49 0 0 0 0-6.33Z"
            },
            {
                "d": "M8.7 15.165a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l4.92-4.92a1.004 1.004 0 1 0-1.42-1.42l-4.92 4.92a1 1 0 0 0 0 1.42Z"
            }
        ]
    },
    "list-ui-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.5 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 2h14a1 1 0 0 0 0-2h-14a1 1 0 1 0 0 2Zm0 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10-5h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Zm0 5h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "loading": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.614 2.002a9.968 9.968 0 0 1 7.137 2.796 10.147 10.147 0 0 1 3.115 7.135v.003c-.002.034 0 .07 0 .106 0 .707-.575 1.281-1.282 1.281-.026 0-.052-.002-.076-.003a8.985 8.985 0 0 1-.532 2.08 9.092 9.092 0 0 1-1.907 2.991 9.177 9.177 0 0 1-6.456 2.834 9.335 9.335 0 0 1-6.683-2.609 9.507 9.507 0 0 1-2.125-3.034 9.644 9.644 0 0 1-.147-7.358 9.782 9.782 0 0 1 2.047-3.2 9.832 9.832 0 0 1 6.91-3.022Zm.001 1.921a8.01 8.01 0 0 0-3.096.533 8.153 8.153 0 0 0-2.68 1.7A8.235 8.235 0 0 0 3.99 8.773a8.33 8.33 0 0 0-.706 3.158 8.334 8.334 0 0 0 .557 3.22 8.464 8.464 0 0 0 1.768 2.784 8.555 8.555 0 0 0 2.723 1.916 8.626 8.626 0 0 0 3.281.73A8.663 8.663 0 0 0 14.956 20a8.804 8.804 0 0 0 2.888-1.838 8.873 8.873 0 0 0 1.986-2.827 8.797 8.797 0 0 0 .617-2.023 1.281 1.281 0 0 1-1.138-1.38 7.816 7.816 0 0 0-.514-2.973 7.827 7.827 0 0 0-1.63-2.577 7.933 7.933 0 0 0-2.515-1.777 7.978 7.978 0 0 0-3.035-.682Z"
            }
        ]
    },
    "lock": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 13a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1Zm5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3ZM9 7a3 3 0 0 1 6 0v2H9V7Zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7Z"
            }
        ]
    },
    "logout-left": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15 20h4a.994.994 0 0 0 .707-.293A.994.994 0 0 0 20 19V5a.994.994 0 0 0-.293-.707A.994.994 0 0 0 19 4h-4a1 1 0 0 1 0-2h4a2.997 2.997 0 0 1 3 3v14a2.997 2.997 0 0 1-3 3h-4a1 1 0 0 1 0-2Z"
            },
            {
                "d": "M5.414 11H15a1 1 0 0 1 0 2H5.414l3.293 3.293a.999.999 0 1 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L5.414 11Z"
            }
        ]
    },
    "logout": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9 20H5a.994.994 0 0 1-.707-.293A.994.994 0 0 1 4 19V5c0-.276.111-.525.293-.707A.994.994 0 0 1 5 4h4a1 1 0 0 0 0-2H5a2.997 2.997 0 0 0-3 3v14a2.997 2.997 0 0 0 3 3h4a1 1 0 0 0 0-2Z"
            },
            {
                "d": "M18.586 11H9a1 1 0 0 0 0 2h9.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5a.999.999 0 1 0-1.414 1.414L18.586 11Z"
            }
        ]
    },
    "mail-add": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 7h1v1a1 1 0 0 0 2 0V7h1a1 1 0 0 0 0-2h-1V4a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2Z"
            },
            {
                "d": "M21 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.41l5.88 5.89a3 3 0 0 0 4.24 0l2.47-2.47a1.004 1.004 0 0 0-1.42-1.42l-2.47 2.47a1 1 0 0 1-1.4 0L5.41 7H13a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "mail-send": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M4.79 10.5h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Zm16.78-2.84V7.6a3 3 0 0 0-2.37-1.1h-7.93a3 3 0 0 0-2 .74A2.93 2.93 0 0 0 8.31 9l-.88 5a3 3 0 0 0 2.95 3.52h7.94a3 3 0 0 0 3-2.48l.88-5a3 3 0 0 0-.63-2.38Zm-2.74.84-3.4 2.76a1 1 0 0 1-1.38-.12L11.72 8.5h7.11Zm.48 6.17a1 1 0 0 1-1 .83h-7.93a1 1 0 0 1-.76-.36 1 1 0 0 1-.22-.81l.8-4.53 2.35 2.66a3 3 0 0 0 4.14.35L20.13 10l-.82 4.67ZM5.79 6.5h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Z"
            }
        ]
    },
    "mail": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Zm1 5.28-7.52 4.57a1 1 0 0 1-1 0L4 9.28V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.28ZM19 6H5a1 1 0 0 0-1 1l8 4.88L20 7a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "mail_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M5 10H3a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2Zm3.724-2.216 4.036 4.176a3 3 0 0 0 4.14.35l5.36-4.309a3 3 0 0 1 .15 1.54l-.88 5a3 3 0 0 1-3 2.48h-7.94a3 3 0 0 1-2.95-3.52l.88-5a2.93 2.93 0 0 1 .204-.717ZM19.41 6a3 3 0 0 1 1.748.528L15.64 10.76a1 1 0 0 1-1.38-.12l-4.155-4.32A3 3 0 0 1 11.48 6ZM6 6H3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Z"
            }
        ]
    },
    "manual": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "fill-rule": "evenodd",
                "d": "M19 12V6.5c0-.4 0-.7-.3-.9a.8.8 0 0 0-1 0c-.2.2-.4.4-.4.8v4c0 .4-.2.6-.5.6-.2 0-.4-.2-.4-.7V4.6c0-.5-.5-1-1-.8-.5 0-.8.4-.8 1V10.6c0 .2-.2.4-.4.4a.4.4 0 0 1-.4-.3V2.9c0-.4-.3-.7-.6-.9a.8.8 0 0 0-1 .2c-.2.2-.3.4-.3.7v7.5c0 .5-.1.7-.4.7-.3 0-.5-.2-.5-.7V4.6c0-.5-.5-1-1-.8-.5 0-.7.4-.7 1V14c0 .6-.3.8-.8.5l-2.9-1.4-.5-.2c-.4-.1-.7-.1-1 .2-.3.3-.3.8.1 1.2l5.6 5.7a5.5 5.5 0 0 0 5.6 1.8 5 5 0 0 0 3.7-4.8V12ZM13.2 1c.4.1.8.3 1 .6.4.4.5.9.5 1.5.7-.4 1.3-.4 1.9 0 .6.4.8 1 .8 1.8l.5-.2c1.2-.2 2.2.6 2.2 1.9V17c0 2.2-1 4-3 5.1-1.2.7-2.5 1-3.8.7-1-.1-2-.4-2.7-1l-1.3-1L3.6 15c-.8-.9-.8-2 0-2.7.6-.4 1.1-.5 1.7-.3l.7.2 2 1.1.4.1V4.8c0-.8.3-1.4 1-1.8.4-.2 1-.2 1.4 0h.2l.1-.6c.2-.7.6-1.1 1.3-1.3l.1-.1h.6Z",
                "clip-rule": "evenodd"
            },
            {
                "d": "M19 12v-.4h-.2v.3h.3Zm0 0v.2h.4V12H19Zm0-5.4h.4-.3Zm-.3-.9.1-.2-.1.2Zm-1 0 .2.3-.1-.3Zm-.4.8h.3-.3Zm0 4h.3-.3Zm-.5.6v.3-.3Zm-.4-.7h.3-.3Zm0-4.8h-.3.3Zm0-1H16h.3Zm-1-.8-.1-.3v.3Zm-.8 1h-.3.3Zm0 5.6h.3-.3Zm0 .3h-.3.3Zm-.4.4v.3-.3Zm-.4-.3h-.3.3Zm0-.4h-.4.3Zm0-7.5h.2-.3Zm-.6-.9-.1.3V2Zm-1 .2.2.2-.2-.2Zm-.3.7h-.3.3Zm0 7.5h.3-.3Zm-.4.7v.3-.3Zm-.5-.7h-.3.3Zm0-4h.3-.3Zm0-1.8h-.3.3Zm-1-.8V4v-.3Zm-.7 1H9h.3Zm0 9.3H9h.3Zm-.8.5-.2.3.2-.3Zm-2.9-1.4.2-.3-.2.3Zm-.5-.2v.3-.3Zm-1 .2L4 13l.2.2Zm.1 1.2-.2.2.2-.2Zm5.6 5.7.2-.2-.2.2Zm1.4 1.2-.1.3.1-.3Zm4.2.6v.3-.3Zm3.7-4.8h.3-.3ZM13 1l.1-.3V1Zm1 .6.3-.2-.3.2Zm.5 1.5h-.3v.4l.5-.2-.2-.2Zm1.9 0-.2.3.2-.3Zm.8 1.8H17v.4l.4-.1v-.3Zm.5-.2v-.3.3ZM20 6.6h-.3.3ZM20 17h-.3.3Zm-3 5.1.1.3-.1-.3Zm-3.8.7v-.3.3Zm-2.7-1-.2.2.2-.2Zm-1.3-1 .2-.3-.2.3ZM3.6 15l.2-.2-.2.2Zm0-2.7.3.2-.2-.2Zm1.7-.3v-.3.3Zm.7.2.1-.2-.1.2Zm2 1.1.2-.3-.1.3Zm.4.1-.2.3.5.2v-.5h-.3Zm0-8.7H8h.3Zm1-1.8.1.3-.1-.3Zm1.4 0v.2V3Zm.2 0-.1.3.4.2V3H11Zm.1-.6h.3-.3ZM12.4 1l-.1-.3V1Zm.1-.1V.7 1Zm6.6 11.2v-.6.6Zm.3-.3V6.6h-.6v5.3h.6Zm0-5.3c0-.5-.2-.9-.6-1.1l-.3.5c.2.1.3.3.3.6h.6Zm-.6-1.1c-.4-.3-.8-.3-1.2 0l.3.5h.6l.3-.5Zm-1.2 0c-.4.2-.6.5-.6 1h.6c0-.2.1-.4.3-.5l-.3-.6Zm-.6 1v4h.6v-4H17Zm0 4v.2h-.1v.7c.2 0 .4-.1.5-.3.2-.2.2-.4.2-.7H17Zm-.1.3h-.1l-.1-.4h-.6c0 .3 0 .5.2.7.1.2.3.3.5.3v-.6Zm-.2-.4V5.6h-.6v4.8h.6Zm0-4.8v-1H16v1h.6Zm0-1c0-.7-.7-1.3-1.4-1.1l.1.6c.3-.1.7.2.7.5h.6Zm-1.4-1.1c-.3 0-.5.2-.7.4-.2.2-.3.5-.3.8h.6c0-.2 0-.3.2-.4l.3-.2-.1-.6Zm-1 1.2v5.7h.6V4.7h-.6Zm0 5.7v.3l.6.1v-.4h-.6Zm0 .3h-.1v.7c.3 0 .6-.3.7-.6l-.6-.1Zm-.1 0H14l-.5.1c0 .4.3.6.7.6v-.6Zm-.2 0v-.3h-.6v.4l.6-.1Zm0-.3V3h-.6v7.5h.6ZM14 3c0-.3 0-.5-.2-.7 0-.2-.3-.4-.5-.5l-.2.6.2.2.1.4h.6Zm-.7-1.2c-.4-.2-.9-.1-1.3.2l.4.5c.2-.2.4-.2.7-.1l.2-.6ZM12 2c-.3.3-.4.7-.4 1h.6l.2-.5-.4-.5Zm-.4 1v7.5h.6V3h-.6Zm0 7.5v.3h-.1v.7l.6-.3.1-.7h-.6Zm-.1.4h-.1v-.4h-.7c0 .3 0 .5.2.7.1.2.4.3.6.3v-.6Zm-.2-.4v-4h-.6v4h.6Zm0-4V4.6h-.6v1.8h.6Zm0-1.8c0-.7-.7-1.3-1.4-1.1l.1.6c.4-.1.7.2.7.5h.6ZM10 3.5c-.3 0-.5.2-.7.4-.2.3-.2.5-.2.8h.6l.1-.4.3-.2v-.6ZM9 4.7v9.4h.7V4.7H9Zm0 9.4v.3h-.3l-.3.5c.3.1.6.2 1 0 .2-.1.3-.5.3-.8H9Zm-.3.3-2.8-1.5-.3.6 2.8 1.4.3-.5Zm-2.8-1.5-.7-.2v.6l.4.2.3-.6Zm-.7-.2c-.3-.1-.8-.1-1.2.3l.4.4c.2-.2.4-.2.7-.1l.1-.6ZM4 13a1 1 0 0 0-.3.8c0 .3.2.6.4.8l.4-.4a.7.7 0 0 1-.2-.4l.1-.4L4 13Zm.1 1.6 5.6 5.7.4-.4-5.6-5.7-.4.4Zm5.6 5.7c.4.5 1 1 1.5 1.3l.3-.6a6 6 0 0 1-1.4-1l-.4.3Zm1.5 1.3c1.3.7 2.8 1 4.3.6l-.1-.6c-1.4.4-2.7.1-4-.6l-.2.6Zm4.3.6c2.3-.6 4-2.7 4-5h-.6c0 2-1.5 4-3.5 4.4l.1.6Zm4-5v-5.3h-.6v5.2h.6ZM13 1.1c.4.2.7.3 1 .6l.4-.4C14 1 13.6.8 13.2.7l-.2.6Zm1 .6c.2.3.3.7.3 1.3h.6c0-.7-.1-1.2-.5-1.7l-.5.4Zm.8 1.5c.5-.2 1-.2 1.5 0l.4-.4a2 2 0 0 0-2.2-.1l.3.5Zm1.5 0c.5.4.7 1 .7 1.6h.6c0-.8-.2-1.5-1-2l-.3.5Zm1.1 1.9.3-.1.2-.1-.1-.6h-.3l-.3.2.2.6Zm.5-.2c1-.2 1.8.5 1.8 1.6h.6c0-1.4-1.2-2.5-2.5-2.2V5Zm1.8 1.6V17h.6V6.6h-.6Zm0 10.5c0 2.1-1 3.8-2.9 4.9l.3.5c2-1.2 3.1-3 3.2-5.4h-.6ZM16.8 22c-1 .6-2.3.8-3.5.6l-.1.6c1.4.2 2.7 0 4-.7l-.4-.5Zm-3.5.6c-1-.1-1.9-.4-2.7-1l-.3.5c.9.6 1.8 1 2.9 1.1v-.6Zm-2.7-1-1.2-1-.4.5 1.3 1 .3-.5Zm-1.2-1L3.8 15l-.4.4L9 21l.4-.5ZM3.8 15c-.7-.8-.7-1.7 0-2.3l-.3-.5c-1 .8-1 2.2-.1 3.2l.4-.4Zm0-2.3c.5-.3 1-.4 1.4-.2l.2-.6a2 2 0 0 0-1.9.3l.4.5Zm1.4-.2.7.2.2-.5c-.2-.2-.4-.3-.7-.3l-.2.6Zm.7.2 2 1 .3-.5-2-1-.3.5Zm2 1 .3.2.3-.5-.3-.2-.2.6Zm.8 0V13.2H8v.2h.6Zm0-.3V4.8H8v8.5h.6Zm0-8.5c0-.7.2-1.2.8-1.5l-.3-.5c-.8.4-1.1 1.1-1.1 2h.6Zm.8-1.5c.4-.2.8-.2 1.2 0l.2-.6a2 2 0 0 0-1.7 0l.3.6Zm1.2 0h.2l.2-.5-.2-.1-.2.5Zm.6-.2v-.6l-.5-.2V3h.5Zm0-.6c.2-.6.6-1 1.2-1.1l-.2-.6a2 2 0 0 0-1.5 1.5l.6.2Zm1.2-1.1.1-.1-.2-.6h-.1l.2.7Zm0-.1h.6V.7h-.6v.6Z"
            }
        ]
    },
    "map": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a8 8 0 0 0-8 8c0 5.4 7.05 11.5 7.35 11.76a1 1 0 0 0 1.3 0C13 21.5 20 15.4 20 10a8 8 0 0 0-8-8Zm0 17.65c-2.13-2-6-6.31-6-9.65a6 6 0 1 1 12 0c0 3.34-3.87 7.66-6 9.65ZM12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
            }
        ]
    },
    "medal": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M14.95 2.046a1 1 0 0 1 .76.104l5.2 3a1 1 0 0 1 .47.61 1 1 0 0 1-.14.76l-3.9 6.76A6 6 0 1 1 6 16a5.91 5.91 0 0 1 .72-2.66l-4-6.83a1 1 0 0 1-.1-.75 1 1 0 0 1 .47-.61l5.2-3a1 1 0 0 1 1.37.36L12 6.57l2.34-4.06a1 1 0 0 1 .61-.464ZM12 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM8.46 4.38 5 6.38l3 5.2A5.94 5.94 0 0 1 11.68 10L8.46 4.38Zm7.12 0-2.42 4.19.98 1.83A5.9 5.9 0 0 1 16 11.55l3.04-5.17-3.46-2Z"
            }
        ]
    },
    "meet_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a1 1 0 0 1 1 1v1h8a1 1 0 0 1 1 1v10a3 3 0 0 1-3 3h-4.59l2.3 2.29a1 1 0 0 1 0 1.42 1 1 0 0 1-1.42 0L13 19.41V21a1 1 0 0 1-2 0v-1.59l-2.29 2.3a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42L9.59 18H5a3 3 0 0 1-3-3V5a1 1 0 0 1 1-1h8V3a1 1 0 0 1 1-1Zm1 10H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2ZM9 8H7a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2Z"
            }
        ]
    },
    "meeting": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7 10h2a1 1 0 1 0 0-2H7a1 1 0 1 0 0 2Z"
            },
            {
                "d": "M12 2a1 1 0 0 1 1 1v1h8a1 1 0 0 1 1 1v10a3 3 0 0 1-3 3h-4.59l2.3 2.29a1 1 0 0 1 0 1.42 1 1 0 0 1-1.42 0L13 19.41V21a1 1 0 0 1-2 0v-1.59l-2.29 2.3a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42L9.59 18H5a3 3 0 0 1-3-3V5a1 1 0 0 1 1-1h8V3a1 1 0 0 1 1-1Zm8 4H4v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6Z"
            },
            {
                "d": "M7 14h6a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2Z"
            }
        ]
    },
    "message-check": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16.29 9.71a1 1 0 0 0 1.42 0l4-4a1.004 1.004 0 1 0-1.42-1.42L17 7.59l-1.29-1.3a1.004 1.004 0 1 0-1.42 1.42l2 2Z"
            },
            {
                "d": "M21 9a1 1 0 0 0-1 1v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9.41l5.88 5.89a3 3 0 0 0 2.11.87 3.08 3.08 0 0 0 2.16-.9l1.72-1.72a1.004 1.004 0 1 0-1.42-1.42l-1.75 1.75a1 1 0 0 1-1.4 0L5.41 8H11a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "message-exclamation": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 13.5a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.91l5.88 5.88a3 3 0 0 0 4.24 0l3.59-3.58a1.004 1.004 0 0 0-1.42-1.42l-3.58 3.59a1 1 0 0 1-1.42 0L5.41 7.5H17a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1Zm0-11a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M20.8 9.5a.64.64 0 0 0-.18.06.76.76 0 0 0-.18.09l-.15.12a1.05 1.05 0 0 0-.29.71 1.23 1.23 0 0 0 0 .19.6.6 0 0 0 .06.19.76.76 0 0 0 .09.18c.037.052.077.102.12.15a1 1 0 0 0 1.42 0l.12-.15a.76.76 0 0 0 .09-.18.6.6 0 0 0 .06-.19 1.23 1.23 0 0 0 0-.19 1 1 0 0 0-1.2-1l.04.02Z"
            }
        ]
    },
    "message-receive": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m8.29 6.21 2 2a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29H15a1 1 0 0 0 0-2h-3.59l.3-.29a1.004 1.004 0 0 0-1.42-1.42l-2 2a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33ZM16 10.5a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3Zm1 3.41-2.88 2.88a3 3 0 0 1-2.12.88 2.94 2.94 0 0 1-2.12-.89L7 13.91v4.59a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-4.59Zm-1.42-1.41H8.42l2.88 2.88a1 1 0 0 0 1.4 0l2.88-2.88Z"
            }
        ]
    },
    "message-search": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16.817 2.01a4.31 4.31 0 0 1 4.313 4.3 4.37 4.37 0 0 1-.65 2.26l1.73 1.72a1 1 0 0 1 0 1.44 1 1 0 0 1-1.42 0L19.07 10a4.37 4.37 0 0 1-2.26.63 4.31 4.31 0 0 1 .007-8.62ZM16.81 4a2.32 2.32 0 0 0-2.31 2.36A2.3 2.3 0 0 0 15.18 8a2.37 2.37 0 0 0 3.27 0 2.3 2.3 0 0 0 .68-1.69 2.28 2.28 0 0 0-.68-1.63A2.3 2.3 0 0 0 16.81 4Z"
            },
            {
                "d": "M20.5 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V9.41l5.88 5.89a3 3 0 0 0 4.24 0L15 13.88a1.004 1.004 0 1 0-1.42-1.42l-1.38 1.42a1 1 0 0 1-1.4 0L4.91 8H9.5a1 1 0 0 0 0-2h-5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "message": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.842 3.753a2.725 2.725 0 0 1 3.085-.465l12.666 6.3a2.69 2.69 0 0 1 .01 4.824l-12.667 6.3c-.38.185-.798.284-1.222.288a2.718 2.718 0 0 1-2.276-1.23 2.688 2.688 0 0 1-.203-2.568l2.172-4.833a.95.95 0 0 0 0-.738L3.235 6.798a2.69 2.69 0 0 1 .607-3.045ZM6.122 4.9a.908.908 0 0 0-1.02.163A.897.897 0 0 0 4.9 6.07l2.162 4.833c.028.065.053.13.073.198h6.234c.5 0 .904.403.904.9s-.405.9-.904.9H7.135c-.02.067-.045.133-.073.198L4.9 17.931a.897.897 0 0 0 .202 1.007.908.908 0 0 0 1.02.163l12.666-6.3a.9.9 0 0 0 0-1.602Z"
            }
        ]
    },
    "minus-circle": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            },
            {
                "d": "M16 11H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "minus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "mobile": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m12.71 16.29-.15-.12a.76.76 0 0 0-.18-.09L12.2 16a1 1 0 0 0-.91.27 1.15 1.15 0 0 0-.21.33 1 1 0 0 0 1.3 1.31c.12-.058.23-.132.33-.22a1 1 0 0 0 .21-1.09 1 1 0 0 0-.21-.31Z"
            },
            {
                "d": "M16 2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm0 2H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "modify": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M1.226 0C.998 0 .801.131.686.36l-.01.026c-.332 1.95-.192 3.99.383 5.597.933 2.768 3.202 4.532 6.235 4.842h.072c.052 0 .119.001.185-.027.123.296.317.703.606 1.15l-6.39 6.492c-.394.4-.61.947-.596 1.5.013.523.226.998.595 1.334l2.12 2.159c.375.381.844.566 1.433.566h.078c.548 0 1.036-.304 1.356-.566l5.771-5.942c.077.08.156.158.234.237l.157.158c1.846 1.874 3.895 3.592 5.627 4.715 1.34.849 2.273 1.244 2.933 1.244.38 0 .685-.112.905-.334 1.438-1.466-2.526-6.553-5.54-9.616l-.162-.164a32.52 32.52 0 0 1-.228-.23l4.228-4.295.05-.06v-.002l2.728-7.079c.098-.196.01-.39-.094-.496a.5.5 0 0 0-.232-.123c-.11-.027-.203-.018-.264.028L15.922 4.16 10.92 9.145c-.474-.27-.888-.486-1.332-.711v-.868C9.513 5.06 7.864 3.164 5.472 2.85c-.305 0-.594 0-.91-.075-.441 0-.822 0-1.187-.076C2.52 2.483 1.404 1.604 1.623.561V.482c0-.198-.178-.379-.354-.47zm.248 2.658c.484.499 1.107.865 1.707 1 .465.08.993.08 1.46.08h.82c1.872.225 3.18 1.735 3.256 3.756v.733L7.18 9.857C4.618 9.47 2.752 7.991 1.926 5.695a12.24 12.24 0 0 1-.452-3.037Zm20.737.069-.4.933a1.784 1.784 0 0 1-.577-.582Zm-2 .728c.236.498.653.921 1.144 1.16l-1.46 3.862h-1.28v-.983c0-.667-.576-1.252-1.232-1.252h-.971V4.94Zm-4.668 2.268v.384c0 .192-.035.536-.28.702l-3.05 3.101a4.632 4.632 0 0 1-.461-.338Zm1.082 1.558h.758c.172 0 .285.114.285.29v.769c0 .233-.098.501-.28.781l-2.742 2.787a34 34 0 0 0-.937-.785c-.23-.189-.454-.37-.666-.553l2.89-3.008c.193-.2.394-.28.692-.28Zm-7.49 1.944c.5.218 1.017.45 1.601.894l1.305.861.037.03c.337.273.686.556 1.088.834a4.651 4.651 0 0 1-2.28 2.31l-.107-.136c-.256-.326-.308-.333-.496-.645l-.453-.717c-.124-.184-.047-.104-.164-.27-.173-.244-.337-.475-.473-.704a19.555 19.555 0 0 1-.875-1.63Zm9.837.134h.375l-3.558 3.547-.397-.404 2.737-2.783.08-.076c.181-.188.438-.284.763-.284zm-5.052 3.145c.051.045.1.083.15.121.073.055.141.106.219.182.183.15.371.321.553.488.19.174.39.356.578.506.224.232.45.464.68.695 4.717 4.871 5.888 7.981 5.536 8.342-.101.1-.798.134-2.613-1.018-1.637-1.06-3.518-2.653-5.443-4.61a72.743 72.743 0 0 1-.68-.694 12.91 12.91 0 0 1-.988-1.157l-.02-.02a3.26 3.26 0 0 1-.365-.413 5.849 5.849 0 0 0 2.393-2.422zm-5.274.303c.056.079.112.149.166.218.062.078.12.151.178.237l-3.063 3.111-.394-.404zm.918 1.222c.172.207.343.426.52.649.252.318.512.647.795.978l-2.827 2.875-1.459-1.484zm1.899 2.387.076.088c.09.105.188.223.31.324l-2.736 2.78-.396-.403Zm-6.672.229 3.68 3.738-.514.44-3.639-3.698Zm-1.139 1.31 3.58 3.635-1.219 1.166-.002.002a1.012 1.012 0 0 1-1.455 0L2.441 20.61a.873.873 0 0 0-.117-.16c-.06-.07-.094-.113-.094-.168l-.01-.045c-.066-.132-.066-.192-.066-.34 0-.124 0-.267.049-.316l.017-.025c.037-.074.073-.128.11-.184.037-.057.073-.113.111-.187z"
            }
        ]
    },
    "more-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm14 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "more": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-7a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "music": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21.65 2.241a1 1 0 0 0-.8-.23l-13 2a1 1 0 0 0-.85.99v10.35a3.45 3.45 0 0 0-1.5-.35 3.5 3.5 0 1 0 3.5 3.5v-7.64l11-1.69v4.18a3.45 3.45 0 0 0-1.5-.35 3.5 3.5 0 1 0 3.5 3.5v-13.5a1 1 0 0 0-.35-.76ZM5.5 20.001a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm13-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM20 7.141 9 8.831v-3l11-1.66v2.97Z"
            }
        ]
    },
    "newspaper": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 11h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm0 4h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2Zm-6-6h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2Z"
            },
            {
                "d": "M21 3a1 1 0 0 1 .993.883L22 4v13a4 4 0 0 1-3.8 3.995L18 21H5a3 3 0 0 1-2.995-2.824L2 18V8a1 1 0 0 1 .883-.993L3 7h3V4a1 1 0 0 1 .883-.993L7 3h14Zm-1 2H8v13a3 3 0 0 1-.117.806L7.82 19H18a2 2 0 0 0 1.995-1.85L20 17V5ZM6 9H4v9a1 1 0 0 0 2 0V9Z"
            },
            {
                "d": "M11 13h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2Zm0 4h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2Z"
            }
        ]
    },
    "no-download-arrow": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21.494 1.709c-.255 0-.51.1-.707.297L1.695 21.098a.992.992 0 0 0 0 1.414.992.992 0 0 0 1.414 0L22.201 3.42a.992.992 0 0 0 0-1.414.997.997 0 0 0-.707-.297zM12 2a1 1 0 0 0-1 1v8.086l2-2V3a1 1 0 0 0-1-1zM8.002 9.996a1 1 0 0 0-.973.744c-.093.347.006.717.26.971l1.543 1.543 1.418-1.418-1.54-1.547a1.006 1.006 0 0 0-.708-.293zm8.275.055-5.324 5.324.336.336a.998.998 0 0 0 .33.209c.242.107.52.107.762 0a.997.997 0 0 0 .33-.21l4-4a1.006 1.006 0 0 0 0-1.421.98.98 0 0 0-.434-.238zM3 14a1 1 0 0 0-1 1v4c0 .325.065.633.16.926L4 18.086V15a1 1 0 0 0-1-1zm18 0a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H6.328l-1.937 1.938c.196.04.4.062.61.062h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1z"
            }
        ]
    },
    "notes": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 1 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 1 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v13Z"
            }
        ]
    },
    "observer": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21.41 8.651v-.06a10 10 0 0 0-18.78-.06.85.85 0 0 0-.08.24 10 10 0 1 0 18.86-.12ZM12 4.001a8 8 0 0 1 6.92 4h-1.2a3 3 0 0 0-4.62.22 3.17 3.17 0 0 0-1.1-.22 3.17 3.17 0 0 0-1.1.22 3 3 0 0 0-4.62-.22h-1.2a8 8 0 0 1 6.92-4Zm4.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.5 10a8 8 0 0 1-8-8 8.24 8.24 0 0 1 .26-2H5.5a3.001 3.001 0 0 0 6 .18 1 1 0 0 1 1 0 3.001 3.001 0 0 0 6-.18h1.24a8.24 8.24 0 0 1 .26 2 8 8 0 0 1-8 8Zm2.36-5.77a3.76 3.76 0 0 1-4.72 0 1.001 1.001 0 1 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1.001 1.001 0 0 0-1.28-1.54Z"
            }
        ]
    },
    "ongoing": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Z"
            }
        ]
    },
    "optional": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7.992 1.5a1.498 1.498 0 0 0-1.24.668C4.595 5.404 3.5 8.688 3.5 12c0 3.312 1.095 6.596 3.252 9.832a1.5 1.5 0 1 0 2.496-1.664C7.405 17.403 6.5 14.688 6.5 12c0-2.688.905-5.404 2.748-8.168A1.5 1.5 0 0 0 7.992 1.5zm8.016 0a1.5 1.5 0 0 0-1.256 2.332C16.595 6.596 17.5 9.312 17.5 12c0 2.688-.905 5.404-2.748 8.168a1.5 1.5 0 1 0 2.496 1.664C19.405 18.597 20.5 15.312 20.5 12c0-3.312-1.095-6.596-3.252-9.832a1.498 1.498 0 0 0-1.24-.668z"
            }
        ]
    },
    "order-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M6 12.584v-1.968h12v1.968zM3 5.6h18v2.016H3zm6.984 12v-2.016h4.032V17.6z"
            }
        ]
    },
    "paperclip": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m19.08 12.42-6.18 6.19a4.25 4.25 0 0 1-6-6l8-8a2.57 2.57 0 0 1 3.54 0 2.52 2.52 0 0 1 0 3.54l-6.9 6.89A.764.764 0 0 1 10.42 14l5.13-5.12a1.004 1.004 0 1 0-1.42-1.42L9 12.6a2.74 2.74 0 0 0 0 3.89 2.82 2.82 0 0 0 3.89 0l6.89-6.9a4.5 4.5 0 0 0-6.36-6.36l-8 8A6.25 6.25 0 0 0 14.31 20l6.19-6.18a1.004 1.004 0 1 0-1.42-1.42v.02Z"
            }
        ]
    },
    "paralelo": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M5.15 4a.308.308 0 0 0-.314.3v.3H2.314A.308.308 0 0 0 2 4.9v3c0 .497.423.9.945.9h1.446l-.725.686a.293.293 0 0 0-.094.213c0 .08.034.157.094.213a.322.322 0 0 0 .447 0l.723-.69V9.7c0 .166.14.301.314.301a.308.308 0 0 0 .315-.3v-.477l.72.69c.06.056.141.089.225.089a.322.322 0 0 0 .223-.09.293.293 0 0 0 .094-.213.293.293 0 0 0-.094-.213l-.725-.685h1.447c.522 0 .946-.404.946-.9v-3a.31.31 0 0 0-.317-.301h-2.52v-.3c0-.165-.14-.3-.314-.3zm15.846 1.01a.6.6 0 0 0-.426 1.027l.38.373H10.001a.6.6 0 0 0 0 1.2h10.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176zM2.631 5.2H7.67v2.7c0 .166-.14.3-.315.3h-4.41a.306.306 0 0 1-.314-.3V5.2zm.943.6a.306.306 0 0 0-.314.3c0 .165.14.3.314.3h.631a.308.308 0 0 0 .315-.3.306.306 0 0 0-.315-.3h-.63zm0 1.2a.308.308 0 0 0-.314.3c0 .166.14.3.314.3h1.89a.306.306 0 0 0 .315-.3c0-.165-.14-.3-.314-.3h-1.89zm1.576 8a.308.308 0 0 0-.314.3v.3H2.314a.308.308 0 0 0-.314.3v3c0 .497.423.9.945.9h1.446l-.725.686a.293.293 0 0 0-.094.213c0 .08.034.157.094.213a.322.322 0 0 0 .447 0l.723-.69v.477c0 .166.14.301.314.301a.308.308 0 0 0 .315-.3v-.477l.72.69c.06.056.141.089.225.089a.322.322 0 0 0 .223-.09.293.293 0 0 0 .094-.213.293.293 0 0 0-.094-.213l-.725-.685h1.447c.522 0 .946-.404.946-.9v-3a.31.31 0 0 0-.317-.301h-2.52v-.3c0-.165-.14-.3-.314-.3zm15.846 1.01a.6.6 0 0 0-.426 1.027l.38.373H10.001a.6.6 0 0 0 0 1.2h10.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176zm-18.365.19H7.67v2.7c0 .166-.14.3-.315.3h-4.41a.306.306 0 0 1-.314-.3v-2.7zm.943.6a.306.306 0 0 0-.314.3c0 .165.14.3.314.3h.631a.308.308 0 0 0 .315-.3.306.306 0 0 0-.315-.3h-.63zm0 1.2a.308.308 0 0 0-.314.3c0 .166.14.3.314.3h1.89a.306.306 0 0 0 .315-.3c0-.165-.14-.3-.314-.3h-1.89z"
            }
        ]
    },
    "path": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.111 8c-.456 0-.831.382-.883.874l-.006.115v1.978H5.89c-.456 0-.832.381-.883.873L5 11.955v4.056c0 .546.398.989.889.989.456 0 .831-.382.883-.874l.006-.115v-3.067h5.333c.456 0 .832-.381.883-.873l.006-.116V8.99c0-.546-.398-.989-.889-.989Z"
            },
            {
                "d": "M11.889 8c.456 0 .831.382.883.874l.006.115v1.978h5.333c.456 0 .832.381.883.873l.006.115v4.056c0 .546-.398.989-.889.989-.456 0-.831-.382-.883-.874l-.006-.115v-3.067H11.89c-.456 0-.832-.381-.883-.873L11 11.955V8.99c0-.546.398-.989.889-.989Z"
            },
            {
                "d": "m23 20.2-.007.093c-.057.398-.48.707-.993.707h-8l-.117-.005c-.497-.047-.883-.385-.883-.795V16a1 1 0 0 1 .883-.993L14 15h8a1 1 0 0 1 .993.883L23 16v4.2Zm-8-.8h6V17h-6v2.4Zm-4 .8-.007.093c-.057.398-.48.707-.993.707H2l-.117-.005C1.386 20.948 1 20.61 1 20.2V16a1 1 0 0 1 .883-.993L2 15h8a1 1 0 0 1 .993.883L11 16v4.2Zm-8-.8h6V17H3v2.4ZM17 8.2l-.007.093c-.057.398-.48.707-.993.707H8l-.117-.005C7.386 8.948 7 8.61 7 8.2V4a1 1 0 0 1 .883-.993L8 3h8a1 1 0 0 1 .993.883L17 4v4.2Zm-8-.8h6V5H9v2.4Z"
            }
        ]
    },
    "pause": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16 2a3 3 0 0 0-3 3v14a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-2 0V5a1 1 0 0 1 2 0v14ZM8 2a3 3 0 0 0-3 3v14a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-2 0V5a1 1 0 1 1 2 0v14Z"
            }
        ]
    },
    "pdf": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10.25 12.751c.416.426 1.02 1.021 1.733 1.655l-.032.003.05.04c-.843.107-1.598.293-2.25.552.157-.69.356-1.57.499-2.25zm6.25-9.75 3.75 3.75h-3.46a.29.29 0 0 1-.29-.29zm1.48 13.178c-.163.636-.603.997-1.209.997-.382 0-.712-.153-.775-.184l-.03-.017c-.669-.41-1.354-.87-2.042-1.37-1.27.065-3.063.286-4.513.952l-.078.301c-.473 1.709-1.398 1.893-1.775 1.893a.78.78 0 0 1-.168-.015l-.051-.014a.84.84 0 0 1-.518-.472c-.186-.446.047-.97.097-1.07l.076-.115A5.653 5.653 0 0 1 8.54 15.87c.284-1.086.772-2.976.986-3.958-.25-.242-.396-.391-.428-.423-.59-.645-.811-1.215-.662-1.702.141-.462.576-.688.812-.748.374-.1.773.002 1.02.268.351.38.476 1.112.374 2.176-.002.025-.007.054-.011.086a42.186 42.186 0 0 0 3.611 3.02c.244-.007.489-.012.728-.012.803 0 1.341.044 1.44.053.012 0 .846.023 1.31.558.222.258.315.584.27.942zm-.28-14.52a.826.826 0 0 0-.499-.159H2.956c-.39 0-.706.243-.706.542v19.917c0 .299.316.541.706.541h18.088c.39 0 .706-.242.706-.541V5.564a.487.487 0 0 0-.207-.383z"
            }
        ]
    },
    "play": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.527 10.917 6.348 3.15A.874.874 0 0 0 5.872 3c-.477 0-.867.422-.867.938H5v16.125h.004c0 .515.39.937.867.937.179 0 .328-.066.49-.16l12.167-7.757A1.45 1.45 0 0 0 19 12c0-.436-.184-.82-.473-1.083Z"
            }
        ]
    },
    "play1": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m18.79 8.998-9.66-5.54a3.42 3.42 0 0 0-5.13 3v11.12a3.42 3.42 0 0 0 5.13 2.96l9.66-5.54a3.42 3.42 0 0 0 0-5.92zm-1 4.19-9.66 5.62c-.44.25-.98.25-1.42 0a1.42 1.42 0 0 1-.71-1.23V6.418c0-.507.27-.976.71-1.23a1.51 1.51 0 0 1 .71-.19c.249.005.492.07.71.19l9.66 5.58a1.42 1.42 0 0 1 0 2.46z"
            }
        ]
    },
    "plugin-tnt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 14H9a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
            },
            {
                "d": "M13 2a3 3 0 0 1 2.751 1.824L15.82 4H17a3 3 0 0 1 2.995 2.824L20 7v12a3 3 0 0 1-2.824 2.995L17 22H7a3 3 0 0 1-2.995-2.824L4 19V7a3 3 0 0 1 2.824-2.995L7 4h1.18a3 3 0 0 1 2.63-1.994L11 2h2ZM8 6H7a1 1 0 0 0-.993.883L6 7v12a1 1 0 0 0 .883.993L7 20h10a1 1 0 0 0 .993-.883L18 19V7a1 1 0 0 0-.883-.993L17 6h-1v1a1 1 0 0 1-.883.993L15 8H9a1 1 0 0 1-.993-.883L8 7V6Zm5-2h-2a1 1 0 0 0-1 1v1h4V5a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M15 10H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "plus-circle": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            },
            {
                "d": "M16 11h-3V8a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "plus-square": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9 13h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2h-2V9a1 1 0 0 0-2 0v2H9a1 1 0 0 0 0 2Z"
            },
            {
                "d": "M21 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm-1 2H4v16h16V4Z"
            }
        ]
    },
    "plus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "ppt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.2 1.5c.15 0 .295.036.415.103l.085.056 3.843 3.522a.511.511 0 0 1 .198.298l.01.085v16.395c0 .272-.262.496-.602.535l-.105.006H2.956c-.355 0-.648-.2-.698-.461l-.008-.08V2.04c0-.272.261-.497.602-.535l.104-.006H17.2ZM11.98 9H8.25v.71l.91.07.21.206v7.75l-.25.226-.816.078v.71h4.08v-.71l-.984-.078-.21-.227v-2.618c.208.014.39.025.547.032.158.007.29.01.398.01 1.142 0 2.03-.282 2.664-.847.634-.566.951-1.36.951-2.382 0-1.017-.3-1.76-.897-2.227C14.255 9.234 13.297 9 11.98 9Zm4.52-6v3.46a.29.29 0 0 0 .232.284l.057.006h3.461L16.5 3Z"
            },
            {
                "d": "M12.065 9.75h-.815v4.471c.01 0 .028.003.053.008.234.014.404.021.51.021.807 0 1.415-.195 1.824-.585.409-.391.613-.974.613-1.75 0-.7-.188-1.237-.564-1.608-.375-.371-.916-.557-1.621-.557"
            }
        ]
    },
    "presentation": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 2a1 1 0 0 1 0 2h-1v10h1a1 1 0 0 1 0 2h-8v1.17l4.55 3A1 1 0 0 1 17 22a.94.94 0 0 1-.55-.17L13 19.55V21a1 1 0 0 1-2 0v-1.45l-3.45 2.28A.94.94 0 0 1 7 22a1 1 0 0 1-.55-1.85l4.55-3V16H3a1 1 0 0 1 0-2h1V4H3a1 1 0 1 1 0-2Zm-3 2H6v10h12V4Z"
            },
            {
                "d": "M9.61 5.78a1.73 1.73 0 0 1 1.76 0l3 1.74a1.76 1.76 0 0 1 0 3l-3 1.74a1.73 1.73 0 0 1-1.76 0 1.71 1.71 0 0 1-.87-1.48V7.3a1.71 1.71 0 0 1 .87-1.52Zm1.13 1.9-.02 2.64L13 9l-2.26-1.32Z"
            }
        ]
    },
    "program": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 1.87a13.1 13.1 0 0 1 2.17.19A1 1 0 0 1 22 3v12a1 1 0 0 1-1.17 1 10.9 10.9 0 0 0-8.25 2.02l-.12.07h-.11a.91.91 0 0 1-.7 0h-.11l-.12-.07a10.9 10.9 0 0 0-8.25-1.91 1 1 0 0 1-1.17-1v-12a1 1 0 0 1 .83-1A13.1 13.1 0 0 1 5 1.92a12.94 12.94 0 0 1 7 2 12.94 12.94 0 0 1 7-2.05Zm1 2a8.69 8.69 0 0 0-1 0 10.86 10.86 0 0 0-6 1.8v9.72a12.87 12.87 0 0 1 6-1.48h1Zm-15 0a8.69 8.69 0 0 0-1 0v10h1a12.87 12.87 0 0 1 6 1.48V5.67a10.86 10.86 0 0 0-6-1.8Z"
            },
            {
                "d": "M21.17 18.06a13.1 13.1 0 0 0-2.17-.19 12.94 12.94 0 0 0-7 2.05 12.94 12.94 0 0 0-7-2.05 13.1 13.1 0 0 0-2.17.19A1 1 0 0 0 2 19.21a1 1 0 0 0 1.17.79 10.9 10.9 0 0 1 8.25 1.91 1 1 0 0 0 1.16 0A10.9 10.9 0 0 1 20.83 20a1 1 0 0 0 1.17-.79 1 1 0 0 0-.83-1.15Z"
            }
        ]
    },
    "program_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.292 18.24c.653.002 1.306.059 1.95.169a.9.9 0 0 1 .588.358c.14.192.197.431.158.665a.898.898 0 0 1-1.052.703 9.873 9.873 0 0 0-7.415 1.7.906.906 0 0 1-1.042 0 9.873 9.873 0 0 0-7.415-1.7.898.898 0 0 1-1.052-.703.883.883 0 0 1 .158-.665.9.9 0 0 1 .588-.358c.644-.11 1.297-.167 1.95-.17 2.23-.001 4.415.632 6.292 1.825a11.715 11.715 0 0 1 6.292-1.824ZM18.28 4c.654.003 1.306.06 1.95.17a.89.89 0 0 1 .746.836v10.68a.887.887 0 0 1-.315.689.905.905 0 0 1-.736.2 9.871 9.871 0 0 0-7.416 1.798l.19-.137V5.406a11.72 11.72 0 0 1 5.188-1.4Zm-12.583.045C7.543 4.032 9.36 4.455 11 5.27v12.79a9.877 9.877 0 0 0-6.948-1.386.905.905 0 0 1-.737-.2.887.887 0 0 1-.315-.69V5.103a.893.893 0 0 1 .746-.89c.644-.11 1.297-.166 1.95-.168Z"
            }
        ]
    },
    "puzzle-piece": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13.3 3.74c.448.64.693 1.4.7 2.18h3a1 1 0 0 1 1 1v3a4 4 0 0 1 2.18 7.3 3.86 3.86 0 0 1-1.92.69l-.26.01v3a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3h1a4 4 0 0 1 7.3-2.18Zm-4.71.68A2 2 0 0 0 8 5.92c.002.23.046.457.13.67a1 1 0 0 1-.95 1.33H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11v-3.18a1 1 0 0 1 1.33-.95 1.77 1.77 0 0 0 1.74-.23 2 2 0 0 0 .93-1.37 2 2 0 0 0-.48-1.59 1.89 1.89 0 0 0-2.17-.55 1 1 0 0 1-1.33-.95V7.92h-3.2a1 1 0 0 1-1-1.33 1.77 1.77 0 0 0-.23-1.74 1.94 1.94 0 0 0-3-.43Z"
            }
        ]
    },
    "question-circle": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2c2.76 0 5.262 1.12 7.07 2.93A9.97 9.97 0 0 1 22 12c0 2.76-1.12 5.262-2.93 7.07A9.97 9.97 0 0 1 12 22a9.974 9.974 0 0 1-7.07-2.93A9.97 9.97 0 0 1 2 12c0-2.76 1.12-5.262 2.93-7.07A9.97 9.97 0 0 1 12 2Zm0 2a7.97 7.97 0 0 0-5.657 2.343A7.971 7.971 0 0 0 4 12a7.97 7.97 0 0 0 2.343 5.657A7.971 7.971 0 0 0 12 20a7.97 7.97 0 0 0 5.657-2.343A7.971 7.971 0 0 0 20 12a7.97 7.97 0 0 0-2.343-5.657A7.971 7.971 0 0 0 12 4Z"
            },
            {
                "d": "M10.212 9.575a1.81 1.81 0 0 1 .929-1.037c.42-.202.915-.243 1.389-.075.416.146.745.427.955.78.166.28.258.605.26.943a.93.93 0 0 1-.107.422 1.755 1.755 0 0 1-.334.446c-.645.644-1.665.992-1.665.992a.909.909 0 1 0 .576 1.725s1.403-.46 2.375-1.432a3.56 3.56 0 0 0 .675-.918 2.76 2.76 0 0 0 .299-1.245 3.69 3.69 0 0 0-.516-1.862 3.63 3.63 0 0 0-4.693-1.415A3.626 3.626 0 0 0 8.497 8.97a.908.908 0 1 0 1.715.604ZM12 17.455a.91.91 0 1 0 0-1.82.91.91 0 0 0 0 1.82Z"
            }
        ]
    },
    "radiobutton-check-line": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m14.72 8.79-4.29 4.3-1.65-1.65a1 1 0 1 0-1.41 1.41l2.35 2.36a1 1 0 0 0 1.41 0l5-5a1 1 0 1 0-1.41-1.42Z"
            },
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            }
        ]
    },
    "radiobutton-check": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm3.074 7.338-3.788 3.885-1.36-1.402a1.11 1.11 0 0 0-1.595 0 1.172 1.172 0 0 0 0 1.632l2.157 2.207a1.11 1.11 0 0 0 1.596 0l4.585-4.69a1.172 1.172 0 0 0 0-1.632 1.11 1.11 0 0 0-1.595 0Z"
            }
        ]
    },
    "radiobutton-cross-line": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15.705 8.295a.999.999 0 0 0-1.418 0L12 10.592 9.713 8.295a1.003 1.003 0 0 0-1.418 1.418L10.592 12l-2.297 2.287a.999.999 0 0 0 0 1.418.999.999 0 0 0 1.418 0L12 13.408l2.287 2.297a.999.999 0 0 0 1.418 0 .999.999 0 0 0 0-1.418L13.408 12l2.297-2.287a.999.999 0 0 0 0-1.418Z"
            },
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            }
        ]
    },
    "radiobutton-cross": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm2.996 6a.999.999 0 0 0-.71.295L12 10.592 9.713 8.295a1.003 1.003 0 0 0-1.418 1.418L10.592 12l-2.297 2.287a.999.999 0 0 0 0 1.418.999.999 0 0 0 1.418 0L12 13.408l2.287 2.297a.999.999 0 0 0 1.418 0 .999.999 0 0 0 0-1.418L13.408 12l2.297-2.287a.999.999 0 0 0 0-1.418.999.999 0 0 0-.71-.295Z"
            }
        ]
    },
    "radiobutton-empty": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
            }
        ]
    },
    "recommended": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21.3 10.08A3 3 0 0 0 19 9h-4.56L15 7.57A4.13 4.13 0 0 0 11.11 2a1 1 0 0 0-.91.59L7.35 9H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12.73a3 3 0 0 0 2.95-2.46l1.27-7a3 3 0 0 0-.65-2.46ZM7 20H5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2v9Zm13-7.82-1.27 7a1 1 0 0 1-1 .82H9v-9.79l2.72-6.12a2.11 2.11 0 0 1 1.38 2.78l-.53 1.43a2 2 0 0 0 1.87 2.7H19a1 1 0 0 1 .77.36 1 1 0 0 1 .23.82Z"
            }
        ]
    },
    "restaurant": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16.882 11.664a3 3 0 0 0 2.16-.88l2.83-2.83a1 1 0 1 0-1.42-1.41l-2.86 2.82a1 1 0 0 1-1.42 0l3.54-3.53a1.004 1.004 0 1 0-1.42-1.42l-3.53 3.54a1 1 0 0 1 0-1.41l2.83-2.83a1.004 1.004 0 1 0-1.42-1.42l-2.83 2.83a3 3 0 0 0 0 4.24l-1.3 1.29-8.27-8.3-.1-.06a.71.71 0 0 0-.17-.11l-.18-.07-.12-.08h-.27a.57.57 0 0 0-.18 0 .7.7 0 0 0-.17.09l-.16.1h-.07l-.06.1a1 1 0 0 0-.11.17 1.07 1.07 0 0 0-.07.19v.11a11 11 0 0 0 3.11 9.34l2.64 2.63-5.41 5.4a1 1 0 0 0 .71 1.71 1 1 0 0 0 .71-.29l6.07-5.98 2.83-2.83 2-2a3 3 0 0 0 2.11.89Zm-7.65 1.82-2.63-2.64a9.06 9.06 0 0 1-2.56-5.41l6.61 6.6-1.42 1.45Zm6.24.57a1.008 1.008 0 0 0-1.43 1.42l6.3 6.3a1 1 0 0 0 .7.26 1 1 0 0 0 .71-1.71l-6.28-6.27Z"
            }
        ]
    },
    "review": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-6v2h4a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h4v-2H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm0 2H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-4.71 2.29a1.004 1.004 0 0 1 1.42 1.42l-4 4a1 1 0 0 1-1.42 0l-2-2a1.004 1.004 0 0 1 1.42-1.42l1.29 1.3z"
            }
        ]
    },
    "rol": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.988 6a4.822 4.822 0 0 1 4.558 3.228 4.781 4.781 0 0 1-1.575 5.34 8.018 8.018 0 0 1 4.497 4.456 8.998 8.998 0 0 1-1.217 1.451 6.425 6.425 0 0 0-6.247-4.874 6.426 6.426 0 0 0-6.249 4.88l-.119-.117c-.41-.41-.78-.86-1.106-1.342a8.016 8.016 0 0 1 4.475-4.455 4.781 4.781 0 0 1-1.575-5.34A4.822 4.822 0 0 1 11.988 6ZM12 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
            },
            {
                "d": "M12 1c3.037 0 5.788 1.233 7.778 3.222A10.966 10.966 0 0 1 23 12c0 3.037-1.233 5.788-3.222 7.778A10.966 10.966 0 0 1 12 23a10.972 10.972 0 0 1-7.778-3.222A10.966 10.966 0 0 1 1 12c0-3.037 1.233-5.788 3.222-7.778A10.966 10.966 0 0 1 12 1Zm0 2a8.967 8.967 0 0 0-6.364 2.636A8.967 8.967 0 0 0 3 12a8.967 8.967 0 0 0 2.636 6.364A8.967 8.967 0 0 0 12 21a8.967 8.967 0 0 0 6.364-2.636A8.967 8.967 0 0 0 21 12a8.967 8.967 0 0 0-2.636-6.364A8.967 8.967 0 0 0 12 3Z"
            }
        ]
    },
    "rules": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m22.511 6.95-5.61-5.66a1 1 0 0 0-1.41 0l-14.2 14.15a1 1 0 0 0 0 1.41l5.66 5.66a1 1 0 0 0 1.41 0l14.15-14.15a1 1 0 0 0 0-1.41zm-3.54 2.12-.71-.71a1 1 0 1 0-1.41 1.42l.71.71-1.42 1.41-2.12-2.12a1 1 0 0 0-1.41 1.41l2.12 2.12-1.42 1.42-.7-.71a1.004 1.004 0 0 0-1.42 1.42l.71.7-1.41 1.42-2.13-2.12a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41l2.12 2.12-1.41 1.42-4.25-4.25 12.73-12.73 4.25 4.25z"
            }
        ]
    },
    "satisfactionpoll": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 2a3 3 0 0 1 2.82 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.18A3 3 0 0 1 11 2h2ZM8 6H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V6Zm5-2h-2a1 1 0 0 0-1 1v1h4V5a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M14.785 14.095a1 1 0 0 1 .85 1.81c-1.315.618-2.585.933-3.807.933a6.952 6.952 0 0 1-3.543-.974 1 1 0 0 1 1.006-1.728 4.96 4.96 0 0 0 2.537.702c.91 0 1.895-.244 2.957-.743Z"
            }
        ]
    },
    "school": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.684 1.052a.99.99 0 0 1 .632 0l9 3A1 1 0 0 1 22 5v3a1 1 0 0 1-1 1h-1v7.184A2.995 2.995 0 0 1 22 19v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a2.995 2.995 0 0 1 2-2.816V9H3a1 1 0 0 1-1-1V5a1 1 0 0 1 .684-.948ZM19 18H5a1 1 0 0 0-1 1v1h16v-1a1 1 0 0 0-1-1ZM8 9H6v7h2V9Zm6 0h-4v7h4V9Zm4 0h-2v7h2V9Zm-6-5.946L4 5.72V7h16V5.72l-8-2.666Z"
            }
        ]
    },
    "scorm": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.2.75c.151 0 .295.036.415.103l.085.055 3.843 3.524c.106.08.175.185.198.297l.01.085v17.895c0 .272-.262.496-.602.535l-.104.006H2.955c-.354 0-.647-.2-.697-.461l-.008-.08V1.29c0-.271.261-.497.6-.535L2.956.75h14.246ZM17 9H7c-.553 0-1 .418-1 .933v8.634c0 .515.447.933 1 .933h10c.552 0 1-.418 1-.933V9.933C18 9.418 17.552 9 17 9Zm-.5-6.75v3.46a.29.29 0 0 0 .29.29h3.46L16.5 2.25Z"
            },
            {
                "d": "M9.75 10.875a.375.375 0 1 1 .75 0 .375.375 0 0 1-.75 0Zm-1.5 0a.375.375 0 1 1 .75 0 .375.375 0 0 1-.75 0Zm-1.5 0a.375.375 0 1 1 .75 0 .375.375 0 0 1-.75 0ZM16.642 12c.337 0 .608.254.608.571v5.608c0 .317-.27.571-.608.571H7.358c-.337 0-.608-.254-.608-.571V12.57c0-.317.27-.571.608-.571h9.284Zm-5.722 1.5a.418.418 0 0 0-.392.566c.034.086.972 2.29.972 2.29l.58-.582.582.582a.49.49 0 1 0 .694-.694l-.58-.582.58-.58s-2.196-.938-2.286-.972a.425.425 0 0 0-.15-.028Z"
            }
        ]
    },
    "search-plus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15 10h-3V7a1 1 0 0 0-2 0v3H7a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2Z"
            },
            {
                "d": "M4.615 4.615A9 9 0 0 1 18 16.61l3.71 3.68a1 1 0 0 1 0 1.39 1 1 0 0 1-1.42 0L16.61 18A9 9 0 0 1 4.615 4.615ZM11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z"
            }
        ]
    },
    "search": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M4.636 4.636a9 9 0 0 1 13.385 11.995l3.71 3.68a1 1 0 0 1 0 1.39 1 1 0 0 1-1.42 0l-3.68-3.68A9 9 0 0 1 4.636 4.636Zm6.385-.615a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z"
            }
        ]
    },
    "secuencial": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M6.15 5a.308.308 0 0 0-.314.3v.3H3.314A.308.308 0 0 0 3 5.9v3c0 .497.423.9.945.9h1.446l-.725.686a.293.293 0 0 0-.094.213c0 .08.034.157.094.213a.322.322 0 0 0 .447 0l.723-.69v.477c0 .166.14.301.314.301a.308.308 0 0 0 .315-.3v-.477l.72.69c.06.056.141.089.225.089a.322.322 0 0 0 .223-.09.293.293 0 0 0 .094-.213.293.293 0 0 0-.094-.213l-.725-.685h1.447c.522 0 .946-.404.946-.9v-3a.31.31 0 0 0-.317-.301h-2.52v-.3c0-.165-.14-.3-.314-.3zm11 0a.308.308 0 0 0-.314.3v.3h-2.522a.308.308 0 0 0-.314.3v3c0 .497.423.9.945.9h1.446l-.725.686a.293.293 0 0 0-.094.213c0 .08.034.157.094.213a.322.322 0 0 0 .447 0l.723-.69v.477c0 .166.14.301.314.301a.308.308 0 0 0 .315-.3v-.477l.72.69c.06.056.141.089.225.089a.322.322 0 0 0 .223-.09.293.293 0 0 0 .094-.213.293.293 0 0 0-.094-.213l-.725-.685h1.447c.522 0 .946-.404.946-.9v-3a.31.31 0 0 0-.317-.301h-2.52v-.3c0-.165-.14-.3-.314-.3zM3.63 6.2h5.04v2.7c0 .166-.14.3-.315.3h-4.41a.306.306 0 0 1-.314-.3V6.2zm11 0h5.04v2.7c0 .166-.14.3-.315.3h-4.41a.306.306 0 0 1-.314-.3V6.2zm-10.056.6a.306.306 0 0 0-.314.3c0 .165.14.3.314.3h.631a.308.308 0 0 0 .315-.3.306.306 0 0 0-.315-.3h-.63zm11 0a.306.306 0 0 0-.314.3c0 .165.14.3.314.3h.631a.308.308 0 0 0 .315-.3.306.306 0 0 0-.315-.3h-.63zm-11 1.2a.308.308 0 0 0-.314.3c0 .166.14.3.314.3h1.89a.306.306 0 0 0 .315-.3c0-.165-.14-.3-.314-.3h-1.89zm11 0a.308.308 0 0 0-.314.3c0 .166.14.3.314.3h1.89a.306.306 0 0 0 .315-.3c0-.165-.14-.3-.314-.3h-1.89zm-6.578 6.01a.6.6 0 0 0-.426 1.027l.38.373H3.001a.6.6 0 0 0 0 1.2h5.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176zm10 0a.6.6 0 0 0-.426 1.027l.38.373h-5.948a.6.6 0 0 0 0 1.2h5.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176z"
            }
        ]
    },
    "share": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21.757 5.596a4 4 0 0 1-6.7 4.08l-.137-.156-5.1 2.35a3.64 3.64 0 0 1 .071 2.013l-.071.247 5.1 2.35A4 4 0 0 1 18 15a4 4 0 1 1-4 4 4.17 4.17 0 0 1 .033-.475l.037-.235-5.28-2.43a4 4 0 1 1-.16-5.868l.16.148 5.28-2.43a4 4 0 0 1 7.687-2.114ZM18 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM6 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
            }
        ]
    },
    "shield": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.43 2.18a1 1 0 0 1 1.14 0 8 8 0 0 0 6.22 1.27 1 1 0 0 1 1.21.98v7.45a9 9 0 0 1-3.77 7.33l-3.65 2.6a1 1 0 0 1-1.16 0l-3.65-2.6A9 9 0 0 1 4 11.88V4.43a1 1 0 0 1 1.21-.98 8 8 0 0 0 6.22-1.27ZM12 4.19a10 10 0 0 1-6 1.39v6.3a7 7 0 0 0 2.93 5.7L12 19.77l3.07-2.19a7 7 0 0 0 2.93-5.7v-6.3a10 10 0 0 1-6-1.39Z"
            }
        ]
    },
    "shopping-basket": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M14 18a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Zm-4 0a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Z"
            },
            {
                "d": "m14.923 1.935.124.003a1 1 0 0 1 .843.612L17.62 6H19a3 3 0 0 1 .94 5.84l-.74 7.46a3 3 0 0 1-3 2.7H7.82a3 3 0 0 1-3-2.7l-.74-7.46A3 3 0 0 1 5 6h1.38l1.73-3.45a1 1 0 0 1 1.78.9L8.62 6h6.76l-1.27-2.55a1 1 0 0 1 .937-1.512ZM17.9 12H6.1l.71 7.1a1 1 0 0 0 1 .9h8.38a1 1 0 0 0 1-.9l.71-7.1ZM19 8H5a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "shopping-trolley": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.94 2a3 3 0 0 1 2.82 2H21a1 1 0 0 1 .82.38 1 1 0 0 1 .18.86l-1.65 6.49A3 3 0 0 1 17.44 14H7a1 1 0 0 0 0 2h14a1 1 0 0 1 0 2h-.18a3 3 0 1 1-5.64 0h-2.36a3 3 0 1 1-5.64 0H7a3.003 3.003 0 0 1-.27-6L5 5.24l-.06-.48a1 1 0 0 0-1-.76H3a1 1 0 1 1 0-2ZM10 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm1.72-12H7.28l1.5 6h8.63a1 1 0 0 0 1-.76L19.72 6Z"
            }
        ]
    },
    "sincro": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M5.5 3C4.292 3 3.312 4.037 3.312 5.316c0 .662.272 1.29.745 1.723C2.806 7.64 2 8.96 2 10.412a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463c0-1.535 1.175-2.78 2.625-2.78s2.625 1.245 2.625 2.78a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463C8.999 8.958 8.194 7.64 6.943 7.04a2.337 2.337 0 0 0 .745-1.723C7.688 4.037 6.707 3 5.5 3zm0 .926c.725 0 1.313.623 1.313 1.39 0 .369-.14.722-.385.983-.246.26-.58.406-.928.406-.725 0-1.313-.621-1.313-1.389 0-.767.588-1.39 1.313-1.39zM20.996 5.01a.6.6 0 0 0-.426 1.027l.38.373H10.001a.6.6 0 0 0 0 1.2h10.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176zM5.5 14c-1.208 0-2.188 1.037-2.188 2.316 0 .662.272 1.29.745 1.723C2.806 18.64 2 19.96 2 21.412a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463c0-1.535 1.175-2.78 2.625-2.78s2.625 1.245 2.625 2.78a.45.45 0 0 0 .438.463.45.45 0 0 0 .437-.463c-.001-1.454-.806-2.773-2.057-3.373a2.337 2.337 0 0 0 .745-1.723C7.688 15.037 6.707 14 5.5 14zm0 .926c.725 0 1.313.623 1.313 1.39 0 .369-.14.722-.385.983-.246.26-.58.406-.928.406-.725 0-1.313-.621-1.313-1.389 0-.767.588-1.39 1.313-1.39zm15.496 1.084a.6.6 0 0 0-.426 1.027l.38.373H10.001a.6.6 0 0 0 0 1.2h10.947l-.379.37a.6.6 0 0 0 0 .852.6.6 0 0 0 .852 0l1.396-1.396a.608.608 0 0 0 .127-.2.598.598 0 0 0 0-.455.6.6 0 0 0-.127-.197l-1.396-1.398a.6.6 0 0 0-.426-.176z"
            }
        ]
    },
    "sort-down": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m6.29 14.29-.29.3V7a1 1 0 1 0-2 0v7.59l-.29-.3a1.004 1.004 0 1 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1.004 1.004 0 1 0-1.42-1.42ZM11 8h10a1 1 0 0 0 0-2H11a1 1 0 0 0 0 2Zm10 3H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Zm0 5H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "sort-up": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M5.714 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-2 2a1.004 1.004 0 0 0 1.42 1.42l.29-.3V17a1 1 0 0 0 2 0V9.41l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-2-2ZM11.004 8h10a1 1 0 1 0 0-2h-10a1 1 0 0 0 0 2Zm10 8h-10a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2Zm0-5h-10a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2Z"
            }
        ]
    },
    "spinner": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M6.804 15a1 1 0 0 0-1.366-.366l-1.732 1a1 1 0 0 0 1 1.732l1.732-1A1 1 0 0 0 6.804 15ZM3.706 8.366l1.732 1a1 1 0 1 0 1-1.732l-1.732-1a1 1 0 0 0-1 1.732ZM6 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm11.196-3a1 1 0 0 0 1.366.366l1.732-1a1 1 0 1 0-1-1.732l-1.732 1A1 1 0 0 0 17.196 9ZM15 6.804a1 1 0 0 0 1.366-.366l1-1.732a1 1 0 1 0-1.732-1l-1 1.732A1 1 0 0 0 15 6.804Zm5.294 8.83-1.732-1a1 1 0 1 0-1 1.732l1.732 1a1 1 0 0 0 1-1.732Zm-3.928 1.928a1 1 0 1 0-1.732 1l1 1.732a1 1 0 1 0 1.732-1l-1-1.732ZM21 11h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2Zm-9 7a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1Zm-3-.804a1 1 0 0 0-1.366.366l-1 1.732a1 1 0 0 0 1.732 1l1-1.732A1 1 0 0 0 9 17.196ZM12 2a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "star-full": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M22 9.75c0 .185-.104.387-.313.605l-4.362 4.462 1.033 6.3c.008.06.012.144.012.253a.768.768 0 0 1-.126.447.418.418 0 0 1-.367.183.94.94 0 0 1-.48-.151L12 18.875l-5.397 2.974a.987.987 0 0 1-.48.151c-.169 0-.295-.06-.379-.183a.768.768 0 0 1-.126-.447c0-.05.008-.135.024-.252l1.033-6.301L2.3 10.355c-.2-.226-.3-.428-.3-.605 0-.31.224-.504.673-.58l6.034-.92 2.704-5.733C11.563 2.172 11.76 2 12 2s.437.172.589.517l2.704 5.734 6.034.92c.449.075.673.269.673.58Z"
            }
        ]
    },
    "star": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2.436a1 1 0 0 1 .9.564l2.55 5.17 5.69.83a1 1 0 0 1 .86.67 1 1 0 0 1-.32 1.02l-4.13 4 1 5.68a1 1 0 0 1-.4 1 1 1 0 0 1-.59.19.93.93 0 0 1-.46-.12L12 18.76l-5.12 2.67a1 1 0 0 1-1.45-1.07l1-5.68-4.13-4a1 1 0 0 1-.25-1A1 1 0 0 1 2.86 9l5.69-.84L11.1 3a1 1 0 0 1 .9-.564ZM12 5.7l-1.78 3.81a1 1 0 0 1-.76.55l-4.21.61 3 3a1 1 0 0 1 .29.89l-.72 4.19 3.76-2a1 1 0 0 1 .94 0l3.76 2-.72-4.19a1 1 0 0 1 .29-.89l3-2.99-4.21-.61a1 1 0 0 1-.76-.55L12 5.7Z"
            }
        ]
    },
    "stopwatch": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7.1 6.68a8 8 0 0 1 9.79 0l.9-.91a1.004 1.004 0 0 1 1.42 1.42l-.91.9A8 8 0 1 1 4 13a7.92 7.92 0 0 1 1.69-4.9l-.92-.91a1.008 1.008 0 0 1 1.42-1.43ZM12 7a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm-2-3h4a1 1 0 0 0 0-2h-4a1 1 0 1 0 0 2Z"
            },
            {
                "d": "M13 10a1 1 0 0 0-2 0v1.89a1.5 1.5 0 1 0 2 0V10Z"
            }
        ]
    },
    "store": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m19.95 2.523.05.107 2 5 .004.095L22 7.82l.007.09L22 8l-.008.223a4 4 0 0 1-1.79 3.093L20 11.44V21a1 1 0 0 1-.883.993L19 22H5a1 1 0 0 1-.993-.883L4 21v-9.6a4 4 0 0 1-1.99-3.179L2 8l.017-.063a.58.58 0 0 1 .053-.117l-.004-.095.004-.095 2-5a1 1 0 0 1 .808-.623L5 2h14a1 1 0 0 1 .95.523ZM15 10.62a4 4 0 0 1-6 0 4 4 0 0 1-2.77 1.372L6 12v8h3v-5a1 1 0 0 1 .883-.993L10 14h4a1 1 0 0 1 .993.883L15 15v5h3v-8a4 4 0 0 1-3-1.38ZM13 16h-2v4h2v-4Zm5.32-12H5.68L4 8.15A2.001 2.001 0 1 0 8 8a1 1 0 1 1 2 0 2 2 0 1 0 4 0 1 1 0 0 1 2 0 2 2 0 0 0 2 2 2 2 0 0 0 1.982-1.695L20 8.15 18.32 4Z"
            }
        ]
    },
    "strategy": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M20.5 13a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V8.41l5.88 5.89a3 3 0 0 0 2.11.87 3.08 3.08 0 0 0 2.16-.9l1.72-1.72a1.004 1.004 0 0 0-1.42-1.42l-1.75 1.75a1 1 0 0 1-1.4 0L4.91 7h5.59a1 1 0 0 0 0-2h-6a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1zm0-6a2 2 0 0 0-1.18.39l-1.75-.8 1.93-.88a2 2 0 0 0 1 .29 2 2 0 1 0-2-2l-1.9.87a2 2 0 0 0-1.1-.37 2 2 0 1 0 0 4c.322 0 .639-.082.92-.24l2.1 1A2 2 0 1 0 20.5 7z"
            }
        ]
    },
    "supervisor": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10.867 15.658a4.357 4.357 0 0 0 1.488-3.282c0-2.437-1.959-4.412-4.375-4.412s-4.375 1.975-4.375 4.412c0 1.26.543 2.458 1.488 3.282A7.062 7.062 0 0 0 .98 22.082c0 .487.392.882.875.882a.879.879 0 0 0 .875-.882c0-2.924 2.35-5.295 5.25-5.295s5.25 2.37 5.25 5.295c0 .487.392.882.875.882a.879.879 0 0 0 .875-.882 7.062 7.062 0 0 0-4.112-6.424zm-2.887-.634a2.636 2.636 0 0 1-2.625-2.647c0-1.462 1.175-2.648 2.625-2.648a2.636 2.636 0 0 1 2.625 2.647c0 .702-.277 1.375-.769 1.872a2.61 2.61 0 0 1-1.856.775zm7.909-7.018a.75.75 0 0 0 .75-.75.385.385 0 0 0 0-.075l1.395-1.395h.23l.805.805v.04a.75.75 0 0 0 1.5 0v-.04l1.82-1.835a.75.75 0 1 0-.75-.75.385.385 0 0 0 0 .075l-1.805 1.805h-.08l-.865-.88a.75.75 0 0 0-1.5 0l-1.5 1.5a.75.75 0 0 0 0 1.5zm6.75 2h-8.5v-8.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 0-1z"
            }
        ]
    },
    "support": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.112 2.624a6.971 6.971 0 0 1 5.77 0 1 1 0 0 1 .296 1.617l-3.77 3.756 1.599 1.6 3.756-3.77a.999.999 0 0 1 1.618.294 6.982 6.982 0 0 1 .173 5.355 6.98 6.98 0 0 1-3.664 3.91 6.971 6.971 0 0 1-5.114.257l-6.448 6.448a3.115 3.115 0 0 1-2.207.914 3.115 3.115 0 0 1-2.207-.914A3.115 3.115 0 0 1 1 19.884c0-.797.305-1.598.914-2.207l6.447-6.447a6.978 6.978 0 0 1 .087-4.697 6.98 6.98 0 0 1 3.664-3.909Zm3.447 1.41a4.96 4.96 0 0 0-2.623.412 4.983 4.983 0 0 0-2.617 2.792 4.982 4.982 0 0 0 .123 3.825c.166.373.097.818-.204 1.12l-6.91 6.91a1.114 1.114 0 0 0-.328.792c0 .29.109.574.328.793.219.22.504.328.793.328.289 0 .574-.109.793-.328l6.91-6.91a1.003 1.003 0 0 1 1.118-.205 4.976 4.976 0 0 0 4.124.001 5.007 5.007 0 0 0 2.908-5.118L17.4 11.02a2 2 0 0 1-2.807-.008l-1.607-1.608a2 2 0 0 1 .001-2.8Z"
            }
        ]
    },
    "swatchbook": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7.5 15.6a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8Z"
            },
            {
                "d": "M9.3 3A2.7 2.7 0 0 1 12 5.646l1.098-1.107a2.7 2.7 0 0 1 3.816 0l2.547 2.538a2.7 2.7 0 0 1 0 3.816L18.354 12A2.7 2.7 0 0 1 21 14.7v3.6a2.7 2.7 0 0 1-2.7 2.7H5.7A2.7 2.7 0 0 1 3 18.3V5.7A2.7 2.7 0 0 1 5.7 3Zm0 1.8H5.7a.9.9 0 0 0-.9.9v12.6a.9.9 0 0 0 .9.9h3.6a.9.9 0 0 0 .9-.9V5.7a.9.9 0 0 0-.9-.9Zm9 9h-1.737l-4.572 4.572c-.01.282-.06.561-.153.828H18.3a.9.9 0 0 0 .9-.9v-3.6a.9.9 0 0 0-.9-.9Zm-2.655-7.992a.9.9 0 0 0-1.269 0L12 8.184v7.632l3.6-3.555 2.592-2.592a.9.9 0 0 0 0-1.269Z"
            }
        ]
    },
    "sync-exclamation": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.29 15.71A1 1 0 0 0 13 15a1.05 1.05 0 0 0-.29-.71 1 1 0 0 0-1.09-.21 1 1 0 0 0-.33.21A1.05 1.05 0 0 0 11 15a1 1 0 0 0 .29.71Z"
            },
            {
                "d": "M19.91 15.51h-4.53a1 1 0 0 0 0 2h2.4A8 8 0 0 1 4 12a1 1 0 0 0-2 0 10 10 0 0 0 16.88 7.23V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-.97-.99ZM12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 1 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 1 0 0-2h-2.4A8 8 0 0 1 20 12a1 1 0 0 0 2 0A10 10 0 0 0 12 2Z"
            },
            {
                "d": "M12 13a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1Z"
            }
        ]
    },
    "sync": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19.91 15.51h-4.53a1 1 0 0 0 0 2h2.4A8 8 0 0 1 4 12a1 1 0 0 0-2 0 10 10 0 0 0 16.88 7.23V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-.97-.99ZM12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 1 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 1 0 0-2h-2.4A8 8 0 0 1 20 12a1 1 0 0 0 2 0A10 10 0 0 0 12 2Z"
            }
        ]
    },
    "tablet": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm0 2H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
            },
            {
                "d": "M12.71 16.29a1 1 0 0 0-.91-.29l-.18.06a.76.76 0 0 0-.18.09l-.15.12a1 1 0 0 0-.21.33 1 1 0 0 0 .21 1.09c.1.088.21.162.33.22A1 1 0 0 0 13 17a.84.84 0 0 0-.08-.38 1.15 1.15 0 0 0-.21-.33Z"
            }
        ]
    },
    "tag": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm14.71 5.78-9.48-9.46A1 1 0 0 0 11.5 2h-6a1 1 0 0 0-.71.29l-2.5 2.49a1 1 0 0 0-.29.71v6c0 .26.1.52.29.71l9.49 9.5c.2.18.45.29.71.29a1 1 0 0 0 .71-.29l8.51-8.51a1 1 0 0 0 0-1.41Zm-9.22 7.81L4 11.09V5.9L5.9 4h5.18l8.5 8.49-7.09 7.1Z"
            }
        ]
    },
    "teacher": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.99 2a3.86 3.86 0 0 1 3.86 3.86 3.81 3.81 0 0 1-1 2.57 5.91 5.91 0 0 1 1.91 1.65c.41-.08.82-.08 1.24-.08a11.9 11.9 0 0 1 2.18.19 1 1 0 0 1 .82.98v8.25a1 1 0 0 1-.36.77 1 1 0 0 1-.82.22 9.75 9.75 0 0 0-1.82-.18 9.89 9.89 0 0 0-5.52 1.67l-.13.05h-.07A.87.87 0 0 1 12 22a1.09 1.09 0 0 1-.42-.09l-.13-.05-.306-.194A9.89 9.89 0 0 0 6 20.23a9.75 9.75 0 0 0-1.82.22 1 1 0 0 1-.82-.22 1 1 0 0 1-.36-.77v-8.25a1 1 0 0 1 .82-1A11.9 11.9 0 0 1 6 10c.42 0 .83 0 1.22.07a6.11 6.11 0 0 1 1.91-1.64 3.81 3.81 0 0 1-1-2.57A3.86 3.86 0 0 1 11.99 2ZM7.52 12.05A9.63 9.63 0 0 0 5 12v6.28c.34-.05.67-.05 1-.05 1.727 0 3.433.376 5 1.1v-6a10 10 0 0 0-3.37-1.28ZM19 12a9.39 9.39 0 0 0-2.43.06h-.2A9.76 9.76 0 0 0 13 13.28v6a11.6 11.6 0 0 1 6-1Zm-7-2.31-.24.01a4 4 0 0 0-2.2.86c.34.1.67.23 1 .36h.06c.475.196.936.423 1.38.68a12.43 12.43 0 0 1 2.44-1.06A4 4 0 0 0 12 9.69ZM12 4a1.86 1.86 0 0 0 0 3.71l.152-.017A1.86 1.86 0 0 0 12 4Z"
            }
        ]
    },
    "teacher_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.99 2a3.86 3.86 0 0 1 3.86 3.86 3.81 3.81 0 0 1-1 2.57 5.91 5.91 0 0 1 1.91 1.65c.41-.08.82-.08 1.24-.08a11.9 11.9 0 0 1 2.18.19 1 1 0 0 1 .82.98v8.25a1 1 0 0 1-.36.77 1 1 0 0 1-.82.22 9.75 9.75 0 0 0-1.82-.18 9.89 9.89 0 0 0-5.52 1.67l-.13.05h-.07A.87.87 0 0 1 12 22a1.09 1.09 0 0 1-.42-.09l-.13-.05-.306-.194A9.89 9.89 0 0 0 6 20.23a9.75 9.75 0 0 0-1.82.22 1 1 0 0 1-.82-.22 1 1 0 0 1-.36-.77v-8.25a1 1 0 0 1 .82-1A11.9 11.9 0 0 1 6 10c.42 0 .83 0 1.22.07a6.11 6.11 0 0 1 1.91-1.64 3.81 3.81 0 0 1-1-2.57A3.86 3.86 0 0 1 11.99 2ZM12 9.69l-.24.01a4 4 0 0 0-2.2.86c.34.1.67.23 1 .36h.06c.475.196.936.423 1.38.68a12.43 12.43 0 0 1 2.44-1.06A4 4 0 0 0 12 9.69ZM12 4a1.86 1.86 0 0 0 0 3.71l.152-.017A1.86 1.86 0 0 0 12 4Z"
            }
        ]
    },
    "text-format": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M14 9h8l-4 4z"
            },
            {
                "d": "M2 16.375v1.75h12v-1.75zM8.686 5l4.028 9.625h-1.8l-.771-1.925H5.857l-.771 1.925h-1.8L7.4 5h1.286ZM8 6.75l-1.543 4.375H9.63L8 6.75Z"
            }
        ]
    },
    "text-list": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M3.71 16.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21 1 1 0 0 0-.21.33 1 1 0 0 0 .21 1.09c.097.088.209.16.33.21a.94.94 0 0 0 .76 0 1.15 1.15 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1 1 0 0 0-.21-.33ZM7 8h14a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2Zm-3.29 3.29a1 1 0 0 0-1.09-.21 1.15 1.15 0 0 0-.33.21 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76c.05.121.122.233.21.33.097.088.209.16.33.21a.94.94 0 0 0 .76 0 1.15 1.15 0 0 0 .33-.21 1.15 1.15 0 0 0 .21-.33.94.94 0 0 0 0-.76 1 1 0 0 0-.21-.33ZM21 11H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2ZM3.71 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1.15 1.15 0 0 0-.21.33.94.94 0 0 0 0 .76c.05.121.122.233.21.33.097.088.209.16.33.21a1 1 0 0 0 1.09-.21 1.15 1.15 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.15 1.15 0 0 0-.21-.33ZM21 16H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "text-size": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9 11H3a1 1 0 0 0 0 2h2v5a1 1 0 0 0 2 0v-5h2a1 1 0 0 0 0-2Zm12-6H9a1 1 0 1 0 0 2h5v11a1 1 0 0 0 2 0V7h5a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "text-strike-through": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15 13H9a1 1 0 0 0 0 2h2v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2Zm2-7H7a1 1 0 1 0 0 2h4v2a1 1 0 0 0 2 0V8h4a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "tnt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M16.028 10.028h-2v-2a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1Zm-6 1v1h-1v-3h3v1h-1a1 1 0 0 0-1 1Zm5 4h-3v-3h3v3Zm6 3.28V5.748a2 2 0 1 0-2.72-2.72H5.748a2 2 0 1 0-2.72 2.72v12.56a2 2 0 1 0 2.72 2.72h12.56a2 2 0 1 0 2.72-2.72Zm-2 0c-.3.17-.55.42-.72.72H5.748c-.17-.3-.42-.55-.72-.72V5.748c.3-.17.55-.42.72-.72h12.56c.17.3.42.55.72.72v12.56Z"
            }
        ]
    },
    "training-2": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11 2a3 3 0 0 0-2.82 2H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3h-1.18A3 3 0 0 0 13 2h-2zm0 2h2a1 1 0 0 1 1 1v1h-4V5a1 1 0 0 1 1-1zM7 6h1v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm4.996 3c-.947 0-1.717.777-1.717 1.736 0 .428.16.84.446 1.157-.33.183-.62.435-.85.738-.173-.032-.354-.031-.541-.031-.325 0-.65.034-.969.095a.449.449 0 0 0-.365.45v3.712a.451.451 0 0 0 .525.446 4.28 4.28 0 0 1 .809-.1 4.356 4.356 0 0 1 2.422.735l.056.021c.06.026.124.04.188.041a.386.386 0 0 0 .125-.023h.031l.057-.022a4.281 4.281 0 0 1 3.262-.67.45.45 0 0 0 .525-.445v-3.713a.45.45 0 0 0-.365-.441 5.224 5.224 0 0 0-.969-.086c-.187 0-.369 0-.55.037a2.637 2.637 0 0 0-.848-.744c.285-.316.443-.729.443-1.157 0-.959-.767-1.736-1.715-1.736zm.004.9a.832.832 0 0 1 .766.834.834.834 0 0 1-.766.836.834.834 0 0 1-.766-.836c0-.438.334-.801.766-.834zm0 2.56c.393.003.774.138 1.084.384-.377.119-.74.278-1.084.476a5.208 5.208 0 0 0-.613-.306h-.028a4.992 4.992 0 0 0-.443-.162c.309-.25.69-.386 1.084-.391zm-2.55 1.015c.186.003.374.02.56.048h.049a4.4 4.4 0 0 1 1.496.575v2.7a5.237 5.237 0 0 0-2.221-.495c-.147 0-.294 0-.445.023V13.5a4.03 4.03 0 0 1 .56-.025zm5.12.004c.18-.005.362.002.541.021v2.826a5.096 5.096 0 0 0-2.666.45v-2.7a4.295 4.295 0 0 1 1.496-.549h.09c.179-.028.359-.044.54-.048z"
            }
        ]
    },
    "training": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M15 10H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm-2 4H9a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
            },
            {
                "d": "M13 2a3 3 0 0 1 2.82 2H17a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1.18A3 3 0 0 1 11 2h2ZM8 6H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V6Zm5-2h-2a1 1 0 0 0-1 1v1h4V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "trash": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M13 2a3 3 0 0 1 3 3v1h4a1 1 0 0 1 0 2h-1v11a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V8H4a1 1 0 1 1 0-2h4V5a3 3 0 0 1 3-3Zm4 6H7v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8Zm-7 2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1Zm4 0a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1Zm-1-6h-2a1 1 0 0 0-1 1v1h4V5a1 1 0 0 0-1-1Z"
            }
        ]
    },
    "trophy": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v3a4 4 0 0 1-4 4h-1.54A6 6 0 0 1 13 13.91V16h1a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-2a3 3 0 0 1 3-3h1v-2.09A6 6 0 0 1 7.54 12H6a4 4 0 0 1-4-4V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1Zm-3 16h-4a1 1 0 0 0-1 1v1h6v-1a1 1 0 0 0-1-1Zm2-14H8v4a4 4 0 1 0 8 0V4ZM6 6H4v2a2 2 0 0 0 2 2h.35A6 6 0 0 1 6 8V6Zm14 0h-2v2a6 6 0 0 1-.35 2H18a2 2 0 0 0 2-2V6Z"
            }
        ]
    },
    "true": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8.42 12.21a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l1.5-1.5a1 1 0 0 0 0-1.42l-1.5-1.5a1.004 1.004 0 1 0-1.42 1.42l.79.79-.79.79a1 1 0 0 0 0 1.42Zm5.94 2a3.76 3.76 0 0 1-4.72 0 1.001 1.001 0 1 0-1.28 1.54 5.68 5.68 0 0 0 7.28 0 1.001 1.001 0 0 0-1.28-1.54ZM15 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3-7C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z"
            }
        ]
    },
    "underline": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 15.5a5 5 0 0 0 5-5v-5a1 1 0 0 0-2 0v5a3 3 0 0 1-6 0v-5a1 1 0 1 0-2 0v5a5 5 0 0 0 5 5Zm5 2H7a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z"
            }
        ]
    },
    "unequal": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.027 1.102c-.865-.042-1.785.345-2.455 1.203L2.69 18.79c-1.072 1.372-1.045 3.185.06 4.049 1.106.864 2.872.452 3.944-.92L19.578 5.434c1.072-1.373.989-2.94-.117-3.803a2.519 2.519 0 0 0-1.434-.53zM4.32 5.5C2.762 5.5 1.5 6.638 1.5 8.041l.006.16c.092 1.329 1.316 2.381 2.814 2.381h3.703l3.97-5.082H4.32zm16.213.12-3.88 4.962h3.026c1.558 0 2.82-1.138 2.82-2.541 0-1.135-.825-2.096-1.966-2.422zM4.32 13.417c-1.558 0-2.82 1.138-2.82 2.54 0 .728.338 1.383.88 1.847l3.428-4.387H4.32zm10.117 0-3.97 5.082h9.212c1.558 0 2.82-1.138 2.82-2.541 0-1.404-1.262-2.541-2.82-2.541h-5.242z"
            }
        ]
    },
    "unevaluated": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm-5.417 9c-.322 0-.583.285-.583.636.006 2.54 1.395 4.833 3.532 5.833 2.138 1 4.615.516 6.303-1.232v1.127c0 .351.26.636.582.636.322 0 .583-.285.583-.636V14.5c-.003-.342-.252-.62-.565-.63h-2.64c-.321 0-.582.285-.582.636 0 .352.26.637.583.637h1.398c-1.315 1.5-3.333 1.978-5.098 1.207-1.766-.771-2.926-2.637-2.93-4.714 0-.351-.262-.636-.583-.636Zm5.59-5c-1.493.005-2.928.636-4.008 1.763V6.636c0-.351-.26-.636-.582-.636C7.26 6 7 6.285 7 6.636V9.5c0 .351.26.636.583.636h2.621c.322 0 .583-.285.583-.636 0-.351-.26-.636-.583-.636H8.806c1.314-1.5 3.33-1.978 5.096-1.209 1.765.77 2.925 2.633 2.933 4.709 0 .351.26.636.582.636.322 0 .583-.285.583-.636 0-1.688-.614-3.307-1.706-4.5C15.2 6.67 13.719 6 12.174 6Z"
            }
        ]
    },
    "unrealized": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
            }
        ]
    },
    "unselect": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M7 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8.94a1.307 1.307 0 0 0-.06-.27v-.09a1.064 1.064 0 0 0-.19-.28l-6-6a1.071 1.071 0 0 0-.28-.19.319.319 0 0 0-.09 0 .88.88 0 0 0-.33-.11H7zm0 2h5v3a3 3 0 0 0 3 3h3v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm7 1.41L16.59 8H15a1 1 0 0 1-1-1V5.41zm-4.143 6.07a.86.86 0 0 0-.609 1.468l1.543 1.535-1.543 1.536a.855.855 0 0 0 0 1.216.86.86 0 0 0 1.217 0L12 15.691l1.535 1.543a.855.855 0 0 0 1.217 0 .86.86 0 0 0 0-1.216l-1.543-1.536 1.543-1.535a.862.862 0 0 0-.385-1.44.862.862 0 0 0-.832.223L12 13.273l-1.535-1.543a.855.855 0 0 0-.608-.251z"
            }
        ]
    },
    "update": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 2a10 10 0 0 1 6.88 2.77V3a1 1 0 1 1 2 0v4.5a1 1 0 0 1-1 1h-4.5a1 1 0 1 1 0-2h2.4A8 8 0 1 0 20 12a1 1 0 1 1 2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Z"
            }
        ]
    },
    "user-check": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10 4a5 5 0 0 1 5 5 4.92 4.92 0 0 1-1.7 3.72A8 8 0 0 1 18 20a1 1 0 0 1-2 0 6 6 0 1 0-12 0 1 1 0 0 1-2 0 8 8 0 0 1 4.7-7.28A4.92 4.92 0 0 1 5 9a5 5 0 0 1 5-5Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
            },
            {
                "d": "M21.71 9.63a1 1 0 0 0-1.42 0l-2 2-.62-.63a1 1 0 1 0-1.42 1.41l1.34 1.34a1 1 0 0 0 1.41 0l2.67-2.67a1 1 0 0 0 .04-1.45Z"
            }
        ]
    },
    "user-minus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M19 7h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Zm-7.7 1.72A4.92 4.92 0 0 0 13 5 5 5 0 0 0 3 5a4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 0 16a1 1 0 0 0 2 0 6 6 0 0 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28ZM8 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
            }
        ]
    },
    "user-plus": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 10.5h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Z"
            },
            {
                "d": "M10 3.5a5 5 0 0 1 5 5 4.92 4.92 0 0 1-1.7 3.72A8 8 0 0 1 18 19.5a1 1 0 0 1-2 0 6 6 0 1 0-12 0 1 1 0 0 1-2 0 8 8 0 0 1 4.7-7.28A4.92 4.92 0 0 1 5 8.5a5 5 0 0 1 5-5Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
            }
        ]
    },
    "user": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.936 2a6 6 0 0 1 3.71 10.715 10 10 0 0 1 6.25 8.19 1 1 0 0 1-.88 1.1h-.11a1 1 0 0 1-1-.89 8 8 0 0 0-15.9 0 1.006 1.006 0 1 1-2-.22 10 10 0 0 1 6.22-8.18A6 6 0 0 1 11.936 2Zm0 2.005a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
            }
        ]
    },
    "users-alt": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M9 3.5a5 5 0 0 1 5 5 4.92 4.92 0 0 1-1.7 3.72A8 8 0 0 1 17 19.5a1 1 0 0 1-2 0 6 6 0 1 0-12 0 1 1 0 0 1-2 0 8 8 0 0 1 4.7-7.28A4.92 4.92 0 0 1 4 8.5a5 5 0 0 1 5-5Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm9.74 6.32A5 5 0 0 0 15 3.5a1 1 0 0 0 0 2 3 3 0 0 1 3 3 3 3 0 0 1-1.5 2.59 1 1 0 0 0-.05 1.7l.39.26.13.07a7 7 0 0 1 4 6.38 1 1 0 1 0 2 0 9 9 0 0 0-4.23-7.68Z"
            }
        ]
    },
    "users_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M8.4 12.2c3.535 0 6.4 2.809 6.4 6.274 0 .577-.3 1.006-1.3.992-.424-.006-2.166-.01-4.098-.011H8.367l-.346-.001H3.378l-.082.001C2.38 19.46 2 19.051 2 18.474 2 15.009 4.865 12.2 8.4 12.2Zm8.8-.698c2.651 0 4.8 2.175 4.8 4.857 0 .447-.225.78-.975.768-.206-.002-.825-.005-1.63-.006l-.416-.001h-.218l-.619-.001h-.319l-.972-.001h-.469l.018-.001a4.864 4.864 0 0 0-2.542-4.245 4.759 4.759 0 0 1 3.342-1.37ZM8.4 5c1.767 0 3.2 1.472 3.2 3.287 0 .871-.337 1.707-.937 2.324a3.16 3.16 0 0 1-2.263.963c-1.767 0-3.2-1.472-3.2-3.287S6.633 5 8.4 5Zm8.8.928c1.325 0 2.4 1.139 2.4 2.544 0 .675-.253 1.322-.703 1.8-.45.477-1.06.745-1.697.745-1.325 0-2.4-1.14-2.4-2.545s1.075-2.544 2.4-2.544Z"
            }
        ]
    },
    "video-doc": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.2 1.5c.188 0 .368.057.5.159l3.843 3.522a.487.487 0 0 1 .207.383v16.395c0 .299-.316.541-.706.541H2.956c-.39 0-.706-.242-.706-.541V2.04c0-.299.316-.541.706-.541Zm-2.666 9H7.77c-.15 0-.27.123-.27.275v5.449c0 .152.12.276.27.276h6.764c.15 0 .27-.124.27-.276V14.17l2.335 2.045a.07.07 0 0 0 .043.017c.01 0 .02-.002.028-.007a.07.07 0 0 0 .04-.063v-5.328a.068.068 0 0 0-.04-.061.065.065 0 0 0-.071.01l-2.335 2.045v-2.054a.273.273 0 0 0-.27-.275ZM16.5 3v3.46a.29.29 0 0 0 .29.29h3.46L16.5 3Z"
            }
        ]
    },
    "vimeo": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.4 4H5.6C5.17565 4 4.76869 4.16857 4.46863 4.46863C4.16857 4.76869 4 5.17565 4 5.6V18.4C4 18.8243 4.16857 19.2313 4.46863 19.5314C4.76869 19.8314 5.17565 20 5.6 20H18.4C18.8243 20 19.2313 19.8314 19.5314 19.5314C19.8314 19.2313 20 18.8243 20 18.4V5.6C20 5.17565 19.8314 4.76869 19.5314 4.46863C19.2313 4.16857 18.8243 4 18.4 4ZM17.46 9.31C17.4067 10.4367 16.6233 11.98 15.11 13.94C13.54 15.94 12.2 17 11.11 17C10.43 17 9.87 16.38 9.4 15.13C8.49 11.8 8.1 9.85 7.4 9.85C7.07126 9.98326 6.76448 10.1653 6.49 10.39L5.95 9.69C7.28 8.52 8.55 7.22 9.35 7.15C10.15 7.08 10.76 7.68 11 9C11.74 13.69 12.07 14.4 13.41 12.27C13.7879 11.7504 14.0535 11.1578 14.19 10.53C14.32 9.34 13.27 9.42 12.55 9.73C13.1033 7.86333 14.18 6.95333 15.78 7C16.9667 7.04 17.5267 7.81 17.46 9.31Z"
            }
        ]
    },
    "volume-mute": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12.43 4.082a1 1 0 0 0-1 .12l-4.78 3.78H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.65l4.73 3.78a1 1 0 0 0 .62.22.912.912 0 0 0 .43-.1 1 1 0 0 0 .57-.9v-14a1 1 0 0 0-.57-.9ZM11 16.902l-3.38-2.7a1 1 0 0 0-.62-.22H4v-4h3a1 1 0 0 0 .62-.22l3.38-2.7v9.84Zm8.91-4.92 1.8-1.79a1.004 1.004 0 1 0-1.42-1.42l-1.79 1.8-1.79-1.8a1.004 1.004 0 0 0-1.42 1.42l1.8 1.79-1.8 1.79a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l1.79-1.8 1.79 1.8a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-1.8-1.79Z"
            }
        ]
    },
    "volume": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M11.43 4.22a1 1 0 0 1 1-.12A1 1 0 0 1 13 5v14a1 1 0 0 1-.57.9.912.912 0 0 1-.43.1 1 1 0 0 1-.62-.22L6.65 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.65ZM11 7.08l-3.38 2.7A1 1 0 0 1 7 10H4v4h3a1 1 0 0 1 .62.22l3.38 2.7V7.08Zm8.66-.74a1.004 1.004 0 0 0-1.42 1.42 6 6 0 0 1-.38 8.84 1 1 0 0 0 .64 1.76 1 1 0 0 0 .64-.23 8 8 0 0 0 .52-11.79Z"
            },
            {
                "d": "M16.83 9.17a1.004 1.004 0 1 0-1.42 1.42A2 2 0 0 1 16 12a2 2 0 0 1-.71 1.53 1 1 0 0 0-.13 1.41 1 1 0 0 0 1.41.12A4 4 0 0 0 18 12a4.06 4.06 0 0 0-1.17-2.83Z"
            }
        ]
    },
    "watcher_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M4.725 9.9a3.452 3.452 0 0 0 6.9.207 1.15 1.15 0 0 1 1.15 0 3.452 3.452 0 1 0 6.9-.207h1.426c.193.752.294 1.524.299 2.3a9.2 9.2 0 1 1-18.4 0 9.476 9.476 0 0 1 .299-2.3h1.426Zm10.189 4.864a4.324 4.324 0 0 1-5.428 0 1.151 1.151 0 1 0-1.472 1.771 6.532 6.532 0 0 0 8.372 0 1.151 1.151 0 0 0-1.472-1.77Zm1.311-6.014a1.15 1.15 0 1 1 0 2.3 1.15 1.15 0 0 1 0-2.3Zm-8.05 0a1.15 1.15 0 1 1 0 2.3 1.15 1.15 0 0 1 0-2.3ZM12.2 3a9.2 9.2 0 0 1 7.958 4.6h-1.38a3.45 3.45 0 0 0-5.313.253A3.645 3.645 0 0 0 12.2 7.6a3.645 3.645 0 0 0-1.265.253A3.45 3.45 0 0 0 5.622 7.6h-1.38A9.2 9.2 0 0 1 12.2 3Z"
            }
        ]
    },
    "web-grid": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M21 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm-7 11H4v7h10v-7Zm6-9h-4v16h4V4Zm-6 0H4v7h10V4Z"
            }
        ]
    },
    "webcam": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M12 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
            },
            {
                "d": "M17.105 3.858A8 8 0 0 1 19 13.89a10 10 0 0 1 2.59 4.27 3 3 0 0 1-2.687 3.834L18.7 22H5.3a3 3 0 0 1-2.9-3.84A9.9 9.9 0 0 1 5 13.89 8 8 0 0 1 17.105 3.858ZM17.79 15.5a8 8 0 0 1-11.58 0 7.85 7.85 0 0 0-1.88 3.22A1 1 0 0 0 5.3 20h13.4a1 1 0 0 0 .97-1.28 7.85 7.85 0 0 0-1.88-3.22ZM12 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z"
            }
        ]
    },
    "webcam_hover": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M18.252 16.18a8.868 8.868 0 0 1 2.123 3.638c.1.336.037.699-.169.982a1.13 1.13 0 0 1-.926.464H4.142a1.13 1.13 0 0 1-.927-.464 1.13 1.13 0 0 1-.169-.982A8.868 8.868 0 0 1 5.17 16.18a9.038 9.038 0 0 0 13.082 0ZM11.71 2a7.556 7.556 0 1 1 0 15.113A7.556 7.556 0 0 1 11.71 2Zm0 3.778a3.778 3.778 0 1 0 0 7.556 3.778 3.778 0 0 0 0-7.556Zm0 1.778a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
            }
        ]
    },
    "window": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M10.182 5.636a.91.91 0 1 0 0 1.819.91.91 0 0 0 0-1.819Zm-3.637 0a.91.91 0 1 0 0 1.819.91.91 0 0 0 0-1.819Zm7.273 0a.91.91 0 1 0 0 1.819.91.91 0 0 0 0-1.819Z"
            },
            {
                "d": "M19.273 2A2.727 2.727 0 0 1 22 4.727v14.546A2.727 2.727 0 0 1 19.273 22H4.727A2.727 2.727 0 0 1 2 19.273V4.727A2.727 2.727 0 0 1 4.727 2Zm.909 9.09H3.818v8.183a.91.91 0 0 0 .91.909h14.545a.91.91 0 0 0 .909-.91v-8.181Zm-.91-7.272H4.728a.91.91 0 0 0-.909.91v4.545h16.364V4.727a.91.91 0 0 0-.91-.909Z"
            }
        ]
    },
    "word": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.55 1.5c.174 0 .34.057.462.159l3.547 3.522a.5.5 0 0 1 .191.383v16.395c0 .299-.291.541-.652.541H2.902c-.36 0-.652-.242-.652-.541V2.04c0-.299.292-.541.652-.541ZM8.63 9.2H7.258a.107.107 0 0 0-.104.109v1.142c0 .06.047.109.104.109h.418l1.75 6.958a.106.106 0 0 0 .1.082h1.064a.107.107 0 0 0 .1-.081L12 12.383l1.31 5.136a.106.106 0 0 0 .1.081h1.063a.105.105 0 0 0 .1-.082l1.751-6.958h.418c.057 0 .104-.05.104-.11V9.31a.107.107 0 0 0-.104-.109h-1.37a.106.106 0 0 0-.101.082l-1.337 5.364-1.337-5.321a.105.105 0 0 0-.1-.082h-.993a.104.104 0 0 0-.1.082l-1.338 5.32-1.337-5.363a.106.106 0 0 0-.1-.082Zm8.275-6.3v3.23a.267.267 0 0 0 .267.27h3.195l-3.462-3.5Z"
            }
        ]
    },
    "xls": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "M17.201 1.5c.15 0 .295.037.414.103l.085.056 3.843 3.522a.511.511 0 0 1 .198.298l.01.085v16.395c0 .272-.262.497-.602.535l-.105.006H2.956c-.355 0-.648-.2-.698-.461l-.008-.08V2.04c0-.272.261-.496.602-.535l.104-.006h14.245Zm-5.953 8.25h-3.72c-.274 0-.493.207-.493.464v.177c0 .257.22.465.492.465h1.136l2.524 3.453-2.809 3.321H7.242c-.271 0-.492.209-.492.465v.177c0 .256.22.464.492.464h3.723c.272 0 .493-.208.493-.464v-.177c0-.256-.221-.465-.493-.465H9.661l2.107-2.472 1.757 2.487h-.49c-.272 0-.492.207-.492.464v.177c0 .257.22.464.493.464h3.722c.272 0 .492-.207.492-.464v-.177c0-.257-.22-.464-.492-.464h-1.096l-2.75-3.844 1.686-2.034.746-.897h1.414a.478.478 0 0 0 .492-.465v-.177a.479.479 0 0 0-.492-.464h-3.722a.48.48 0 0 0-.493.464v.177c0 .256.22.465.493.465h.972l-1.722 2.077-1.55-2.092h.518c.271 0 .492-.207.492-.464a.396.396 0 0 0-.006-.066v-.113c-.001-.255-.221-.462-.492-.462ZM16.5 3v3.46a.29.29 0 0 0 .232.284l.057.006h3.461L16.5 3Z"
            }
        ]
    },
    "youtube": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "style": "fill-rule: evenodd;",
                "d": "M22.54 6.42a2.765 2.765 0 0 0-1.945-1.957C18.88 4 12 4 12 4s-6.88 0-8.595.463A2.765 2.765 0 0 0 1.46 6.42C1 8.148 1 11.75 1 11.75s0 3.602.46 5.33a2.765 2.765 0 0 0 1.945 1.958C5.121 19.5 12 19.5 12 19.5s6.88 0 8.595-.462a2.765 2.765 0 0 0 1.945-1.958c.46-1.726.46-5.33.46-5.33s0-3.602-.46-5.33ZM9.75 8.479v6.542l5.75-3.271-5.75-3.271Z"
            }
        ]
    },
    "zip": {
        "width": 24,
        "height": 24,
        "paths": [
            {
                "d": "m12.002 2-.004.667h.694v.667h.693V2H16.8a.74.74 0 0 1 .46.151l3.548 3.355A.466.466 0 0 1 21 5.87v15.613c0 .285-.29.516-.651.516H3.65c-.36 0-.651-.231-.651-.516V2.516C3 2.231 3.29 2 3.651 2h8.35Zm-.003 8.667c-.764 0-1.384.873-1.384 3.178 0 .894.62 1.488 1.384 1.488.766 0 1.385-.593 1.385-1.488 0-2.305-.618-3.178-1.385-3.178ZM13.383 8h-.692v.667h-.693v.667-.002h.693V10h.692V8Zm-2.075-2h-.693v2.668h.693V8H12V6.668h-.693V6Zm4.845-2.665V6.41c0 .069.03.134.08.183.05.048.118.075.188.075h3.194l-3.462-3.333Zm-2.77 1.332h-.69v.666h-.695V6h.694v.667h.692v-2Zm-2.075-1.999h-.693v2.667h.693v-.667H12V3.335h-.693v-.667Z"
            }
        ]
    }
}
